/* eslint-disable */
/*
 * 自动生成，请勿手改。来源：tools/map-pipeline（map.config.json）。
 * 地图：World Map (draft)（key=worldmap, mapID=24）
 */
import Country from "../../enums/Country";
import WDBoardMap from "../../components/map/components/WDBoardMap";
import capturableLandTexture from "../../assets/textures/capturable-land.jpeg";
import seaTexture from "../../assets/textures/sea-texture.png";
import type { MapVariant } from "./types";

const provincesMapData = {
  "CPO": {
    "abbr": "CEN",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 51.5,
        "y": 117.5,
        "text": "Central Pacific Ocean"
      }
    ],
    "width": 103,
    "height": 235,
    "x": 496,
    "y": 113,
    "playable": true,
    "path": "M 103.00 0.00 L 63.00 10.00 L 17.00 16.00 L 18.00 20.00 L 25.00 21.00 L 18.00 25.00 L 18.00 29.00 L 36.00 40.00 L 44.00 53.00 L 48.00 130.00 L 32.00 188.00 L 18.00 207.00 L 0.00 221.00 L 5.00 235.00 L 56.00 232.00 L 103.00 223.00 Z",
    "province": "CPO",
    "rootTerritory": "CPO",
    "viewBox": "0 0 103 235",
    "unitSlots": [
      {
        "name": "main",
        "x": 67.98,
        "y": 123.25,
        "territory": "CPO",
        "arrowReceiver": {
          "x": 85.98,
          "y": 141.25
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 67.98,
        "y": 123.25,
        "territory": "CPO",
        "arrowReceiver": {
          "x": 85.98,
          "y": 141.25
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "MAD": {
    "abbr": "MAD",
    "type": "Coast",
    "centerPos": {
      "x": 54.07,
      "y": 99.19
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 60.5,
        "y": 83,
        "text": "Madras"
      }
    ],
    "width": 121,
    "height": 166,
    "x": 172,
    "y": 333,
    "playable": true,
    "path": "M 33.00 0.00 L 23.00 12.00 L 1.00 24.00 L 2.00 109.00 L 14.00 166.00 L 121.00 166.00 L 115.00 146.00 L 105.00 56.00 L 84.00 46.00 L 70.00 53.00 L 65.00 49.00 L 68.00 40.00 L 62.00 37.00 L 54.00 43.00 L 47.00 34.00 L 40.00 8.00 Z",
    "province": "MAD",
    "rootTerritory": "MAD",
    "viewBox": "0 0 121 166",
    "unitSlots": [
      {
        "name": "main",
        "x": 54.07,
        "y": 99.19,
        "territory": "MAD",
        "arrowReceiver": {
          "x": 72.07,
          "y": 117.19
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 54.07,
        "y": 99.19,
        "territory": "MAD",
        "arrowReceiver": {
          "x": 72.07,
          "y": 117.19
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "JAV": {
    "abbr": "JAV",
    "type": "Coast",
    "centerPos": {
      "x": 102.2,
      "y": 73.32
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 125.5,
        "y": 54.5,
        "text": "Java"
      }
    ],
    "width": 251,
    "height": 109,
    "x": 277,
    "y": 390,
    "playable": true,
    "path": "M 0.00 1.00 L 10.00 88.00 L 16.00 109.00 L 196.00 109.00 L 221.00 97.00 L 232.00 80.00 L 250.00 82.00 L 247.00 75.00 L 251.00 69.00 L 231.00 54.00 L 213.00 63.00 L 218.00 52.00 L 173.00 62.00 L 153.00 61.00 L 138.00 67.00 L 93.00 60.00 L 63.00 42.00 L 50.00 14.00 Z",
    "province": "JAV",
    "rootTerritory": "JAV",
    "viewBox": "0 0 251 109",
    "unitSlots": [
      {
        "name": "main",
        "x": 102.2,
        "y": 73.32,
        "territory": "JAV",
        "arrowReceiver": {
          "x": 120.2,
          "y": 91.32
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 102.2,
        "y": 73.32,
        "territory": "JAV",
        "arrowReceiver": {
          "x": 120.2,
          "y": 91.32
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "NPO": {
    "abbr": "NOR",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 55,
        "y": 64,
        "text": "North Pacific Ocean"
      }
    ],
    "width": 110,
    "height": 128,
    "x": 489,
    "y": 0,
    "playable": true,
    "path": "M 7.00 0.00 L 0.00 11.00 L 6.00 20.00 L 20.00 24.00 L 27.00 31.00 L 23.00 35.00 L 23.00 46.00 L 32.00 72.00 L 27.00 94.00 L 21.00 101.00 L 22.00 107.00 L 12.00 118.00 L 14.00 124.00 L 19.00 128.00 L 63.00 124.00 L 110.00 113.00 L 110.00 0.00 Z",
    "province": "NPO",
    "rootTerritory": "NPO",
    "viewBox": "0 0 110 128",
    "unitSlots": [
      {
        "name": "main",
        "x": 64.35,
        "y": 59.01,
        "territory": "NPO",
        "arrowReceiver": {
          "x": 82.35,
          "y": 77.01
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 64.35,
        "y": 59.01,
        "territory": "NPO",
        "arrowReceiver": {
          "x": 82.35,
          "y": 77.01
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "KIU": {
    "abbr": "KIU",
    "type": "Coast",
    "centerPos": {
      "x": 51.95,
      "y": 99.07
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 44.5,
        "y": 93,
        "text": "Kiushu"
      }
    ],
    "width": 89,
    "height": 186,
    "x": 455,
    "y": 147,
    "playable": true,
    "path": "M 65.00 0.00 L 50.00 22.00 L 49.00 32.00 L 55.00 36.00 L 42.00 37.00 L 40.00 32.00 L 37.00 33.00 L 36.00 69.00 L 13.00 106.00 L 1.00 113.00 L 1.00 131.00 L 17.00 152.00 L 15.00 167.00 L 29.00 164.00 L 31.00 166.00 L 23.00 173.00 L 27.00 178.00 L 36.00 177.00 L 38.00 186.00 L 53.00 178.00 L 73.00 153.00 L 89.00 95.00 L 85.00 20.00 L 82.00 12.00 Z",
    "province": "KIU",
    "rootTerritory": "KIU",
    "viewBox": "0 0 89 186",
    "unitSlots": [
      {
        "name": "main",
        "x": 51.95,
        "y": 99.07,
        "territory": "KIU",
        "arrowReceiver": {
          "x": 69.95,
          "y": 117.07
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 51.95,
        "y": 99.07,
        "territory": "KIU",
        "arrowReceiver": {
          "x": 69.95,
          "y": 117.07
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "SIB": {
    "abbr": "SIB",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 50,
        "y": 66.5,
        "text": "Siberia"
      }
    ],
    "width": 100,
    "height": 133,
    "x": 258,
    "y": 0,
    "playable": true,
    "path": "M 10.00 0.00 L 2.00 11.00 L 3.00 19.00 L 9.00 23.00 L 0.00 29.00 L 5.00 37.00 L 1.00 55.00 L 13.00 71.00 L 18.00 89.00 L 3.00 117.00 L 20.00 133.00 L 30.00 128.00 L 29.00 117.00 L 46.00 120.00 L 54.00 112.00 L 70.00 122.00 L 95.00 119.00 L 100.00 111.00 L 87.00 112.00 L 86.00 107.00 L 75.00 100.00 L 76.00 96.00 L 70.00 89.00 L 71.00 85.00 L 87.00 83.00 L 90.00 73.00 L 82.00 58.00 L 83.00 51.00 L 77.00 46.00 L 82.00 37.00 L 76.00 29.00 L 74.00 14.00 L 80.00 0.00 L 21.00 0.00 L 21.00 7.00 L 16.00 0.00 Z",
    "province": "SIB",
    "rootTerritory": "SIB",
    "viewBox": "0 0 100 133",
    "unitSlots": [
      {
        "name": "main",
        "x": 43.93,
        "y": 60.97,
        "territory": "SIB",
        "arrowReceiver": {
          "x": 61.93,
          "y": 78.97
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 43.93,
        "y": 60.97,
        "territory": "SIB",
        "arrowReceiver": {
          "x": 61.93,
          "y": 78.97
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "ARA": {
    "abbr": "ARA",
    "type": "Coast",
    "centerPos": {
      "x": 23.19,
      "y": 122.14
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 44,
        "y": 134.5,
        "text": "Arabia"
      }
    ],
    "width": 88,
    "height": 269,
    "x": 0,
    "y": 195,
    "playable": true,
    "path": "M 0.00 0.00 L 0.00 269.00 L 3.00 269.00 L 11.00 260.00 L 11.00 186.00 L 27.00 185.00 L 45.00 165.00 L 63.00 160.00 L 88.00 123.00 L 55.00 124.00 L 50.00 121.00 L 43.00 107.00 L 46.00 101.00 L 40.00 96.00 L 32.00 77.00 L 27.00 44.00 L 30.00 21.00 Z",
    "province": "ARA",
    "rootTerritory": "ARA",
    "viewBox": "0 0 88 269",
    "unitSlots": [
      {
        "name": "main",
        "x": 23.19,
        "y": 122.14,
        "territory": "ARA",
        "arrowReceiver": {
          "x": 41.19,
          "y": 140.14
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 23.19,
        "y": 122.14,
        "territory": "ARA",
        "arrowReceiver": {
          "x": 41.19,
          "y": 140.14
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "ARA_2": {
    "abbr": "ARA",
    "type": "Coast",
    "centerPos": {
      "x": 42.14,
      "y": 68.78
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 51.5,
        "y": 60.5,
        "text": "Ara 2"
      }
    ],
    "width": 103,
    "height": 121,
    "x": 37,
    "y": 176,
    "playable": true,
    "path": "M 4.00 11.00 L 0.00 27.00 L 5.00 39.00 L 5.00 62.00 L 13.00 65.00 L 11.00 70.00 L 5.00 71.00 L 12.00 93.00 L 10.00 114.00 L 13.00 118.00 L 39.00 121.00 L 46.00 117.00 L 57.00 119.00 L 65.00 114.00 L 74.00 117.00 L 88.00 113.00 L 103.00 100.00 L 90.00 82.00 L 94.00 67.00 L 76.00 70.00 L 70.00 65.00 L 70.00 58.00 L 62.00 56.00 L 54.00 28.00 L 47.00 22.00 L 38.00 0.00 L 22.00 0.00 Z",
    "province": "ARA_2",
    "rootTerritory": "ARA_2",
    "viewBox": "0 0 103 121",
    "unitSlots": [
      {
        "name": "main",
        "x": 42.14,
        "y": 68.78,
        "territory": "ARA_2",
        "arrowReceiver": {
          "x": 60.14,
          "y": 86.78
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 42.14,
        "y": 68.78,
        "territory": "ARA_2",
        "arrowReceiver": {
          "x": 60.14,
          "y": 86.78
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "IRK": {
    "abbr": "IRK",
    "type": "Land",
    "centerPos": {
      "x": 41.15,
      "y": 58.51
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 44,
        "y": 62.5,
        "text": "Irkutsk"
      }
    ],
    "width": 88,
    "height": 125,
    "x": 329,
    "y": 0,
    "playable": true,
    "path": "M 10.00 0.00 L 4.00 11.00 L 5.00 29.00 L 12.00 38.00 L 7.00 47.00 L 13.00 52.00 L 12.00 58.00 L 20.00 73.00 L 18.00 82.00 L 1.00 85.00 L 0.00 90.00 L 17.00 111.00 L 23.00 108.00 L 31.00 90.00 L 36.00 90.00 L 24.00 124.00 L 34.00 125.00 L 48.00 117.00 L 61.00 121.00 L 65.00 109.00 L 62.00 98.00 L 67.00 88.00 L 87.00 73.00 L 80.00 61.00 L 88.00 47.00 L 78.00 38.00 L 57.00 33.00 L 52.00 15.00 L 56.00 0.00 Z",
    "province": "IRK",
    "rootTerritory": "IRK",
    "viewBox": "0 0 88 125",
    "unitSlots": [
      {
        "name": "main",
        "x": 41.15,
        "y": 58.51,
        "territory": "IRK",
        "arrowReceiver": {
          "x": 59.15,
          "y": 76.51
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 41.15,
        "y": 58.51,
        "territory": "IRK",
        "arrowReceiver": {
          "x": 59.15,
          "y": 76.51
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "SCS": {
    "abbr": "SOU",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 54.5,
        "y": 72,
        "text": "South China Sea"
      }
    ],
    "width": 109,
    "height": 144,
    "x": 379,
    "y": 248,
    "playable": true,
    "path": "M 70.00 0.00 L 64.00 3.00 L 62.00 14.00 L 46.00 30.00 L 35.00 29.00 L 21.00 38.00 L 18.00 45.00 L 9.00 39.00 L 0.00 52.00 L 6.00 68.00 L 24.00 86.00 L 21.00 101.00 L 32.00 117.00 L 35.00 144.00 L 44.00 136.00 L 51.00 135.00 L 62.00 120.00 L 77.00 119.00 L 97.00 101.00 L 105.00 100.00 L 109.00 93.00 L 108.00 87.00 L 99.00 80.00 L 87.00 82.00 L 96.00 76.00 L 95.00 71.00 L 86.00 73.00 L 75.00 67.00 L 77.00 58.00 L 74.00 50.00 L 80.00 36.00 L 74.00 19.00 L 67.00 16.00 L 72.00 7.00 Z",
    "province": "SCS",
    "rootTerritory": "SCS",
    "viewBox": "0 0 109 144",
    "unitSlots": [
      {
        "name": "main",
        "x": 51.93,
        "y": 75.61,
        "territory": "SCS",
        "arrowReceiver": {
          "x": 69.93,
          "y": 93.61
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 51.93,
        "y": 75.61,
        "territory": "SCS",
        "arrowReceiver": {
          "x": 69.93,
          "y": 93.61
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "MON": {
    "abbr": "MON",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 83,
        "y": 41,
        "text": "Mongolia"
      }
    ],
    "width": 166,
    "height": 82,
    "x": 258,
    "y": 89,
    "playable": true,
    "path": "M 166.00 14.00 L 151.00 0.00 L 134.00 9.00 L 138.00 19.00 L 133.00 33.00 L 119.00 29.00 L 106.00 37.00 L 96.00 37.00 L 91.00 32.00 L 69.00 34.00 L 57.00 24.00 L 45.00 33.00 L 30.00 29.00 L 31.00 40.00 L 15.00 48.00 L 18.00 53.00 L 6.00 61.00 L 0.00 74.00 L 11.00 79.00 L 24.00 71.00 L 31.00 73.00 L 34.00 67.00 L 48.00 74.00 L 61.00 68.00 L 78.00 81.00 L 87.00 82.00 L 94.00 77.00 L 111.00 79.00 L 127.00 70.00 L 143.00 68.00 L 143.00 61.00 L 154.00 50.00 L 155.00 39.00 L 150.00 24.00 L 165.00 18.00 Z",
    "province": "MON",
    "rootTerritory": "MON",
    "viewBox": "0 0 166 82",
    "unitSlots": [
      {
        "name": "main",
        "x": 87.54,
        "y": 50.27,
        "territory": "MON",
        "arrowReceiver": {
          "x": 105.54,
          "y": 68.27
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 87.54,
        "y": 50.27,
        "territory": "MON",
        "arrowReceiver": {
          "x": 105.54,
          "y": 68.27
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "MOS": {
    "abbr": "MOS",
    "type": "Land",
    "centerPos": {
      "x": 98.69,
      "y": 38.06
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 88.5,
        "y": 36.5,
        "text": "Moscow"
      }
    ],
    "width": 177,
    "height": 73,
    "x": 57,
    "y": 0,
    "playable": true,
    "path": "M 177.00 19.00 L 172.00 14.00 L 156.00 25.00 L 155.00 19.00 L 145.00 22.00 L 141.00 17.00 L 134.00 23.00 L 131.00 16.00 L 119.00 20.00 L 112.00 17.00 L 108.00 25.00 L 104.00 17.00 L 114.00 4.00 L 125.00 12.00 L 134.00 5.00 L 129.00 0.00 L 80.00 1.00 L 65.00 8.00 L 59.00 17.00 L 83.00 21.00 L 86.00 24.00 L 84.00 32.00 L 66.00 27.00 L 59.00 35.00 L 63.00 25.00 L 60.00 22.00 L 53.00 28.00 L 52.00 45.00 L 1.00 45.00 L 0.00 59.00 L 5.00 67.00 L 9.00 67.00 L 21.00 54.00 L 39.00 61.00 L 42.00 56.00 L 63.00 53.00 L 83.00 69.00 L 95.00 66.00 L 114.00 73.00 L 128.00 73.00 L 146.00 60.00 L 156.00 41.00 L 177.00 23.00 Z",
    "province": "MOS",
    "rootTerritory": "MOS",
    "viewBox": "0 0 177 73",
    "unitSlots": [
      {
        "name": "main",
        "x": 98.69,
        "y": 38.06,
        "territory": "MOS",
        "arrowReceiver": {
          "x": 116.69,
          "y": 56.06
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 98.69,
        "y": 38.06,
        "territory": "MOS",
        "arrowReceiver": {
          "x": 116.69,
          "y": 56.06
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "BAN": {
    "abbr": "BAN",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 72,
        "y": 36,
        "text": "Banda Sea"
      }
    ],
    "width": 144,
    "height": 72,
    "x": 455,
    "y": 393,
    "playable": true,
    "path": "M 0.00 54.00 L 21.00 53.00 L 52.00 43.00 L 57.00 54.00 L 68.00 62.00 L 74.00 58.00 L 77.00 66.00 L 86.00 66.00 L 92.00 59.00 L 101.00 65.00 L 96.00 68.00 L 98.00 72.00 L 114.00 67.00 L 124.00 69.00 L 131.00 50.00 L 128.00 44.00 L 135.00 31.00 L 144.00 48.00 L 144.00 16.00 L 137.00 17.00 L 131.00 13.00 L 121.00 26.00 L 100.00 28.00 L 102.00 20.00 L 95.00 8.00 L 89.00 11.00 L 74.00 8.00 L 70.00 12.00 L 64.00 8.00 L 69.00 2.00 L 60.00 0.00 L 49.00 3.00 L 47.00 8.00 L 35.00 5.00 L 18.00 20.00 L 23.00 33.00 L 16.00 38.00 L 10.00 32.00 Z",
    "province": "BAN",
    "rootTerritory": "BAN",
    "viewBox": "0 0 144 72",
    "unitSlots": [
      {
        "name": "main",
        "x": 77.58,
        "y": 35.89,
        "territory": "BAN",
        "arrowReceiver": {
          "x": 95.58,
          "y": 53.89
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 77.58,
        "y": 35.89,
        "territory": "BAN",
        "arrowReceiver": {
          "x": 95.58,
          "y": 53.89
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "TOB": {
    "abbr": "TOB",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 55.5,
        "y": 56.5,
        "text": "Tobolsk"
      }
    ],
    "width": 111,
    "height": 113,
    "x": 165,
    "y": 0,
    "playable": true,
    "path": "M 97.00 0.00 L 90.00 2.00 L 85.00 19.00 L 70.00 11.00 L 69.00 24.00 L 48.00 42.00 L 30.00 69.00 L 1.00 76.00 L 0.00 86.00 L 5.00 96.00 L 26.00 100.00 L 39.00 93.00 L 64.00 96.00 L 74.00 92.00 L 94.00 113.00 L 98.00 111.00 L 111.00 87.00 L 106.00 71.00 L 95.00 61.00 L 98.00 38.00 L 89.00 28.00 L 93.00 24.00 L 90.00 11.00 Z",
    "province": "TOB",
    "rootTerritory": "TOB",
    "viewBox": "0 0 111 113",
    "unitSlots": [
      {
        "name": "main",
        "x": 64.54,
        "y": 66.94,
        "territory": "TOB",
        "arrowReceiver": {
          "x": 82.54,
          "y": 84.94
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 64.54,
        "y": 66.94,
        "territory": "TOB",
        "arrowReceiver": {
          "x": 82.54,
          "y": 84.94
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "BOB": {
    "abbr": "BAY",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 42,
        "y": 53,
        "text": "Bay of Bengal"
      }
    ],
    "width": 84,
    "height": 106,
    "x": 235,
    "y": 294,
    "playable": true,
    "path": "M 45.00 3.00 L 40.00 14.00 L 8.00 43.00 L 0.00 76.00 L 6.00 78.00 L 9.00 74.00 L 18.00 84.00 L 54.00 100.00 L 83.00 106.00 L 84.00 100.00 L 76.00 93.00 L 70.00 69.00 L 73.00 44.00 L 82.00 30.00 L 80.00 17.00 L 69.00 9.00 L 65.00 1.00 L 59.00 0.00 L 54.00 5.00 Z",
    "province": "BOB",
    "rootTerritory": "BOB",
    "viewBox": "0 0 84 106",
    "unitSlots": [
      {
        "name": "main",
        "x": 45.99,
        "y": 54.06,
        "territory": "BOB",
        "arrowReceiver": {
          "x": 63.99,
          "y": 72.06
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 45.99,
        "y": 54.06,
        "territory": "BOB",
        "arrowReceiver": {
          "x": 63.99,
          "y": 72.06
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "ODE": {
    "abbr": "UKR",
    "type": "Coast",
    "centerPos": {
      "x": 72.12,
      "y": 32.77
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 64.5,
        "y": 42,
        "text": "Ukraine"
      }
    ],
    "width": 129,
    "height": 84,
    "x": 39,
    "y": 54,
    "playable": true,
    "path": "M 1.00 13.00 L 3.00 22.00 L 0.00 28.00 L 16.00 35.00 L 19.00 41.00 L 30.00 35.00 L 31.00 27.00 L 36.00 25.00 L 43.00 32.00 L 44.00 45.00 L 49.00 43.00 L 49.00 37.00 L 70.00 45.00 L 69.00 49.00 L 56.00 50.00 L 55.00 53.00 L 80.00 84.00 L 97.00 63.00 L 111.00 67.00 L 113.00 53.00 L 128.00 40.00 L 124.00 32.00 L 128.00 16.00 L 101.00 15.00 L 81.00 0.00 L 71.00 4.00 L 60.00 3.00 L 57.00 8.00 L 39.00 1.00 L 26.00 14.00 L 15.00 4.00 L 10.00 4.00 Z",
    "province": "ODE",
    "rootTerritory": "ODE",
    "viewBox": "0 0 129 84",
    "unitSlots": [
      {
        "name": "main",
        "x": 72.12,
        "y": 32.77,
        "territory": "ODE",
        "arrowReceiver": {
          "x": 90.12,
          "y": 50.77
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 72.12,
        "y": 32.77,
        "territory": "ODE",
        "arrowReceiver": {
          "x": 90.12,
          "y": 50.77
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "CSE": {
    "abbr": "CEL",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 68.5,
        "y": 35.5,
        "text": "Celebes Sea"
      }
    ],
    "width": 137,
    "height": 71,
    "x": 462,
    "y": 336,
    "playable": true,
    "path": "M 137.00 0.00 L 91.00 9.00 L 40.00 12.00 L 37.00 18.00 L 33.00 16.00 L 28.00 22.00 L 17.00 18.00 L 8.00 21.00 L 3.00 28.00 L 20.00 38.00 L 29.00 50.00 L 3.00 64.00 L 0.00 70.00 L 7.00 71.00 L 12.00 66.00 L 34.00 61.00 L 36.00 56.00 L 49.00 58.00 L 58.00 49.00 L 66.00 50.00 L 68.00 46.00 L 74.00 49.00 L 71.00 59.00 L 79.00 62.00 L 92.00 45.00 L 105.00 46.00 L 109.00 43.00 L 121.00 46.00 L 127.00 54.00 L 137.00 57.00 Z",
    "province": "CSE",
    "rootTerritory": "CSE",
    "viewBox": "0 0 137 71",
    "unitSlots": [
      {
        "name": "main",
        "x": 77.06,
        "y": 31.57,
        "territory": "CSE",
        "arrowReceiver": {
          "x": 95.06,
          "y": 49.57
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 77.06,
        "y": 31.57,
        "territory": "CSE",
        "arrowReceiver": {
          "x": 95.06,
          "y": 49.57
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "TUR": {
    "abbr": "TUR",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 38,
        "y": 52,
        "text": "Turkestan"
      }
    ],
    "width": 76,
    "height": 104,
    "x": 138,
    "y": 94,
    "playable": true,
    "path": "M 71.00 0.00 L 53.00 6.00 L 24.00 3.00 L 12.00 17.00 L 13.00 24.00 L 22.00 35.00 L 18.00 47.00 L 2.00 48.00 L 9.00 66.00 L 0.00 69.00 L 1.00 78.00 L 17.00 83.00 L 28.00 104.00 L 49.00 95.00 L 66.00 101.00 L 73.00 96.00 L 75.00 85.00 L 67.00 78.00 L 69.00 73.00 L 66.00 71.00 L 71.00 51.00 L 69.00 40.00 L 76.00 27.00 L 71.00 13.00 L 74.00 2.00 Z",
    "province": "TUR",
    "rootTerritory": "TUR",
    "viewBox": "0 0 76 104",
    "unitSlots": [
      {
        "name": "main",
        "x": 42.21,
        "y": 51.44,
        "territory": "TUR",
        "arrowReceiver": {
          "x": 60.21,
          "y": 69.44
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 42.21,
        "y": 51.44,
        "territory": "TUR",
        "arrowReceiver": {
          "x": 60.21,
          "y": 69.44
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "ASE": {
    "abbr": "ARA",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 37.5,
        "y": 48.5,
        "text": "Arabian Sea"
      }
    ],
    "width": 75,
    "height": 97,
    "x": 130,
    "y": 260,
    "playable": true,
    "path": "M 56.00 2.00 L 41.00 0.00 L 41.00 17.00 L 36.00 21.00 L 21.00 22.00 L 3.00 41.00 L 2.00 69.00 L 13.00 90.00 L 20.00 94.00 L 47.00 95.00 L 64.00 85.00 L 75.00 72.00 L 68.00 50.00 L 71.00 37.00 L 54.00 21.00 L 58.00 18.00 L 54.00 14.00 Z",
    "province": "ASE",
    "rootTerritory": "ASE",
    "viewBox": "0 0 75 97",
    "unitSlots": [
      {
        "name": "main",
        "x": 37.58,
        "y": 55.36,
        "territory": "ASE",
        "arrowReceiver": {
          "x": 55.58,
          "y": 73.36
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 37.58,
        "y": 55.36,
        "territory": "ASE",
        "arrowReceiver": {
          "x": 55.58,
          "y": 73.36
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "KIR": {
    "abbr": "KIR",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 35.5,
        "y": 51,
        "text": "Kirghiz"
      }
    ],
    "width": 71,
    "height": 102,
    "x": 205,
    "y": 93,
    "playable": true,
    "path": "M 35.00 0.00 L 10.00 2.00 L 4.00 11.00 L 10.00 27.00 L 2.00 42.00 L 5.00 59.00 L 0.00 72.00 L 8.00 85.00 L 6.00 97.00 L 12.00 101.00 L 21.00 101.00 L 15.00 92.00 L 16.00 86.00 L 30.00 89.00 L 53.00 76.00 L 54.00 61.00 L 66.00 51.00 L 66.00 44.00 L 71.00 41.00 Z",
    "province": "KIR",
    "rootTerritory": "KIR",
    "viewBox": "0 0 71 102",
    "unitSlots": [
      {
        "name": "main",
        "x": 30.39,
        "y": 46.12,
        "territory": "KIR",
        "arrowReceiver": {
          "x": 48.39,
          "y": 64.12
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 30.39,
        "y": 46.12,
        "territory": "KIR",
        "arrowReceiver": {
          "x": 48.39,
          "y": 64.12
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "CAN": {
    "abbr": "CAN",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 64.5,
        "y": 35.5,
        "text": "Canton"
      }
    ],
    "width": 129,
    "height": 71,
    "x": 319,
    "y": 224,
    "playable": true,
    "path": "M 128.00 1.00 L 123.00 0.00 L 116.00 6.00 L 106.00 4.00 L 103.00 8.00 L 94.00 4.00 L 86.00 12.00 L 64.00 7.00 L 59.00 19.00 L 54.00 21.00 L 53.00 27.00 L 47.00 28.00 L 40.00 41.00 L 16.00 22.00 L 16.00 12.00 L 6.00 17.00 L 0.00 30.00 L 3.00 33.00 L 14.00 31.00 L 21.00 38.00 L 15.00 61.00 L 23.00 60.00 L 44.00 71.00 L 53.00 59.00 L 70.00 63.00 L 73.00 56.00 L 79.00 56.00 L 81.00 62.00 L 91.00 57.00 L 92.00 40.00 L 102.00 32.00 L 120.00 39.00 L 119.00 32.00 L 123.00 30.00 L 127.00 16.00 L 117.00 16.00 L 116.00 13.00 L 125.00 12.00 L 129.00 8.00 Z",
    "province": "CAN",
    "rootTerritory": "CAN",
    "viewBox": "0 0 129 71",
    "unitSlots": [
      {
        "name": "main",
        "x": 67.53,
        "y": 34.74,
        "territory": "CAN",
        "arrowReceiver": {
          "x": 85.53,
          "y": 52.74
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 67.53,
        "y": 34.74,
        "territory": "CAN",
        "arrowReceiver": {
          "x": 85.53,
          "y": 52.74
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "PER": {
    "abbr": "PER",
    "type": "Coast",
    "centerPos": {
      "x": 35.68,
      "y": 55.52
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 34.5,
        "y": 55,
        "text": "Persia"
      }
    ],
    "width": 69,
    "height": 110,
    "x": 95,
    "y": 147,
    "playable": true,
    "path": "M 8.00 0.00 L 5.00 9.00 L 9.00 23.00 L 0.00 32.00 L 0.00 40.00 L 5.00 45.00 L 2.00 57.00 L 12.00 60.00 L 25.00 89.00 L 35.00 86.00 L 57.00 110.00 L 66.00 96.00 L 57.00 79.00 L 64.00 71.00 L 69.00 44.00 L 53.00 27.00 L 35.00 29.00 L 26.00 24.00 L 22.00 8.00 L 16.00 8.00 Z",
    "province": "PER",
    "rootTerritory": "PER",
    "viewBox": "0 0 69 110",
    "unitSlots": [
      {
        "name": "main",
        "x": 35.68,
        "y": 55.52,
        "territory": "PER",
        "arrowReceiver": {
          "x": 53.68,
          "y": 73.52
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 35.68,
        "y": 55.52,
        "territory": "PER",
        "arrowReceiver": {
          "x": 53.68,
          "y": 73.52
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "GOB": {
    "abbr": "GOB",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 58.5,
        "y": 29,
        "text": "Gobi Desert"
      }
    ],
    "width": 117,
    "height": 58,
    "x": 254,
    "y": 157,
    "playable": true,
    "path": "M 0.00 16.00 L 12.00 26.00 L 29.00 28.00 L 41.00 40.00 L 39.00 44.00 L 25.00 44.00 L 29.00 54.00 L 56.00 50.00 L 62.00 58.00 L 68.00 58.00 L 80.00 49.00 L 102.00 47.00 L 101.00 41.00 L 111.00 33.00 L 117.00 12.00 L 99.00 9.00 L 84.00 15.00 L 64.00 0.00 L 54.00 6.00 L 37.00 0.00 L 35.00 6.00 L 29.00 3.00 L 16.00 11.00 L 6.00 10.00 Z",
    "province": "GOB",
    "rootTerritory": "GOB",
    "viewBox": "0 0 117 58",
    "unitSlots": [
      {
        "name": "main",
        "x": 62.04,
        "y": 27.08,
        "territory": "GOB",
        "arrowReceiver": {
          "x": 80.04,
          "y": 45.08
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 62.04,
        "y": 27.08,
        "territory": "GOB",
        "arrowReceiver": {
          "x": 80.04,
          "y": 45.08
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_25": {
    "abbr": "REG",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 61.5,
        "y": 36.5,
        "text": "REGION_25"
      }
    ],
    "width": 123,
    "height": 73,
    "x": 476,
    "y": 426,
    "playable": true,
    "path": "M 116.00 1.00 L 112.00 1.00 L 109.00 10.00 L 112.00 16.00 L 102.00 37.00 L 89.00 35.00 L 71.00 41.00 L 67.00 33.00 L 54.00 33.00 L 49.00 38.00 L 50.00 48.00 L 43.00 44.00 L 34.00 45.00 L 23.00 61.00 L 0.00 73.00 L 123.00 73.00 L 123.00 16.00 Z",
    "province": "REGION_25",
    "rootTerritory": "REGION_25",
    "viewBox": "0 0 123 73",
    "unitSlots": [
      {
        "name": "main",
        "x": 78.68,
        "y": 52.06,
        "territory": "REGION_25",
        "arrowReceiver": {
          "x": 96.68,
          "y": 70.06
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 78.68,
        "y": 52.06,
        "territory": "REGION_25",
        "arrowReceiver": {
          "x": 96.68,
          "y": 70.06
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "SOO": {
    "abbr": "SEA",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 42.5,
        "y": 52.5,
        "text": "Sea of Okhotsk"
      }
    ],
    "width": 85,
    "height": 105,
    "x": 435,
    "y": 0,
    "playable": true,
    "path": "M 42.00 0.00 L 38.00 5.00 L 41.00 20.00 L 31.00 17.00 L 27.00 32.00 L 17.00 39.00 L 7.00 40.00 L 0.00 65.00 L 22.00 65.00 L 27.00 60.00 L 36.00 79.00 L 39.00 78.00 L 36.00 68.00 L 52.00 78.00 L 50.00 84.00 L 61.00 95.00 L 57.00 102.00 L 69.00 105.00 L 74.00 102.00 L 85.00 80.00 L 83.00 62.00 L 76.00 59.00 L 79.00 53.00 L 58.00 37.00 L 47.00 10.00 L 50.00 0.00 Z",
    "province": "SOO",
    "rootTerritory": "SOO",
    "viewBox": "0 0 85 105",
    "unitSlots": [
      {
        "name": "main",
        "x": 47.07,
        "y": 56.07,
        "territory": "SOO",
        "arrowReceiver": {
          "x": 65.07,
          "y": 74.07
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 47.07,
        "y": 56.07,
        "territory": "SOO",
        "arrowReceiver": {
          "x": 65.07,
          "y": 74.07
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "OKH": {
    "abbr": "YAK",
    "type": "Coast",
    "centerPos": {
      "x": 44,
      "y": 22.38
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 47,
        "y": 34,
        "text": "Yakutsk"
      }
    ],
    "width": 94,
    "height": 68,
    "x": 382,
    "y": 0,
    "playable": true,
    "path": "M 0.00 20.00 L 5.00 33.00 L 24.00 36.00 L 36.00 48.00 L 29.00 62.00 L 37.00 68.00 L 43.00 62.00 L 56.00 58.00 L 55.00 49.00 L 62.00 32.00 L 71.00 37.00 L 80.00 31.00 L 85.00 15.00 L 92.00 17.00 L 91.00 4.00 L 94.00 0.00 L 4.00 0.00 Z",
    "province": "OKH",
    "rootTerritory": "OKH",
    "viewBox": "0 0 94 68",
    "unitSlots": [
      {
        "name": "main",
        "x": 44,
        "y": 22.38,
        "territory": "OKH",
        "arrowReceiver": {
          "x": 62,
          "y": 40.38
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 44,
        "y": 22.38,
        "territory": "OKH",
        "arrowReceiver": {
          "x": 62,
          "y": 40.38
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "SHA": {
    "abbr": "SHA",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 57,
        "y": 44,
        "text": "Shanghai"
      }
    ],
    "width": 114,
    "height": 88,
    "x": 333,
    "y": 177,
    "playable": true,
    "path": "M 101.00 1.00 L 88.00 3.00 L 85.00 16.00 L 77.00 26.00 L 49.00 34.00 L 34.00 32.00 L 13.00 47.00 L 1.00 45.00 L 0.00 51.00 L 5.00 60.00 L 2.00 69.00 L 26.00 88.00 L 26.00 81.00 L 33.00 79.00 L 33.00 73.00 L 40.00 72.00 L 49.00 52.00 L 71.00 59.00 L 80.00 50.00 L 87.00 54.00 L 92.00 50.00 L 102.00 53.00 L 113.00 46.00 L 110.00 33.00 L 95.00 22.00 Z",
    "province": "SHA",
    "rootTerritory": "SHA",
    "viewBox": "0 0 114 88",
    "unitSlots": [
      {
        "name": "main",
        "x": 54.42,
        "y": 46.56,
        "territory": "SHA",
        "arrowReceiver": {
          "x": 72.42,
          "y": 64.56
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 54.42,
        "y": 46.56,
        "territory": "SHA",
        "arrowReceiver": {
          "x": 72.42,
          "y": 64.56
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "TIB": {
    "abbr": "TIB",
    "type": "Land",
    "centerPos": {
      "x": 50.61,
      "y": 23.13
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 49,
        "y": 23.5,
        "text": "Tibet"
      }
    ],
    "width": 98,
    "height": 47,
    "x": 237,
    "y": 207,
    "playable": true,
    "path": "M 98.00 28.00 L 93.00 14.00 L 79.00 8.00 L 72.00 0.00 L 60.00 6.00 L 56.00 2.00 L 51.00 5.00 L 41.00 3.00 L 9.00 10.00 L 0.00 21.00 L 9.00 33.00 L 27.00 37.00 L 42.00 47.00 L 58.00 42.00 L 80.00 44.00 L 88.00 33.00 Z",
    "province": "TIB",
    "rootTerritory": "TIB",
    "viewBox": "0 0 98 47",
    "unitSlots": [
      {
        "name": "main",
        "x": 50.61,
        "y": 23.13,
        "territory": "TIB",
        "arrowReceiver": {
          "x": 68.61,
          "y": 41.13
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 50.61,
        "y": 23.13,
        "territory": "TIB",
        "arrowReceiver": {
          "x": 68.61,
          "y": 41.13
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "AMU": {
    "abbr": "AMU",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 41,
        "y": 39.5,
        "text": "Amur"
      }
    ],
    "width": 82,
    "height": 79,
    "x": 396,
    "y": 61,
    "playable": true,
    "path": "M 0.00 28.00 L 5.00 32.00 L 16.00 27.00 L 32.00 45.00 L 39.00 43.00 L 51.00 51.00 L 61.00 44.00 L 63.00 58.00 L 56.00 73.00 L 60.00 79.00 L 79.00 71.00 L 82.00 57.00 L 77.00 44.00 L 82.00 28.00 L 66.00 6.00 L 52.00 3.00 L 35.00 9.00 L 38.00 1.00 L 32.00 0.00 L 15.00 19.00 Z",
    "province": "AMU",
    "rootTerritory": "AMU",
    "viewBox": "0 0 82 79",
    "unitSlots": [
      {
        "name": "main",
        "x": 51.15,
        "y": 32.49,
        "territory": "AMU",
        "arrowReceiver": {
          "x": 69.15,
          "y": 50.49
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 51.15,
        "y": 32.49,
        "territory": "AMU",
        "arrowReceiver": {
          "x": 69.15,
          "y": 50.49
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "BOR": {
    "abbr": "BOR",
    "type": "Coast",
    "centerPos": {
      "x": 61.7,
      "y": 40.24
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 59,
        "y": 32,
        "text": "Borneo"
      }
    ],
    "width": 118,
    "height": 64,
    "x": 342,
    "y": 387,
    "playable": true,
    "path": "M 0.00 18.00 L 22.00 43.00 L 40.00 42.00 L 43.00 45.00 L 36.00 48.00 L 36.00 55.00 L 42.00 58.00 L 62.00 57.00 L 91.00 64.00 L 110.00 60.00 L 118.00 48.00 L 114.00 35.00 L 93.00 39.00 L 85.00 36.00 L 75.00 39.00 L 72.00 35.00 L 64.00 37.00 L 62.00 32.00 L 58.00 33.00 L 42.00 20.00 L 29.00 0.00 L 24.00 6.00 L 24.00 33.00 L 15.00 29.00 L 4.00 16.00 Z",
    "province": "BOR",
    "rootTerritory": "BOR",
    "viewBox": "0 0 118 64",
    "unitSlots": [
      {
        "name": "main",
        "x": 61.7,
        "y": 40.24,
        "territory": "BOR",
        "arrowReceiver": {
          "x": 79.7,
          "y": 58.24
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 61.7,
        "y": 40.24,
        "territory": "BOR",
        "arrowReceiver": {
          "x": 79.7,
          "y": 58.24
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "PEK": {
    "abbr": "PEK",
    "type": "Coast",
    "centerPos": {
      "x": 57.83,
      "y": 33.32
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 51.5,
        "y": 33,
        "text": "Peking"
      }
    ],
    "width": 103,
    "height": 66,
    "x": 323,
    "y": 158,
    "playable": true,
    "path": "M 103.00 5.00 L 98.00 3.00 L 77.00 9.00 L 73.00 0.00 L 59.00 3.00 L 48.00 14.00 L 42.00 32.00 L 34.00 40.00 L 34.00 47.00 L 12.00 48.00 L 0.00 59.00 L 8.00 65.00 L 16.00 63.00 L 23.00 66.00 L 43.00 51.00 L 58.00 53.00 L 65.00 48.00 L 72.00 50.00 L 88.00 43.00 L 97.00 25.00 L 91.00 24.00 L 87.00 18.00 L 100.00 11.00 Z",
    "province": "PEK",
    "rootTerritory": "PEK",
    "viewBox": "0 0 103 66",
    "unitSlots": [
      {
        "name": "main",
        "x": 57.83,
        "y": 33.32,
        "territory": "PEK",
        "arrowReceiver": {
          "x": 75.83,
          "y": 51.32
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 57.83,
        "y": 33.32,
        "territory": "PEK",
        "arrowReceiver": {
          "x": 75.83,
          "y": 51.32
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "BAL": {
    "abbr": "BAL",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 29,
        "y": 54.5,
        "text": "Bal"
      }
    ],
    "width": 58,
    "height": 109,
    "x": 0,
    "y": 58,
    "playable": true,
    "path": "M 10.00 0.00 L 6.00 11.00 L 12.00 27.00 L 9.00 28.00 L 3.00 20.00 L 0.00 28.00 L 0.00 83.00 L 19.00 101.00 L 39.00 109.00 L 58.00 87.00 L 52.00 86.00 L 44.00 74.00 L 24.00 70.00 L 30.00 64.00 L 28.00 54.00 L 39.00 49.00 L 39.00 42.00 L 27.00 37.00 L 22.00 43.00 L 22.00 52.00 L 9.00 51.00 L 15.00 40.00 L 14.00 32.00 L 21.00 24.00 L 16.00 10.00 L 18.00 1.00 Z",
    "province": "BAL",
    "rootTerritory": "BAL",
    "viewBox": "0 0 58 109",
    "unitSlots": [
      {
        "name": "main",
        "x": 20.99,
        "y": 65.33,
        "territory": "BAL",
        "arrowReceiver": {
          "x": 38.99,
          "y": 83.33
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 20.99,
        "y": 65.33,
        "territory": "BAL",
        "arrowReceiver": {
          "x": 38.99,
          "y": 83.33
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "CAL": {
    "abbr": "CAL",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 36.5,
        "y": 26,
        "text": "Calcutta"
      }
    ],
    "width": 73,
    "height": 52,
    "x": 218,
    "y": 273,
    "playable": true,
    "path": "M 0.00 20.00 L 7.00 40.00 L 27.00 45.00 L 36.00 52.00 L 53.00 39.00 L 65.00 21.00 L 70.00 23.00 L 73.00 13.00 L 67.00 3.00 L 39.00 8.00 L 12.00 0.00 L 3.00 5.00 Z",
    "province": "CAL",
    "rootTerritory": "CAL",
    "viewBox": "0 0 73 52",
    "unitSlots": [
      {
        "name": "main",
        "x": 33.22,
        "y": 23.03,
        "territory": "CAL",
        "arrowReceiver": {
          "x": 51.22,
          "y": 41.03
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 33.22,
        "y": 23.03,
        "territory": "CAL",
        "arrowReceiver": {
          "x": 51.22,
          "y": 41.03
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "SOJ": {
    "abbr": "SEA",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 27,
        "y": 49,
        "text": "Sea of Japan"
      }
    ],
    "width": 54,
    "height": 98,
    "x": 451,
    "y": 94,
    "playable": true,
    "path": "M 30.00 0.00 L 23.00 10.00 L 27.00 23.00 L 25.00 38.00 L 9.00 44.00 L 0.00 60.00 L 1.00 66.00 L 13.00 78.00 L 19.00 95.00 L 24.00 98.00 L 38.00 91.00 L 36.00 87.00 L 31.00 89.00 L 25.00 84.00 L 33.00 85.00 L 46.00 71.00 L 44.00 62.00 L 54.00 48.00 L 50.00 41.00 L 39.00 39.00 L 47.00 37.00 L 48.00 32.00 L 36.00 16.00 L 41.00 8.00 Z",
    "province": "SOJ",
    "rootTerritory": "SOJ",
    "viewBox": "0 0 54 98",
    "unitSlots": [
      {
        "name": "main",
        "x": 27.94,
        "y": 53.03,
        "territory": "SOJ",
        "arrowReceiver": {
          "x": 45.94,
          "y": 71.03
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 27.94,
        "y": 53.03,
        "territory": "SOJ",
        "arrowReceiver": {
          "x": 45.94,
          "y": 71.03
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "AFG": {
    "abbr": "AFG",
    "type": "Land",
    "centerPos": {
      "x": 34.77,
      "y": 23.31
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 35.5,
        "y": 25,
        "text": "Afghanistan"
      }
    ],
    "width": 71,
    "height": 50,
    "x": 156,
    "y": 190,
    "playable": true,
    "path": "M 67.00 6.00 L 61.00 7.00 L 58.00 2.00 L 48.00 6.00 L 31.00 0.00 L 7.00 12.00 L 0.00 34.00 L 10.00 40.00 L 25.00 42.00 L 37.00 50.00 L 48.00 43.00 L 65.00 20.00 L 71.00 19.00 Z",
    "province": "AFG",
    "rootTerritory": "AFG",
    "viewBox": "0 0 71 50",
    "unitSlots": [
      {
        "name": "main",
        "x": 34.77,
        "y": 23.31,
        "territory": "AFG",
        "arrowReceiver": {
          "x": 52.77,
          "y": 41.31
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 34.77,
        "y": 23.31,
        "territory": "AFG",
        "arrowReceiver": {
          "x": 52.77,
          "y": 41.31
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "MAN": {
    "abbr": "MAN",
    "type": "Land",
    "centerPos": {
      "x": 31.51,
      "y": 29.5
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 30,
        "y": 33,
        "text": "Manchuria"
      }
    ],
    "width": 60,
    "height": 66,
    "x": 398,
    "y": 106,
    "playable": true,
    "path": "M 59.00 1.00 L 51.00 7.00 L 38.00 0.00 L 13.00 6.00 L 17.00 24.00 L 15.00 34.00 L 0.00 57.00 L 7.00 60.00 L 27.00 54.00 L 38.00 66.00 L 39.00 55.00 L 58.00 19.00 Z",
    "province": "MAN",
    "rootTerritory": "MAN",
    "viewBox": "0 0 60 66",
    "unitSlots": [
      {
        "name": "main",
        "x": 31.51,
        "y": 29.5,
        "territory": "MAN",
        "arrowReceiver": {
          "x": 49.51,
          "y": 47.5
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 31.51,
        "y": 29.5,
        "territory": "MAN",
        "arrowReceiver": {
          "x": 49.51,
          "y": 47.5
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "BOM": {
    "abbr": "BOM",
    "type": "Coast",
    "centerPos": {
      "x": 21.53,
      "y": 41.02
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 19.5,
        "y": 47,
        "text": "Bombay"
      }
    ],
    "width": 39,
    "height": 94,
    "x": 185,
    "y": 245,
    "playable": true,
    "path": "M 10.00 2.00 L 2.00 13.00 L 4.00 25.00 L 0.00 29.00 L 6.00 32.00 L 1.00 37.00 L 5.00 44.00 L 23.00 54.00 L 21.00 59.00 L 14.00 59.00 L 13.00 65.00 L 25.00 93.00 L 29.00 94.00 L 39.00 72.00 L 33.00 49.00 L 35.00 23.00 L 31.00 1.00 Z",
    "province": "BOM",
    "rootTerritory": "BOM",
    "viewBox": "0 0 39 94",
    "unitSlots": [
      {
        "name": "main",
        "x": 21.53,
        "y": 41.02,
        "territory": "BOM",
        "arrowReceiver": {
          "x": 39.53,
          "y": 59.02
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 21.53,
        "y": 41.02,
        "territory": "BOM",
        "arrowReceiver": {
          "x": 39.53,
          "y": 59.02
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "SIN": {
    "abbr": "SIN",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 36.5,
        "y": 23.5,
        "text": "Sinkiang"
      }
    ],
    "width": 73,
    "height": 47,
    "x": 221,
    "y": 176,
    "playable": true,
    "path": "M 0.00 5.00 L 7.00 16.00 L 4.00 23.00 L 7.00 39.00 L 15.00 47.00 L 38.00 37.00 L 54.00 36.00 L 60.00 32.00 L 58.00 23.00 L 73.00 23.00 L 63.00 10.00 L 48.00 8.00 L 33.00 0.00 L 14.00 7.00 Z",
    "province": "SIN",
    "rootTerritory": "SIN",
    "viewBox": "0 0 73 47",
    "unitSlots": [
      {
        "name": "main",
        "x": 32.49,
        "y": 21.57,
        "territory": "SIN",
        "arrowReceiver": {
          "x": 50.49,
          "y": 39.57
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 32.49,
        "y": 21.57,
        "territory": "SIN",
        "arrowReceiver": {
          "x": 50.49,
          "y": 39.57
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "GOM": {
    "abbr": "GUL",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 20.5,
        "y": 38.5,
        "text": "Gulf of Martaban"
      }
    ],
    "width": 41,
    "height": 77,
    "x": 306,
    "y": 327,
    "playable": true,
    "path": "M 8.00 4.00 L 1.00 16.00 L 1.00 48.00 L 11.00 66.00 L 36.00 77.00 L 41.00 73.00 L 41.00 67.00 L 29.00 51.00 L 33.00 33.00 L 27.00 10.00 L 29.00 1.00 Z",
    "province": "GOM",
    "rootTerritory": "GOM",
    "viewBox": "0 0 41 77",
    "unitSlots": [
      {
        "name": "main",
        "x": 18.42,
        "y": 38.03,
        "territory": "GOM",
        "arrowReceiver": {
          "x": 36.42,
          "y": 56.03
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 18.42,
        "y": 38.03,
        "territory": "GOM",
        "arrowReceiver": {
          "x": 36.42,
          "y": 56.03
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "BUR": {
    "abbr": "BUR",
    "type": "Coast",
    "centerPos": {
      "x": 19.01,
      "y": 44.67
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 21.5,
        "y": 59.5,
        "text": "Burma"
      }
    ],
    "width": 43,
    "height": 119,
    "x": 310,
    "y": 256,
    "playable": true,
    "path": "M 20.00 0.00 L 4.00 19.00 L 6.00 27.00 L 2.00 31.00 L 0.00 50.00 L 6.00 56.00 L 6.00 75.00 L 17.00 70.00 L 25.00 72.00 L 29.00 99.00 L 25.00 118.00 L 28.00 119.00 L 34.00 96.00 L 29.00 82.00 L 30.00 71.00 L 22.00 61.00 L 29.00 51.00 L 29.00 42.00 L 35.00 49.00 L 43.00 45.00 L 40.00 34.00 L 32.00 29.00 L 22.00 29.00 L 29.00 6.00 Z",
    "province": "BUR",
    "rootTerritory": "BUR",
    "viewBox": "0 0 43 119",
    "unitSlots": [
      {
        "name": "main",
        "x": 19.01,
        "y": 44.67,
        "territory": "BUR",
        "arrowReceiver": {
          "x": 37.01,
          "y": 62.67
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 19.01,
        "y": 44.67,
        "territory": "BUR",
        "arrowReceiver": {
          "x": 37.01,
          "y": 62.67
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "ECS": {
    "abbr": "EAS",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 23,
        "y": 33.5,
        "text": "East China Sea"
      }
    ],
    "width": 46,
    "height": 67,
    "x": 445,
    "y": 191,
    "playable": true,
    "path": "M 28.00 0.00 L 16.00 0.00 L 15.00 8.00 L 4.00 22.00 L 8.00 29.00 L 3.00 31.00 L 0.00 55.00 L 10.00 60.00 L 13.00 67.00 L 24.00 58.00 L 31.00 42.00 L 46.00 24.00 L 44.00 15.00 L 39.00 14.00 Z",
    "province": "ECS",
    "rootTerritory": "ECS",
    "viewBox": "0 0 46 67",
    "unitSlots": [
      {
        "name": "main",
        "x": 21.31,
        "y": 31.21,
        "territory": "ECS",
        "arrowReceiver": {
          "x": 39.31,
          "y": 49.21
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 21.31,
        "y": 31.21,
        "territory": "ECS",
        "arrowReceiver": {
          "x": 39.31,
          "y": 49.21
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "SUN": {
    "abbr": "SUN",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 23,
        "y": 29.5,
        "text": "Sunda Sea"
      }
    ],
    "width": 46,
    "height": 59,
    "x": 367,
    "y": 354,
    "playable": true,
    "path": "M 36.00 0.00 L 24.00 4.00 L 20.00 16.00 L 7.00 18.00 L 7.00 9.00 L 0.00 7.00 L 3.00 31.00 L 17.00 52.00 L 26.00 59.00 L 44.00 41.00 L 46.00 34.00 L 44.00 12.00 Z",
    "province": "SUN",
    "rootTerritory": "SUN",
    "viewBox": "0 0 46 59",
    "unitSlots": [
      {
        "name": "main",
        "x": 25.75,
        "y": 28.02,
        "territory": "SUN",
        "arrowReceiver": {
          "x": 43.75,
          "y": 46.02
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 25.75,
        "y": 28.02,
        "territory": "SUN",
        "arrowReceiver": {
          "x": 43.75,
          "y": 46.02
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "PGU": {
    "abbr": "PER",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 40,
        "y": 39,
        "text": "Persian Gulf"
      }
    ],
    "width": 80,
    "height": 78,
    "x": 91,
    "y": 204,
    "playable": true,
    "path": "M 0.00 2.00 L 2.00 16.00 L 8.00 27.00 L 16.00 29.00 L 19.00 40.00 L 29.00 43.00 L 37.00 37.00 L 40.00 39.00 L 36.00 53.00 L 55.00 76.00 L 70.00 78.00 L 80.00 72.00 L 76.00 57.00 L 59.00 53.00 L 39.00 30.00 L 27.00 31.00 L 15.00 3.00 Z",
    "province": "PGU",
    "rootTerritory": "PGU",
    "viewBox": "0 0 80 78",
    "unitSlots": [
      {
        "name": "main",
        "x": 40.06,
        "y": 43.75,
        "territory": "PGU",
        "arrowReceiver": {
          "x": 58.06,
          "y": 61.75
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 40.06,
        "y": 43.75,
        "territory": "PGU",
        "arrowReceiver": {
          "x": 58.06,
          "y": 61.75
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "DEL": {
    "abbr": "DEL",
    "type": "Land",
    "centerPos": {
      "x": 28.27,
      "y": 22.35
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 33.5,
        "y": 19.5,
        "text": "Delhi"
      }
    ],
    "width": 67,
    "height": 39,
    "x": 216,
    "y": 241,
    "playable": true,
    "path": "M 1.00 3.00 L 0.00 17.00 L 5.00 35.00 L 17.00 32.00 L 43.00 39.00 L 67.00 34.00 L 65.00 25.00 L 26.00 11.00 L 21.00 1.00 Z",
    "province": "DEL",
    "rootTerritory": "DEL",
    "viewBox": "0 0 67 39",
    "unitSlots": [
      {
        "name": "main",
        "x": 28.27,
        "y": 22.35,
        "territory": "DEL",
        "arrowReceiver": {
          "x": 46.27,
          "y": 40.35
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 28.27,
        "y": 22.35,
        "territory": "DEL",
        "arrowReceiver": {
          "x": 46.27,
          "y": 40.35
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "ANG": {
    "abbr": "ANA",
    "type": "Coast",
    "centerPos": {
      "x": 36.12,
      "y": 18.63
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 36,
        "y": 20,
        "text": "Anatolia"
      }
    ],
    "width": 72,
    "height": 40,
    "x": 29,
    "y": 113,
    "playable": true,
    "path": "M 1.00 2.00 L 0.00 13.00 L 6.00 18.00 L 15.00 18.00 L 22.00 30.00 L 26.00 24.00 L 33.00 25.00 L 29.00 29.00 L 31.00 35.00 L 43.00 32.00 L 52.00 33.00 L 61.00 40.00 L 71.00 39.00 L 72.00 34.00 L 60.00 27.00 L 61.00 17.00 L 46.00 3.00 L 42.00 9.00 L 36.00 9.00 L 35.00 1.00 Z",
    "province": "ANG",
    "rootTerritory": "ANG",
    "viewBox": "0 0 72 40",
    "unitSlots": [
      {
        "name": "main",
        "x": 36.12,
        "y": 18.63,
        "territory": "ANG",
        "arrowReceiver": {
          "x": 54.12,
          "y": 36.63
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 36.12,
        "y": 18.63,
        "territory": "ANG",
        "arrowReceiver": {
          "x": 54.12,
          "y": 36.63
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "BLA": {
    "abbr": "BLA",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 32.5,
        "y": 22.5,
        "text": "Black Sea"
      }
    ],
    "width": 65,
    "height": 45,
    "x": 43,
    "y": 85,
    "playable": true,
    "path": "M 0.00 20.00 L 10.00 29.00 L 32.00 31.00 L 49.00 45.00 L 58.00 44.00 L 63.00 39.00 L 51.00 18.00 L 61.00 20.00 L 65.00 15.00 L 57.00 10.00 L 52.00 10.00 L 49.00 15.00 L 36.00 15.00 L 37.00 0.00 L 29.00 1.00 L 17.00 12.00 L 10.00 10.00 Z",
    "province": "BLA",
    "rootTerritory": "BLA",
    "viewBox": "0 0 65 45",
    "unitSlots": [
      {
        "name": "main",
        "x": 35.52,
        "y": 22.76,
        "territory": "BLA",
        "arrowReceiver": {
          "x": 53.52,
          "y": 40.76
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 35.52,
        "y": 22.76,
        "territory": "BLA",
        "arrowReceiver": {
          "x": 53.52,
          "y": 40.76
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_48": {
    "abbr": "CAS",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 21,
        "y": 29.5,
        "text": "Caspian Sea"
      }
    ],
    "width": 42,
    "height": 59,
    "x": 117,
    "y": 117,
    "playable": true,
    "path": "M 22.00 0.00 L 7.00 12.00 L 10.00 35.00 L 0.00 42.00 L 1.00 51.00 L 14.00 59.00 L 22.00 52.00 L 18.00 45.00 L 30.00 43.00 L 29.00 36.00 L 22.00 34.00 L 22.00 25.00 L 38.00 24.00 L 42.00 14.00 L 36.00 4.00 L 30.00 5.00 Z",
    "province": "REGION_48",
    "rootTerritory": "REGION_48",
    "viewBox": "0 0 42 59",
    "unitSlots": [
      {
        "name": "main",
        "x": 19.39,
        "y": 27.08,
        "territory": "REGION_48",
        "arrowReceiver": {
          "x": 37.39,
          "y": 45.08
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 19.39,
        "y": 27.08,
        "territory": "REGION_48",
        "arrowReceiver": {
          "x": 37.39,
          "y": 45.08
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "EGY": {
    "abbr": "EGY",
    "type": "Coast",
    "centerPos": {
      "x": 12.85,
      "y": 36.18
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 14.5,
        "y": 34,
        "text": "Egypt"
      }
    ],
    "width": 29,
    "height": 68,
    "x": 0,
    "y": 142,
    "playable": true,
    "path": "M 0.00 0.00 L 0.00 51.00 L 26.00 68.00 L 29.00 56.00 L 25.00 22.00 L 18.00 24.00 L 18.00 15.00 Z",
    "province": "EGY",
    "rootTerritory": "EGY",
    "viewBox": "0 0 29 68",
    "unitSlots": [
      {
        "name": "main",
        "x": 12.85,
        "y": 36.18,
        "territory": "EGY",
        "arrowReceiver": {
          "x": 30.85,
          "y": 54.18
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 12.85,
        "y": 36.18,
        "territory": "EGY",
        "arrowReceiver": {
          "x": 30.85,
          "y": 54.18
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "MAD_2": {
    "abbr": "MAD",
    "type": "Coast",
    "centerPos": {
      "x": 16.06,
      "y": 25.34
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 18,
        "y": 30,
        "text": "Mad 2"
      }
    ],
    "width": 36,
    "height": 60,
    "x": 214,
    "y": 315,
    "playable": true,
    "path": "M 19.00 0.00 L 10.00 1.00 L 0.00 25.00 L 5.00 52.00 L 12.00 60.00 L 15.00 57.00 L 11.00 51.00 L 22.00 49.00 L 29.00 21.00 L 36.00 15.00 L 31.00 4.00 L 26.00 5.00 Z",
    "province": "MAD_2",
    "rootTerritory": "MAD_2",
    "viewBox": "0 0 36 60",
    "unitSlots": [
      {
        "name": "main",
        "x": 16.06,
        "y": 25.34,
        "territory": "MAD_2",
        "arrowReceiver": {
          "x": 34.06,
          "y": 43.34
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 16.06,
        "y": 25.34,
        "territory": "MAD_2",
        "arrowReceiver": {
          "x": 34.06,
          "y": 43.34
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_51": {
    "abbr": "REG",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 43.5,
        "y": 11,
        "text": "REGION_51"
      }
    ],
    "width": 87,
    "height": 22,
    "x": 168,
    "y": 0,
    "playable": true,
    "path": "M 0.00 12.00 L 6.00 19.00 L 20.00 16.00 L 24.00 22.00 L 32.00 12.00 L 36.00 15.00 L 35.00 22.00 L 52.00 13.00 L 55.00 16.00 L 66.00 13.00 L 68.00 9.00 L 80.00 17.00 L 87.00 0.00 L 20.00 0.00 L 23.00 7.00 L 17.00 12.00 L 6.00 4.00 Z",
    "province": "REGION_51",
    "rootTerritory": "REGION_51",
    "viewBox": "0 0 87 22",
    "unitSlots": [
      {
        "name": "main",
        "x": 44.97,
        "y": 8.35,
        "territory": "REGION_51",
        "arrowReceiver": {
          "x": 62.97,
          "y": 26.35
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 44.97,
        "y": 8.35,
        "territory": "REGION_51",
        "arrowReceiver": {
          "x": 62.97,
          "y": 26.35
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "BEN": {
    "abbr": "BEN",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 20.5,
        "y": 27,
        "text": "Bengal"
      }
    ],
    "width": 41,
    "height": 54,
    "x": 283,
    "y": 250,
    "playable": true,
    "path": "M 13.00 0.00 L 7.00 3.00 L 7.00 12.00 L 0.00 22.00 L 8.00 35.00 L 8.00 43.00 L 17.00 45.00 L 25.00 54.00 L 30.00 24.00 L 41.00 9.00 L 34.00 3.00 Z",
    "province": "BEN",
    "rootTerritory": "BEN",
    "viewBox": "0 0 41 54",
    "unitSlots": [
      {
        "name": "main",
        "x": 19.45,
        "y": 22.47,
        "territory": "BEN",
        "arrowReceiver": {
          "x": 37.45,
          "y": 40.47
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 19.45,
        "y": 22.47,
        "territory": "BEN",
        "arrowReceiver": {
          "x": 37.45,
          "y": 40.47
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "RED": {
    "abbr": "RED",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 10.5,
        "y": 57.5,
        "text": "Red Sea"
      }
    ],
    "width": 21,
    "height": 115,
    "x": 27,
    "y": 178,
    "playable": true,
    "path": "M 2.00 0.00 L 2.00 48.00 L 10.00 50.00 L 10.00 66.00 L 3.00 68.00 L 4.00 87.00 L 8.00 102.00 L 18.00 115.00 L 21.00 88.00 L 14.00 73.00 L 15.00 38.00 L 10.00 26.00 L 14.00 3.00 L 6.00 4.00 Z",
    "province": "RED",
    "rootTerritory": "RED",
    "viewBox": "0 0 21 115",
    "unitSlots": [
      {
        "name": "main",
        "x": 10.1,
        "y": 59.08,
        "territory": "RED",
        "arrowReceiver": {
          "x": 28.1,
          "y": 77.08
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 10.1,
        "y": 59.08,
        "territory": "RED",
        "arrowReceiver": {
          "x": 28.1,
          "y": 77.08
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "MES": {
    "abbr": "MES",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 18,
        "y": 29.5,
        "text": "Mesopotamia"
      }
    ],
    "width": 36,
    "height": 59,
    "x": 66,
    "y": 145,
    "playable": true,
    "path": "M 3.00 0.00 L 0.00 9.00 L 5.00 30.00 L 11.00 32.00 L 18.00 52.00 L 29.00 59.00 L 32.00 47.00 L 28.00 34.00 L 36.00 25.00 L 33.00 10.00 Z",
    "province": "MES",
    "rootTerritory": "MES",
    "viewBox": "0 0 36 59",
    "unitSlots": [
      {
        "name": "main",
        "x": 18.73,
        "y": 25.55,
        "territory": "MES",
        "arrowReceiver": {
          "x": 36.73,
          "y": 43.55
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 18.73,
        "y": 25.55,
        "territory": "MES",
        "arrowReceiver": {
          "x": 36.73,
          "y": 43.55
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "MAK": {
    "abbr": "MAK",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 21.5,
        "y": 29.5,
        "text": "Mak"
      }
    ],
    "width": 43,
    "height": 59,
    "x": 444,
    "y": 364,
    "playable": true,
    "path": "M 23.00 1.00 L 17.00 0.00 L 5.00 10.00 L 2.00 26.00 L 8.00 33.00 L 1.00 46.00 L 1.00 59.00 L 11.00 52.00 L 15.00 34.00 L 43.00 19.00 L 37.00 10.00 Z",
    "province": "MAK",
    "rootTerritory": "MAK",
    "viewBox": "0 0 43 59",
    "unitSlots": [
      {
        "name": "main",
        "x": 17.89,
        "y": 23.28,
        "territory": "MAK",
        "arrowReceiver": {
          "x": 35.89,
          "y": 41.28
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 17.89,
        "y": 23.28,
        "territory": "MAK",
        "arrowReceiver": {
          "x": 35.89,
          "y": 41.28
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "SIAM": {
    "abbr": "SIA",
    "type": "Coast",
    "centerPos": {
      "x": 20.37,
      "y": 24.42
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 21.5,
        "y": 26,
        "text": "Siam"
      }
    ],
    "width": 43,
    "height": 52,
    "x": 334,
    "y": 306,
    "playable": true,
    "path": "M 17.00 0.00 L 5.00 4.00 L 0.00 11.00 L 7.00 21.00 L 6.00 31.00 L 12.00 52.00 L 16.00 49.00 L 16.00 39.00 L 22.00 39.00 L 26.00 45.00 L 43.00 32.00 L 34.00 13.00 L 19.00 12.00 L 20.00 2.00 Z",
    "province": "SIAM",
    "rootTerritory": "SIAM",
    "viewBox": "0 0 43 52",
    "unitSlots": [
      {
        "name": "main",
        "x": 20.37,
        "y": 24.42,
        "territory": "SIAM",
        "arrowReceiver": {
          "x": 38.37,
          "y": 42.42
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 20.37,
        "y": 24.42,
        "territory": "SIAM",
        "arrowReceiver": {
          "x": 38.37,
          "y": 42.42
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "BOR_2": {
    "abbr": "CEL",
    "type": "Coast",
    "centerPos": {
      "x": 30.88,
      "y": 19.16
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 27.5,
        "y": 17.5,
        "text": "Celebes"
      }
    ],
    "width": 55,
    "height": 35,
    "x": 396,
    "y": 391,
    "playable": true,
    "path": "M 55.00 4.00 L 47.00 0.00 L 42.00 5.00 L 33.00 5.00 L 23.00 15.00 L 2.00 17.00 L 0.00 24.00 L 10.00 33.00 L 18.00 31.00 L 24.00 34.00 L 32.00 25.00 L 34.00 34.00 L 42.00 34.00 L 47.00 30.00 L 47.00 19.00 Z",
    "province": "BOR_2",
    "rootTerritory": "BOR_2",
    "viewBox": "0 0 55 35",
    "unitSlots": [
      {
        "name": "main",
        "x": 30.88,
        "y": 19.16,
        "territory": "BOR_2",
        "arrowReceiver": {
          "x": 48.88,
          "y": 37.16
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 30.88,
        "y": 19.16,
        "territory": "BOR_2",
        "arrowReceiver": {
          "x": 48.88,
          "y": 37.16
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "YEL": {
    "abbr": "YEL",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 15.5,
        "y": 22.5,
        "text": "Yellow Sea"
      }
    ],
    "width": 31,
    "height": 45,
    "x": 428,
    "y": 166,
    "playable": true,
    "path": "M 12.00 0.00 L 5.00 8.00 L 7.00 14.00 L 0.00 32.00 L 21.00 45.00 L 31.00 28.00 L 23.00 6.00 Z",
    "province": "YEL",
    "rootTerritory": "YEL",
    "viewBox": "0 0 31 45",
    "unitSlots": [
      {
        "name": "main",
        "x": 15.65,
        "y": 24.15,
        "territory": "YEL",
        "arrowReceiver": {
          "x": 33.65,
          "y": 42.15
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 15.65,
        "y": 24.15,
        "territory": "YEL",
        "arrowReceiver": {
          "x": 33.65,
          "y": 42.15
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "BEL": {
    "abbr": "BEL",
    "type": "Coast",
    "centerPos": {
      "x": 21.72,
      "y": 19.98
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 25.5,
        "y": 18,
        "text": "Beluchistan"
      }
    ],
    "width": 51,
    "height": 36,
    "x": 153,
    "y": 226,
    "playable": true,
    "path": "M 0.00 1.00 L 10.00 15.00 L 3.00 31.00 L 14.00 35.00 L 32.00 36.00 L 38.00 23.00 L 51.00 15.00 L 50.00 12.00 L 40.00 15.00 L 29.00 12.00 L 25.00 18.00 L 21.00 15.00 L 22.00 6.00 Z",
    "province": "BEL",
    "rootTerritory": "BEL",
    "viewBox": "0 0 51 36",
    "unitSlots": [
      {
        "name": "main",
        "x": 21.72,
        "y": 19.98,
        "territory": "BEL",
        "arrowReceiver": {
          "x": 39.72,
          "y": 37.98
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 21.72,
        "y": 19.98,
        "territory": "BEL",
        "arrowReceiver": {
          "x": 39.72,
          "y": 37.98
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "NEW": {
    "abbr": "NEW",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 26.5,
        "y": 18,
        "text": "New Guinea"
      }
    ],
    "width": 53,
    "height": 36,
    "x": 517,
    "y": 382,
    "playable": true,
    "path": "M 0.00 6.00 L 2.00 12.00 L 9.00 11.00 L 8.00 20.00 L 26.00 22.00 L 31.00 18.00 L 37.00 22.00 L 41.00 33.00 L 53.00 35.00 L 53.00 15.00 L 35.00 13.00 L 36.00 10.00 L 52.00 11.00 L 52.00 0.00 L 37.00 0.00 L 25.00 16.00 L 16.00 13.00 L 17.00 2.00 Z",
    "province": "NEW",
    "rootTerritory": "NEW",
    "viewBox": "0 0 53 36",
    "unitSlots": [
      {
        "name": "main",
        "x": 34.05,
        "y": 15.19,
        "territory": "NEW",
        "arrowReceiver": {
          "x": 52.05,
          "y": 33.19
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 34.05,
        "y": 15.19,
        "territory": "NEW",
        "arrowReceiver": {
          "x": 52.05,
          "y": 33.19
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "PUN": {
    "abbr": "PUN",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 20,
        "y": 17.5,
        "text": "Punjab"
      }
    ],
    "width": 40,
    "height": 35,
    "x": 204,
    "y": 211,
    "playable": true,
    "path": "M 21.00 0.00 L 2.00 20.00 L 2.00 35.00 L 40.00 30.00 Z",
    "province": "PUN",
    "rootTerritory": "PUN",
    "viewBox": "0 0 40 35",
    "unitSlots": [
      {
        "name": "main",
        "x": 18.21,
        "y": 20.31,
        "territory": "PUN",
        "arrowReceiver": {
          "x": 36.21,
          "y": 38.31
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 18.21,
        "y": 20.31,
        "territory": "PUN",
        "arrowReceiver": {
          "x": 36.21,
          "y": 38.31
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_62": {
    "abbr": "REG",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 14,
        "y": 19.5,
        "text": "REGION_62"
      }
    ],
    "width": 28,
    "height": 39,
    "x": 571,
    "y": 380,
    "playable": true,
    "path": "M 1.00 0.00 L 0.00 37.00 L 4.00 39.00 L 15.00 24.00 L 22.00 30.00 L 28.00 29.00 L 28.00 13.00 L 18.00 11.00 L 12.00 3.00 Z",
    "province": "REGION_62",
    "rootTerritory": "REGION_62",
    "viewBox": "0 0 28 39",
    "unitSlots": [
      {
        "name": "main",
        "x": 11.96,
        "y": 18.59,
        "territory": "REGION_62",
        "arrowReceiver": {
          "x": 29.96,
          "y": 36.59
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 11.96,
        "y": 18.59,
        "territory": "REGION_62",
        "arrowReceiver": {
          "x": 29.96,
          "y": 36.59
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_63": {
    "abbr": "REG",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 17.5,
        "y": 12.5,
        "text": "REGION_63"
      }
    ],
    "width": 35,
    "height": 25,
    "x": 45,
    "y": 294,
    "playable": true,
    "path": "M 2.00 1.00 L 0.00 8.00 L 8.00 24.00 L 33.00 22.00 L 35.00 10.00 L 31.00 3.00 Z",
    "province": "REGION_63",
    "rootTerritory": "REGION_63",
    "viewBox": "0 0 35 25",
    "unitSlots": [
      {
        "name": "main",
        "x": 17.82,
        "y": 12.51,
        "territory": "REGION_63",
        "arrowReceiver": {
          "x": 35.82,
          "y": 30.51
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 17.82,
        "y": 12.51,
        "territory": "REGION_63",
        "arrowReceiver": {
          "x": 35.82,
          "y": 30.51
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_64": {
    "abbr": "REG",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 15.5,
        "y": 25,
        "text": "REGION_64"
      }
    ],
    "width": 31,
    "height": 50,
    "x": 483,
    "y": 0,
    "playable": true,
    "path": "M 3.00 0.00 L 0.00 10.00 L 8.00 33.00 L 20.00 47.00 L 29.00 50.00 L 31.00 29.00 L 10.00 18.00 L 6.00 7.00 L 11.00 0.00 Z",
    "province": "REGION_64",
    "rootTerritory": "REGION_64",
    "viewBox": "0 0 31 50",
    "unitSlots": [
      {
        "name": "main",
        "x": 15.91,
        "y": 27.98,
        "territory": "REGION_64",
        "arrowReceiver": {
          "x": 33.91,
          "y": 45.98
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 15.91,
        "y": 27.98,
        "territory": "REGION_64",
        "arrowReceiver": {
          "x": 33.91,
          "y": 45.98
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "GOS": {
    "abbr": "GUL",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 13,
        "y": 19.5,
        "text": "Gulf of Siam"
      }
    ],
    "width": 26,
    "height": 39,
    "x": 344,
    "y": 351,
    "playable": true,
    "path": "M 7.00 1.00 L 0.00 29.00 L 13.00 31.00 L 23.00 39.00 L 26.00 31.00 L 23.00 10.00 L 16.00 2.00 Z",
    "province": "GOS",
    "rootTerritory": "GOS",
    "viewBox": "0 0 26 39",
    "unitSlots": [
      {
        "name": "main",
        "x": 14.28,
        "y": 18.55,
        "territory": "GOS",
        "arrowReceiver": {
          "x": 32.28,
          "y": 36.55
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 14.28,
        "y": 18.55,
        "territory": "GOS",
        "arrowReceiver": {
          "x": 32.28,
          "y": 36.55
        }
      }
    },
    "texture": {
      "texture": "#96B2B2",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_66": {
    "abbr": "REG",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 23.5,
        "y": 12.5,
        "text": "REGION_66"
      }
    ],
    "width": 47,
    "height": 25,
    "x": 242,
    "y": 241,
    "playable": true,
    "path": "M 0.00 4.00 L 1.00 10.00 L 41.00 25.00 L 47.00 21.00 L 46.00 13.00 L 36.00 14.00 L 29.00 8.00 L 5.00 0.00 Z",
    "province": "REGION_66",
    "rootTerritory": "REGION_66",
    "viewBox": "0 0 47 25",
    "unitSlots": [
      {
        "name": "main",
        "x": 23.28,
        "y": 12.69,
        "territory": "REGION_66",
        "arrowReceiver": {
          "x": 41.28,
          "y": 30.69
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 23.28,
        "y": 12.69,
        "territory": "REGION_66",
        "arrowReceiver": {
          "x": 41.28,
          "y": 30.69
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "SYR": {
    "abbr": "SYR",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 16,
        "y": 12,
        "text": "Syria"
      }
    ],
    "width": 32,
    "height": 24,
    "x": 39,
    "y": 155,
    "playable": true,
    "path": "M 0.00 12.00 L 3.00 21.00 L 13.00 24.00 L 32.00 20.00 L 28.00 2.00 L 13.00 0.00 Z",
    "province": "SYR",
    "rootTerritory": "SYR",
    "viewBox": "0 0 32 24",
    "unitSlots": [
      {
        "name": "main",
        "x": 16.79,
        "y": 12.62,
        "territory": "SYR",
        "arrowReceiver": {
          "x": 34.79,
          "y": 30.62
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 16.79,
        "y": 12.62,
        "territory": "SYR",
        "arrowReceiver": {
          "x": 34.79,
          "y": 30.62
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_69": {
    "abbr": "REG",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 19.5,
        "y": 17,
        "text": "REGION_69"
      }
    ],
    "width": 39,
    "height": 34,
    "x": 319,
    "y": 394,
    "playable": true,
    "path": "M 0.00 1.00 L 11.00 12.00 L 20.00 34.00 L 24.00 31.00 L 39.00 32.00 L 11.00 3.00 Z",
    "province": "REGION_69",
    "rootTerritory": "REGION_69",
    "viewBox": "0 0 39 34",
    "unitSlots": [
      {
        "name": "main",
        "x": 19.43,
        "y": 18.83,
        "territory": "REGION_69",
        "arrowReceiver": {
          "x": 37.43,
          "y": 36.83
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 19.43,
        "y": 18.83,
        "territory": "REGION_69",
        "arrowReceiver": {
          "x": 37.43,
          "y": 36.83
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "SUM": {
    "abbr": "SUM",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 17,
        "y": 11,
        "text": "Sumatra"
      }
    ],
    "width": 34,
    "height": 22,
    "x": 344,
    "y": 428,
    "playable": true,
    "path": "M 0.00 3.00 L 26.00 22.00 L 34.00 19.00 L 33.00 9.00 L 23.00 2.00 Z",
    "province": "SUM",
    "rootTerritory": "SUM",
    "viewBox": "0 0 34 22",
    "unitSlots": [
      {
        "name": "main",
        "x": 19.96,
        "y": 10.34,
        "territory": "SUM",
        "arrowReceiver": {
          "x": 37.96,
          "y": 28.34
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 19.96,
        "y": 10.34,
        "territory": "SUM",
        "arrowReceiver": {
          "x": 37.96,
          "y": 28.34
        }
      }
    },
    "texture": {
      "texture": "#F9F2E6",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  }
} as unknown as MapVariant["provincesMapData"];

const territoryMap = {
  "CPO": {
    "territory": "CPO",
    "unitSlotName": "main",
    "province": "CPO",
    "provinceMapData": {
      "abbr": "CEN",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 51.5,
          "y": 117.5,
          "text": "Central Pacific Ocean"
        }
      ],
      "width": 103,
      "height": 235,
      "x": 496,
      "y": 113,
      "playable": true,
      "path": "M 103.00 0.00 L 63.00 10.00 L 17.00 16.00 L 18.00 20.00 L 25.00 21.00 L 18.00 25.00 L 18.00 29.00 L 36.00 40.00 L 44.00 53.00 L 48.00 130.00 L 32.00 188.00 L 18.00 207.00 L 0.00 221.00 L 5.00 235.00 L 56.00 232.00 L 103.00 223.00 Z",
      "province": "CPO",
      "rootTerritory": "CPO",
      "viewBox": "0 0 103 235",
      "unitSlots": [
        {
          "name": "main",
          "x": 67.98,
          "y": 123.25,
          "territory": "CPO",
          "arrowReceiver": {
            "x": 85.98,
            "y": 141.25
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 67.98,
          "y": 123.25,
          "territory": "CPO",
          "arrowReceiver": {
            "x": 85.98,
            "y": 141.25
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Central Pacific Ocean": {
    "territory": "CPO",
    "unitSlotName": "main",
    "province": "CPO",
    "provinceMapData": {
      "abbr": "CEN",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 51.5,
          "y": 117.5,
          "text": "Central Pacific Ocean"
        }
      ],
      "width": 103,
      "height": 235,
      "x": 496,
      "y": 113,
      "playable": true,
      "path": "M 103.00 0.00 L 63.00 10.00 L 17.00 16.00 L 18.00 20.00 L 25.00 21.00 L 18.00 25.00 L 18.00 29.00 L 36.00 40.00 L 44.00 53.00 L 48.00 130.00 L 32.00 188.00 L 18.00 207.00 L 0.00 221.00 L 5.00 235.00 L 56.00 232.00 L 103.00 223.00 Z",
      "province": "CPO",
      "rootTerritory": "CPO",
      "viewBox": "0 0 103 235",
      "unitSlots": [
        {
          "name": "main",
          "x": 67.98,
          "y": 123.25,
          "territory": "CPO",
          "arrowReceiver": {
            "x": 85.98,
            "y": 141.25
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 67.98,
          "y": 123.25,
          "territory": "CPO",
          "arrowReceiver": {
            "x": 85.98,
            "y": 141.25
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "MAD": {
    "territory": "MAD",
    "unitSlotName": "main",
    "province": "MAD",
    "provinceMapData": {
      "abbr": "MAD",
      "type": "Coast",
      "centerPos": {
        "x": 54.07,
        "y": 99.19
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 60.5,
          "y": 83,
          "text": "Madras"
        }
      ],
      "width": 121,
      "height": 166,
      "x": 172,
      "y": 333,
      "playable": true,
      "path": "M 33.00 0.00 L 23.00 12.00 L 1.00 24.00 L 2.00 109.00 L 14.00 166.00 L 121.00 166.00 L 115.00 146.00 L 105.00 56.00 L 84.00 46.00 L 70.00 53.00 L 65.00 49.00 L 68.00 40.00 L 62.00 37.00 L 54.00 43.00 L 47.00 34.00 L 40.00 8.00 Z",
      "province": "MAD",
      "rootTerritory": "MAD",
      "viewBox": "0 0 121 166",
      "unitSlots": [
        {
          "name": "main",
          "x": 54.07,
          "y": 99.19,
          "territory": "MAD",
          "arrowReceiver": {
            "x": 72.07,
            "y": 117.19
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 54.07,
          "y": 99.19,
          "territory": "MAD",
          "arrowReceiver": {
            "x": 72.07,
            "y": 117.19
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Madras": {
    "territory": "MAD",
    "unitSlotName": "main",
    "province": "MAD",
    "provinceMapData": {
      "abbr": "MAD",
      "type": "Coast",
      "centerPos": {
        "x": 54.07,
        "y": 99.19
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 60.5,
          "y": 83,
          "text": "Madras"
        }
      ],
      "width": 121,
      "height": 166,
      "x": 172,
      "y": 333,
      "playable": true,
      "path": "M 33.00 0.00 L 23.00 12.00 L 1.00 24.00 L 2.00 109.00 L 14.00 166.00 L 121.00 166.00 L 115.00 146.00 L 105.00 56.00 L 84.00 46.00 L 70.00 53.00 L 65.00 49.00 L 68.00 40.00 L 62.00 37.00 L 54.00 43.00 L 47.00 34.00 L 40.00 8.00 Z",
      "province": "MAD",
      "rootTerritory": "MAD",
      "viewBox": "0 0 121 166",
      "unitSlots": [
        {
          "name": "main",
          "x": 54.07,
          "y": 99.19,
          "territory": "MAD",
          "arrowReceiver": {
            "x": 72.07,
            "y": 117.19
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 54.07,
          "y": 99.19,
          "territory": "MAD",
          "arrowReceiver": {
            "x": 72.07,
            "y": 117.19
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "JAV": {
    "territory": "JAV",
    "unitSlotName": "main",
    "province": "JAV",
    "provinceMapData": {
      "abbr": "JAV",
      "type": "Coast",
      "centerPos": {
        "x": 102.2,
        "y": 73.32
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 125.5,
          "y": 54.5,
          "text": "Java"
        }
      ],
      "width": 251,
      "height": 109,
      "x": 277,
      "y": 390,
      "playable": true,
      "path": "M 0.00 1.00 L 10.00 88.00 L 16.00 109.00 L 196.00 109.00 L 221.00 97.00 L 232.00 80.00 L 250.00 82.00 L 247.00 75.00 L 251.00 69.00 L 231.00 54.00 L 213.00 63.00 L 218.00 52.00 L 173.00 62.00 L 153.00 61.00 L 138.00 67.00 L 93.00 60.00 L 63.00 42.00 L 50.00 14.00 Z",
      "province": "JAV",
      "rootTerritory": "JAV",
      "viewBox": "0 0 251 109",
      "unitSlots": [
        {
          "name": "main",
          "x": 102.2,
          "y": 73.32,
          "territory": "JAV",
          "arrowReceiver": {
            "x": 120.2,
            "y": 91.32
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 102.2,
          "y": 73.32,
          "territory": "JAV",
          "arrowReceiver": {
            "x": 120.2,
            "y": 91.32
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Java": {
    "territory": "JAV",
    "unitSlotName": "main",
    "province": "JAV",
    "provinceMapData": {
      "abbr": "JAV",
      "type": "Coast",
      "centerPos": {
        "x": 102.2,
        "y": 73.32
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 125.5,
          "y": 54.5,
          "text": "Java"
        }
      ],
      "width": 251,
      "height": 109,
      "x": 277,
      "y": 390,
      "playable": true,
      "path": "M 0.00 1.00 L 10.00 88.00 L 16.00 109.00 L 196.00 109.00 L 221.00 97.00 L 232.00 80.00 L 250.00 82.00 L 247.00 75.00 L 251.00 69.00 L 231.00 54.00 L 213.00 63.00 L 218.00 52.00 L 173.00 62.00 L 153.00 61.00 L 138.00 67.00 L 93.00 60.00 L 63.00 42.00 L 50.00 14.00 Z",
      "province": "JAV",
      "rootTerritory": "JAV",
      "viewBox": "0 0 251 109",
      "unitSlots": [
        {
          "name": "main",
          "x": 102.2,
          "y": 73.32,
          "territory": "JAV",
          "arrowReceiver": {
            "x": 120.2,
            "y": 91.32
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 102.2,
          "y": 73.32,
          "territory": "JAV",
          "arrowReceiver": {
            "x": 120.2,
            "y": 91.32
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "NPO": {
    "territory": "NPO",
    "unitSlotName": "main",
    "province": "NPO",
    "provinceMapData": {
      "abbr": "NOR",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 55,
          "y": 64,
          "text": "North Pacific Ocean"
        }
      ],
      "width": 110,
      "height": 128,
      "x": 489,
      "y": 0,
      "playable": true,
      "path": "M 7.00 0.00 L 0.00 11.00 L 6.00 20.00 L 20.00 24.00 L 27.00 31.00 L 23.00 35.00 L 23.00 46.00 L 32.00 72.00 L 27.00 94.00 L 21.00 101.00 L 22.00 107.00 L 12.00 118.00 L 14.00 124.00 L 19.00 128.00 L 63.00 124.00 L 110.00 113.00 L 110.00 0.00 Z",
      "province": "NPO",
      "rootTerritory": "NPO",
      "viewBox": "0 0 110 128",
      "unitSlots": [
        {
          "name": "main",
          "x": 64.35,
          "y": 59.01,
          "territory": "NPO",
          "arrowReceiver": {
            "x": 82.35,
            "y": 77.01
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 64.35,
          "y": 59.01,
          "territory": "NPO",
          "arrowReceiver": {
            "x": 82.35,
            "y": 77.01
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "North Pacific Ocean": {
    "territory": "NPO",
    "unitSlotName": "main",
    "province": "NPO",
    "provinceMapData": {
      "abbr": "NOR",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 55,
          "y": 64,
          "text": "North Pacific Ocean"
        }
      ],
      "width": 110,
      "height": 128,
      "x": 489,
      "y": 0,
      "playable": true,
      "path": "M 7.00 0.00 L 0.00 11.00 L 6.00 20.00 L 20.00 24.00 L 27.00 31.00 L 23.00 35.00 L 23.00 46.00 L 32.00 72.00 L 27.00 94.00 L 21.00 101.00 L 22.00 107.00 L 12.00 118.00 L 14.00 124.00 L 19.00 128.00 L 63.00 124.00 L 110.00 113.00 L 110.00 0.00 Z",
      "province": "NPO",
      "rootTerritory": "NPO",
      "viewBox": "0 0 110 128",
      "unitSlots": [
        {
          "name": "main",
          "x": 64.35,
          "y": 59.01,
          "territory": "NPO",
          "arrowReceiver": {
            "x": 82.35,
            "y": 77.01
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 64.35,
          "y": 59.01,
          "territory": "NPO",
          "arrowReceiver": {
            "x": 82.35,
            "y": 77.01
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "KIU": {
    "territory": "KIU",
    "unitSlotName": "main",
    "province": "KIU",
    "provinceMapData": {
      "abbr": "KIU",
      "type": "Coast",
      "centerPos": {
        "x": 51.95,
        "y": 99.07
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44.5,
          "y": 93,
          "text": "Kiushu"
        }
      ],
      "width": 89,
      "height": 186,
      "x": 455,
      "y": 147,
      "playable": true,
      "path": "M 65.00 0.00 L 50.00 22.00 L 49.00 32.00 L 55.00 36.00 L 42.00 37.00 L 40.00 32.00 L 37.00 33.00 L 36.00 69.00 L 13.00 106.00 L 1.00 113.00 L 1.00 131.00 L 17.00 152.00 L 15.00 167.00 L 29.00 164.00 L 31.00 166.00 L 23.00 173.00 L 27.00 178.00 L 36.00 177.00 L 38.00 186.00 L 53.00 178.00 L 73.00 153.00 L 89.00 95.00 L 85.00 20.00 L 82.00 12.00 Z",
      "province": "KIU",
      "rootTerritory": "KIU",
      "viewBox": "0 0 89 186",
      "unitSlots": [
        {
          "name": "main",
          "x": 51.95,
          "y": 99.07,
          "territory": "KIU",
          "arrowReceiver": {
            "x": 69.95,
            "y": 117.07
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51.95,
          "y": 99.07,
          "territory": "KIU",
          "arrowReceiver": {
            "x": 69.95,
            "y": 117.07
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Kiushu": {
    "territory": "KIU",
    "unitSlotName": "main",
    "province": "KIU",
    "provinceMapData": {
      "abbr": "KIU",
      "type": "Coast",
      "centerPos": {
        "x": 51.95,
        "y": 99.07
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44.5,
          "y": 93,
          "text": "Kiushu"
        }
      ],
      "width": 89,
      "height": 186,
      "x": 455,
      "y": 147,
      "playable": true,
      "path": "M 65.00 0.00 L 50.00 22.00 L 49.00 32.00 L 55.00 36.00 L 42.00 37.00 L 40.00 32.00 L 37.00 33.00 L 36.00 69.00 L 13.00 106.00 L 1.00 113.00 L 1.00 131.00 L 17.00 152.00 L 15.00 167.00 L 29.00 164.00 L 31.00 166.00 L 23.00 173.00 L 27.00 178.00 L 36.00 177.00 L 38.00 186.00 L 53.00 178.00 L 73.00 153.00 L 89.00 95.00 L 85.00 20.00 L 82.00 12.00 Z",
      "province": "KIU",
      "rootTerritory": "KIU",
      "viewBox": "0 0 89 186",
      "unitSlots": [
        {
          "name": "main",
          "x": 51.95,
          "y": 99.07,
          "territory": "KIU",
          "arrowReceiver": {
            "x": 69.95,
            "y": 117.07
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51.95,
          "y": 99.07,
          "territory": "KIU",
          "arrowReceiver": {
            "x": 69.95,
            "y": 117.07
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "SIB": {
    "territory": "SIB",
    "unitSlotName": "main",
    "province": "SIB",
    "provinceMapData": {
      "abbr": "SIB",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 50,
          "y": 66.5,
          "text": "Siberia"
        }
      ],
      "width": 100,
      "height": 133,
      "x": 258,
      "y": 0,
      "playable": true,
      "path": "M 10.00 0.00 L 2.00 11.00 L 3.00 19.00 L 9.00 23.00 L 0.00 29.00 L 5.00 37.00 L 1.00 55.00 L 13.00 71.00 L 18.00 89.00 L 3.00 117.00 L 20.00 133.00 L 30.00 128.00 L 29.00 117.00 L 46.00 120.00 L 54.00 112.00 L 70.00 122.00 L 95.00 119.00 L 100.00 111.00 L 87.00 112.00 L 86.00 107.00 L 75.00 100.00 L 76.00 96.00 L 70.00 89.00 L 71.00 85.00 L 87.00 83.00 L 90.00 73.00 L 82.00 58.00 L 83.00 51.00 L 77.00 46.00 L 82.00 37.00 L 76.00 29.00 L 74.00 14.00 L 80.00 0.00 L 21.00 0.00 L 21.00 7.00 L 16.00 0.00 Z",
      "province": "SIB",
      "rootTerritory": "SIB",
      "viewBox": "0 0 100 133",
      "unitSlots": [
        {
          "name": "main",
          "x": 43.93,
          "y": 60.97,
          "territory": "SIB",
          "arrowReceiver": {
            "x": 61.93,
            "y": 78.97
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 43.93,
          "y": 60.97,
          "territory": "SIB",
          "arrowReceiver": {
            "x": 61.93,
            "y": 78.97
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Siberia": {
    "territory": "SIB",
    "unitSlotName": "main",
    "province": "SIB",
    "provinceMapData": {
      "abbr": "SIB",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 50,
          "y": 66.5,
          "text": "Siberia"
        }
      ],
      "width": 100,
      "height": 133,
      "x": 258,
      "y": 0,
      "playable": true,
      "path": "M 10.00 0.00 L 2.00 11.00 L 3.00 19.00 L 9.00 23.00 L 0.00 29.00 L 5.00 37.00 L 1.00 55.00 L 13.00 71.00 L 18.00 89.00 L 3.00 117.00 L 20.00 133.00 L 30.00 128.00 L 29.00 117.00 L 46.00 120.00 L 54.00 112.00 L 70.00 122.00 L 95.00 119.00 L 100.00 111.00 L 87.00 112.00 L 86.00 107.00 L 75.00 100.00 L 76.00 96.00 L 70.00 89.00 L 71.00 85.00 L 87.00 83.00 L 90.00 73.00 L 82.00 58.00 L 83.00 51.00 L 77.00 46.00 L 82.00 37.00 L 76.00 29.00 L 74.00 14.00 L 80.00 0.00 L 21.00 0.00 L 21.00 7.00 L 16.00 0.00 Z",
      "province": "SIB",
      "rootTerritory": "SIB",
      "viewBox": "0 0 100 133",
      "unitSlots": [
        {
          "name": "main",
          "x": 43.93,
          "y": 60.97,
          "territory": "SIB",
          "arrowReceiver": {
            "x": 61.93,
            "y": 78.97
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 43.93,
          "y": 60.97,
          "territory": "SIB",
          "arrowReceiver": {
            "x": 61.93,
            "y": 78.97
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "ARA": {
    "territory": "ARA",
    "unitSlotName": "main",
    "province": "ARA",
    "provinceMapData": {
      "abbr": "ARA",
      "type": "Coast",
      "centerPos": {
        "x": 23.19,
        "y": 122.14
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 134.5,
          "text": "Arabia"
        }
      ],
      "width": 88,
      "height": 269,
      "x": 0,
      "y": 195,
      "playable": true,
      "path": "M 0.00 0.00 L 0.00 269.00 L 3.00 269.00 L 11.00 260.00 L 11.00 186.00 L 27.00 185.00 L 45.00 165.00 L 63.00 160.00 L 88.00 123.00 L 55.00 124.00 L 50.00 121.00 L 43.00 107.00 L 46.00 101.00 L 40.00 96.00 L 32.00 77.00 L 27.00 44.00 L 30.00 21.00 Z",
      "province": "ARA",
      "rootTerritory": "ARA",
      "viewBox": "0 0 88 269",
      "unitSlots": [
        {
          "name": "main",
          "x": 23.19,
          "y": 122.14,
          "territory": "ARA",
          "arrowReceiver": {
            "x": 41.19,
            "y": 140.14
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 23.19,
          "y": 122.14,
          "territory": "ARA",
          "arrowReceiver": {
            "x": 41.19,
            "y": 140.14
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Arabia": {
    "territory": "ARA",
    "unitSlotName": "main",
    "province": "ARA",
    "provinceMapData": {
      "abbr": "ARA",
      "type": "Coast",
      "centerPos": {
        "x": 23.19,
        "y": 122.14
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 134.5,
          "text": "Arabia"
        }
      ],
      "width": 88,
      "height": 269,
      "x": 0,
      "y": 195,
      "playable": true,
      "path": "M 0.00 0.00 L 0.00 269.00 L 3.00 269.00 L 11.00 260.00 L 11.00 186.00 L 27.00 185.00 L 45.00 165.00 L 63.00 160.00 L 88.00 123.00 L 55.00 124.00 L 50.00 121.00 L 43.00 107.00 L 46.00 101.00 L 40.00 96.00 L 32.00 77.00 L 27.00 44.00 L 30.00 21.00 Z",
      "province": "ARA",
      "rootTerritory": "ARA",
      "viewBox": "0 0 88 269",
      "unitSlots": [
        {
          "name": "main",
          "x": 23.19,
          "y": 122.14,
          "territory": "ARA",
          "arrowReceiver": {
            "x": 41.19,
            "y": 140.14
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 23.19,
          "y": 122.14,
          "territory": "ARA",
          "arrowReceiver": {
            "x": 41.19,
            "y": 140.14
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "ARA_2": {
    "territory": "ARA_2",
    "unitSlotName": "main",
    "province": "ARA_2",
    "provinceMapData": {
      "abbr": "ARA",
      "type": "Coast",
      "centerPos": {
        "x": 42.14,
        "y": 68.78
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 51.5,
          "y": 60.5,
          "text": "Ara 2"
        }
      ],
      "width": 103,
      "height": 121,
      "x": 37,
      "y": 176,
      "playable": true,
      "path": "M 4.00 11.00 L 0.00 27.00 L 5.00 39.00 L 5.00 62.00 L 13.00 65.00 L 11.00 70.00 L 5.00 71.00 L 12.00 93.00 L 10.00 114.00 L 13.00 118.00 L 39.00 121.00 L 46.00 117.00 L 57.00 119.00 L 65.00 114.00 L 74.00 117.00 L 88.00 113.00 L 103.00 100.00 L 90.00 82.00 L 94.00 67.00 L 76.00 70.00 L 70.00 65.00 L 70.00 58.00 L 62.00 56.00 L 54.00 28.00 L 47.00 22.00 L 38.00 0.00 L 22.00 0.00 Z",
      "province": "ARA_2",
      "rootTerritory": "ARA_2",
      "viewBox": "0 0 103 121",
      "unitSlots": [
        {
          "name": "main",
          "x": 42.14,
          "y": 68.78,
          "territory": "ARA_2",
          "arrowReceiver": {
            "x": 60.14,
            "y": 86.78
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42.14,
          "y": 68.78,
          "territory": "ARA_2",
          "arrowReceiver": {
            "x": 60.14,
            "y": 86.78
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Ara 2": {
    "territory": "ARA_2",
    "unitSlotName": "main",
    "province": "ARA_2",
    "provinceMapData": {
      "abbr": "ARA",
      "type": "Coast",
      "centerPos": {
        "x": 42.14,
        "y": 68.78
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 51.5,
          "y": 60.5,
          "text": "Ara 2"
        }
      ],
      "width": 103,
      "height": 121,
      "x": 37,
      "y": 176,
      "playable": true,
      "path": "M 4.00 11.00 L 0.00 27.00 L 5.00 39.00 L 5.00 62.00 L 13.00 65.00 L 11.00 70.00 L 5.00 71.00 L 12.00 93.00 L 10.00 114.00 L 13.00 118.00 L 39.00 121.00 L 46.00 117.00 L 57.00 119.00 L 65.00 114.00 L 74.00 117.00 L 88.00 113.00 L 103.00 100.00 L 90.00 82.00 L 94.00 67.00 L 76.00 70.00 L 70.00 65.00 L 70.00 58.00 L 62.00 56.00 L 54.00 28.00 L 47.00 22.00 L 38.00 0.00 L 22.00 0.00 Z",
      "province": "ARA_2",
      "rootTerritory": "ARA_2",
      "viewBox": "0 0 103 121",
      "unitSlots": [
        {
          "name": "main",
          "x": 42.14,
          "y": 68.78,
          "territory": "ARA_2",
          "arrowReceiver": {
            "x": 60.14,
            "y": 86.78
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42.14,
          "y": 68.78,
          "territory": "ARA_2",
          "arrowReceiver": {
            "x": 60.14,
            "y": 86.78
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "IRK": {
    "territory": "IRK",
    "unitSlotName": "main",
    "province": "IRK",
    "provinceMapData": {
      "abbr": "IRK",
      "type": "Land",
      "centerPos": {
        "x": 41.15,
        "y": 58.51
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 62.5,
          "text": "Irkutsk"
        }
      ],
      "width": 88,
      "height": 125,
      "x": 329,
      "y": 0,
      "playable": true,
      "path": "M 10.00 0.00 L 4.00 11.00 L 5.00 29.00 L 12.00 38.00 L 7.00 47.00 L 13.00 52.00 L 12.00 58.00 L 20.00 73.00 L 18.00 82.00 L 1.00 85.00 L 0.00 90.00 L 17.00 111.00 L 23.00 108.00 L 31.00 90.00 L 36.00 90.00 L 24.00 124.00 L 34.00 125.00 L 48.00 117.00 L 61.00 121.00 L 65.00 109.00 L 62.00 98.00 L 67.00 88.00 L 87.00 73.00 L 80.00 61.00 L 88.00 47.00 L 78.00 38.00 L 57.00 33.00 L 52.00 15.00 L 56.00 0.00 Z",
      "province": "IRK",
      "rootTerritory": "IRK",
      "viewBox": "0 0 88 125",
      "unitSlots": [
        {
          "name": "main",
          "x": 41.15,
          "y": 58.51,
          "territory": "IRK",
          "arrowReceiver": {
            "x": 59.15,
            "y": 76.51
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41.15,
          "y": 58.51,
          "territory": "IRK",
          "arrowReceiver": {
            "x": 59.15,
            "y": 76.51
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Irkutsk": {
    "territory": "IRK",
    "unitSlotName": "main",
    "province": "IRK",
    "provinceMapData": {
      "abbr": "IRK",
      "type": "Land",
      "centerPos": {
        "x": 41.15,
        "y": 58.51
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 62.5,
          "text": "Irkutsk"
        }
      ],
      "width": 88,
      "height": 125,
      "x": 329,
      "y": 0,
      "playable": true,
      "path": "M 10.00 0.00 L 4.00 11.00 L 5.00 29.00 L 12.00 38.00 L 7.00 47.00 L 13.00 52.00 L 12.00 58.00 L 20.00 73.00 L 18.00 82.00 L 1.00 85.00 L 0.00 90.00 L 17.00 111.00 L 23.00 108.00 L 31.00 90.00 L 36.00 90.00 L 24.00 124.00 L 34.00 125.00 L 48.00 117.00 L 61.00 121.00 L 65.00 109.00 L 62.00 98.00 L 67.00 88.00 L 87.00 73.00 L 80.00 61.00 L 88.00 47.00 L 78.00 38.00 L 57.00 33.00 L 52.00 15.00 L 56.00 0.00 Z",
      "province": "IRK",
      "rootTerritory": "IRK",
      "viewBox": "0 0 88 125",
      "unitSlots": [
        {
          "name": "main",
          "x": 41.15,
          "y": 58.51,
          "territory": "IRK",
          "arrowReceiver": {
            "x": 59.15,
            "y": 76.51
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41.15,
          "y": 58.51,
          "territory": "IRK",
          "arrowReceiver": {
            "x": 59.15,
            "y": 76.51
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "SCS": {
    "territory": "SCS",
    "unitSlotName": "main",
    "province": "SCS",
    "provinceMapData": {
      "abbr": "SOU",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54.5,
          "y": 72,
          "text": "South China Sea"
        }
      ],
      "width": 109,
      "height": 144,
      "x": 379,
      "y": 248,
      "playable": true,
      "path": "M 70.00 0.00 L 64.00 3.00 L 62.00 14.00 L 46.00 30.00 L 35.00 29.00 L 21.00 38.00 L 18.00 45.00 L 9.00 39.00 L 0.00 52.00 L 6.00 68.00 L 24.00 86.00 L 21.00 101.00 L 32.00 117.00 L 35.00 144.00 L 44.00 136.00 L 51.00 135.00 L 62.00 120.00 L 77.00 119.00 L 97.00 101.00 L 105.00 100.00 L 109.00 93.00 L 108.00 87.00 L 99.00 80.00 L 87.00 82.00 L 96.00 76.00 L 95.00 71.00 L 86.00 73.00 L 75.00 67.00 L 77.00 58.00 L 74.00 50.00 L 80.00 36.00 L 74.00 19.00 L 67.00 16.00 L 72.00 7.00 Z",
      "province": "SCS",
      "rootTerritory": "SCS",
      "viewBox": "0 0 109 144",
      "unitSlots": [
        {
          "name": "main",
          "x": 51.93,
          "y": 75.61,
          "territory": "SCS",
          "arrowReceiver": {
            "x": 69.93,
            "y": 93.61
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51.93,
          "y": 75.61,
          "territory": "SCS",
          "arrowReceiver": {
            "x": 69.93,
            "y": 93.61
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "South China Sea": {
    "territory": "SCS",
    "unitSlotName": "main",
    "province": "SCS",
    "provinceMapData": {
      "abbr": "SOU",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54.5,
          "y": 72,
          "text": "South China Sea"
        }
      ],
      "width": 109,
      "height": 144,
      "x": 379,
      "y": 248,
      "playable": true,
      "path": "M 70.00 0.00 L 64.00 3.00 L 62.00 14.00 L 46.00 30.00 L 35.00 29.00 L 21.00 38.00 L 18.00 45.00 L 9.00 39.00 L 0.00 52.00 L 6.00 68.00 L 24.00 86.00 L 21.00 101.00 L 32.00 117.00 L 35.00 144.00 L 44.00 136.00 L 51.00 135.00 L 62.00 120.00 L 77.00 119.00 L 97.00 101.00 L 105.00 100.00 L 109.00 93.00 L 108.00 87.00 L 99.00 80.00 L 87.00 82.00 L 96.00 76.00 L 95.00 71.00 L 86.00 73.00 L 75.00 67.00 L 77.00 58.00 L 74.00 50.00 L 80.00 36.00 L 74.00 19.00 L 67.00 16.00 L 72.00 7.00 Z",
      "province": "SCS",
      "rootTerritory": "SCS",
      "viewBox": "0 0 109 144",
      "unitSlots": [
        {
          "name": "main",
          "x": 51.93,
          "y": 75.61,
          "territory": "SCS",
          "arrowReceiver": {
            "x": 69.93,
            "y": 93.61
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51.93,
          "y": 75.61,
          "territory": "SCS",
          "arrowReceiver": {
            "x": 69.93,
            "y": 93.61
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "MON": {
    "territory": "MON",
    "unitSlotName": "main",
    "province": "MON",
    "provinceMapData": {
      "abbr": "MON",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 83,
          "y": 41,
          "text": "Mongolia"
        }
      ],
      "width": 166,
      "height": 82,
      "x": 258,
      "y": 89,
      "playable": true,
      "path": "M 166.00 14.00 L 151.00 0.00 L 134.00 9.00 L 138.00 19.00 L 133.00 33.00 L 119.00 29.00 L 106.00 37.00 L 96.00 37.00 L 91.00 32.00 L 69.00 34.00 L 57.00 24.00 L 45.00 33.00 L 30.00 29.00 L 31.00 40.00 L 15.00 48.00 L 18.00 53.00 L 6.00 61.00 L 0.00 74.00 L 11.00 79.00 L 24.00 71.00 L 31.00 73.00 L 34.00 67.00 L 48.00 74.00 L 61.00 68.00 L 78.00 81.00 L 87.00 82.00 L 94.00 77.00 L 111.00 79.00 L 127.00 70.00 L 143.00 68.00 L 143.00 61.00 L 154.00 50.00 L 155.00 39.00 L 150.00 24.00 L 165.00 18.00 Z",
      "province": "MON",
      "rootTerritory": "MON",
      "viewBox": "0 0 166 82",
      "unitSlots": [
        {
          "name": "main",
          "x": 87.54,
          "y": 50.27,
          "territory": "MON",
          "arrowReceiver": {
            "x": 105.54,
            "y": 68.27
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 87.54,
          "y": 50.27,
          "territory": "MON",
          "arrowReceiver": {
            "x": 105.54,
            "y": 68.27
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Mongolia": {
    "territory": "MON",
    "unitSlotName": "main",
    "province": "MON",
    "provinceMapData": {
      "abbr": "MON",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 83,
          "y": 41,
          "text": "Mongolia"
        }
      ],
      "width": 166,
      "height": 82,
      "x": 258,
      "y": 89,
      "playable": true,
      "path": "M 166.00 14.00 L 151.00 0.00 L 134.00 9.00 L 138.00 19.00 L 133.00 33.00 L 119.00 29.00 L 106.00 37.00 L 96.00 37.00 L 91.00 32.00 L 69.00 34.00 L 57.00 24.00 L 45.00 33.00 L 30.00 29.00 L 31.00 40.00 L 15.00 48.00 L 18.00 53.00 L 6.00 61.00 L 0.00 74.00 L 11.00 79.00 L 24.00 71.00 L 31.00 73.00 L 34.00 67.00 L 48.00 74.00 L 61.00 68.00 L 78.00 81.00 L 87.00 82.00 L 94.00 77.00 L 111.00 79.00 L 127.00 70.00 L 143.00 68.00 L 143.00 61.00 L 154.00 50.00 L 155.00 39.00 L 150.00 24.00 L 165.00 18.00 Z",
      "province": "MON",
      "rootTerritory": "MON",
      "viewBox": "0 0 166 82",
      "unitSlots": [
        {
          "name": "main",
          "x": 87.54,
          "y": 50.27,
          "territory": "MON",
          "arrowReceiver": {
            "x": 105.54,
            "y": 68.27
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 87.54,
          "y": 50.27,
          "territory": "MON",
          "arrowReceiver": {
            "x": 105.54,
            "y": 68.27
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "MOS": {
    "territory": "MOS",
    "unitSlotName": "main",
    "province": "MOS",
    "provinceMapData": {
      "abbr": "MOS",
      "type": "Land",
      "centerPos": {
        "x": 98.69,
        "y": 38.06
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 88.5,
          "y": 36.5,
          "text": "Moscow"
        }
      ],
      "width": 177,
      "height": 73,
      "x": 57,
      "y": 0,
      "playable": true,
      "path": "M 177.00 19.00 L 172.00 14.00 L 156.00 25.00 L 155.00 19.00 L 145.00 22.00 L 141.00 17.00 L 134.00 23.00 L 131.00 16.00 L 119.00 20.00 L 112.00 17.00 L 108.00 25.00 L 104.00 17.00 L 114.00 4.00 L 125.00 12.00 L 134.00 5.00 L 129.00 0.00 L 80.00 1.00 L 65.00 8.00 L 59.00 17.00 L 83.00 21.00 L 86.00 24.00 L 84.00 32.00 L 66.00 27.00 L 59.00 35.00 L 63.00 25.00 L 60.00 22.00 L 53.00 28.00 L 52.00 45.00 L 1.00 45.00 L 0.00 59.00 L 5.00 67.00 L 9.00 67.00 L 21.00 54.00 L 39.00 61.00 L 42.00 56.00 L 63.00 53.00 L 83.00 69.00 L 95.00 66.00 L 114.00 73.00 L 128.00 73.00 L 146.00 60.00 L 156.00 41.00 L 177.00 23.00 Z",
      "province": "MOS",
      "rootTerritory": "MOS",
      "viewBox": "0 0 177 73",
      "unitSlots": [
        {
          "name": "main",
          "x": 98.69,
          "y": 38.06,
          "territory": "MOS",
          "arrowReceiver": {
            "x": 116.69,
            "y": 56.06
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 98.69,
          "y": 38.06,
          "territory": "MOS",
          "arrowReceiver": {
            "x": 116.69,
            "y": 56.06
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Moscow": {
    "territory": "MOS",
    "unitSlotName": "main",
    "province": "MOS",
    "provinceMapData": {
      "abbr": "MOS",
      "type": "Land",
      "centerPos": {
        "x": 98.69,
        "y": 38.06
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 88.5,
          "y": 36.5,
          "text": "Moscow"
        }
      ],
      "width": 177,
      "height": 73,
      "x": 57,
      "y": 0,
      "playable": true,
      "path": "M 177.00 19.00 L 172.00 14.00 L 156.00 25.00 L 155.00 19.00 L 145.00 22.00 L 141.00 17.00 L 134.00 23.00 L 131.00 16.00 L 119.00 20.00 L 112.00 17.00 L 108.00 25.00 L 104.00 17.00 L 114.00 4.00 L 125.00 12.00 L 134.00 5.00 L 129.00 0.00 L 80.00 1.00 L 65.00 8.00 L 59.00 17.00 L 83.00 21.00 L 86.00 24.00 L 84.00 32.00 L 66.00 27.00 L 59.00 35.00 L 63.00 25.00 L 60.00 22.00 L 53.00 28.00 L 52.00 45.00 L 1.00 45.00 L 0.00 59.00 L 5.00 67.00 L 9.00 67.00 L 21.00 54.00 L 39.00 61.00 L 42.00 56.00 L 63.00 53.00 L 83.00 69.00 L 95.00 66.00 L 114.00 73.00 L 128.00 73.00 L 146.00 60.00 L 156.00 41.00 L 177.00 23.00 Z",
      "province": "MOS",
      "rootTerritory": "MOS",
      "viewBox": "0 0 177 73",
      "unitSlots": [
        {
          "name": "main",
          "x": 98.69,
          "y": 38.06,
          "territory": "MOS",
          "arrowReceiver": {
            "x": 116.69,
            "y": 56.06
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 98.69,
          "y": 38.06,
          "territory": "MOS",
          "arrowReceiver": {
            "x": 116.69,
            "y": 56.06
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "BAN": {
    "territory": "BAN",
    "unitSlotName": "main",
    "province": "BAN",
    "provinceMapData": {
      "abbr": "BAN",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 72,
          "y": 36,
          "text": "Banda Sea"
        }
      ],
      "width": 144,
      "height": 72,
      "x": 455,
      "y": 393,
      "playable": true,
      "path": "M 0.00 54.00 L 21.00 53.00 L 52.00 43.00 L 57.00 54.00 L 68.00 62.00 L 74.00 58.00 L 77.00 66.00 L 86.00 66.00 L 92.00 59.00 L 101.00 65.00 L 96.00 68.00 L 98.00 72.00 L 114.00 67.00 L 124.00 69.00 L 131.00 50.00 L 128.00 44.00 L 135.00 31.00 L 144.00 48.00 L 144.00 16.00 L 137.00 17.00 L 131.00 13.00 L 121.00 26.00 L 100.00 28.00 L 102.00 20.00 L 95.00 8.00 L 89.00 11.00 L 74.00 8.00 L 70.00 12.00 L 64.00 8.00 L 69.00 2.00 L 60.00 0.00 L 49.00 3.00 L 47.00 8.00 L 35.00 5.00 L 18.00 20.00 L 23.00 33.00 L 16.00 38.00 L 10.00 32.00 Z",
      "province": "BAN",
      "rootTerritory": "BAN",
      "viewBox": "0 0 144 72",
      "unitSlots": [
        {
          "name": "main",
          "x": 77.58,
          "y": 35.89,
          "territory": "BAN",
          "arrowReceiver": {
            "x": 95.58,
            "y": 53.89
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 77.58,
          "y": 35.89,
          "territory": "BAN",
          "arrowReceiver": {
            "x": 95.58,
            "y": 53.89
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Banda Sea": {
    "territory": "BAN",
    "unitSlotName": "main",
    "province": "BAN",
    "provinceMapData": {
      "abbr": "BAN",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 72,
          "y": 36,
          "text": "Banda Sea"
        }
      ],
      "width": 144,
      "height": 72,
      "x": 455,
      "y": 393,
      "playable": true,
      "path": "M 0.00 54.00 L 21.00 53.00 L 52.00 43.00 L 57.00 54.00 L 68.00 62.00 L 74.00 58.00 L 77.00 66.00 L 86.00 66.00 L 92.00 59.00 L 101.00 65.00 L 96.00 68.00 L 98.00 72.00 L 114.00 67.00 L 124.00 69.00 L 131.00 50.00 L 128.00 44.00 L 135.00 31.00 L 144.00 48.00 L 144.00 16.00 L 137.00 17.00 L 131.00 13.00 L 121.00 26.00 L 100.00 28.00 L 102.00 20.00 L 95.00 8.00 L 89.00 11.00 L 74.00 8.00 L 70.00 12.00 L 64.00 8.00 L 69.00 2.00 L 60.00 0.00 L 49.00 3.00 L 47.00 8.00 L 35.00 5.00 L 18.00 20.00 L 23.00 33.00 L 16.00 38.00 L 10.00 32.00 Z",
      "province": "BAN",
      "rootTerritory": "BAN",
      "viewBox": "0 0 144 72",
      "unitSlots": [
        {
          "name": "main",
          "x": 77.58,
          "y": 35.89,
          "territory": "BAN",
          "arrowReceiver": {
            "x": 95.58,
            "y": 53.89
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 77.58,
          "y": 35.89,
          "territory": "BAN",
          "arrowReceiver": {
            "x": 95.58,
            "y": 53.89
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "TOB": {
    "territory": "TOB",
    "unitSlotName": "main",
    "province": "TOB",
    "provinceMapData": {
      "abbr": "TOB",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 55.5,
          "y": 56.5,
          "text": "Tobolsk"
        }
      ],
      "width": 111,
      "height": 113,
      "x": 165,
      "y": 0,
      "playable": true,
      "path": "M 97.00 0.00 L 90.00 2.00 L 85.00 19.00 L 70.00 11.00 L 69.00 24.00 L 48.00 42.00 L 30.00 69.00 L 1.00 76.00 L 0.00 86.00 L 5.00 96.00 L 26.00 100.00 L 39.00 93.00 L 64.00 96.00 L 74.00 92.00 L 94.00 113.00 L 98.00 111.00 L 111.00 87.00 L 106.00 71.00 L 95.00 61.00 L 98.00 38.00 L 89.00 28.00 L 93.00 24.00 L 90.00 11.00 Z",
      "province": "TOB",
      "rootTerritory": "TOB",
      "viewBox": "0 0 111 113",
      "unitSlots": [
        {
          "name": "main",
          "x": 64.54,
          "y": 66.94,
          "territory": "TOB",
          "arrowReceiver": {
            "x": 82.54,
            "y": 84.94
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 64.54,
          "y": 66.94,
          "territory": "TOB",
          "arrowReceiver": {
            "x": 82.54,
            "y": 84.94
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Tobolsk": {
    "territory": "TOB",
    "unitSlotName": "main",
    "province": "TOB",
    "provinceMapData": {
      "abbr": "TOB",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 55.5,
          "y": 56.5,
          "text": "Tobolsk"
        }
      ],
      "width": 111,
      "height": 113,
      "x": 165,
      "y": 0,
      "playable": true,
      "path": "M 97.00 0.00 L 90.00 2.00 L 85.00 19.00 L 70.00 11.00 L 69.00 24.00 L 48.00 42.00 L 30.00 69.00 L 1.00 76.00 L 0.00 86.00 L 5.00 96.00 L 26.00 100.00 L 39.00 93.00 L 64.00 96.00 L 74.00 92.00 L 94.00 113.00 L 98.00 111.00 L 111.00 87.00 L 106.00 71.00 L 95.00 61.00 L 98.00 38.00 L 89.00 28.00 L 93.00 24.00 L 90.00 11.00 Z",
      "province": "TOB",
      "rootTerritory": "TOB",
      "viewBox": "0 0 111 113",
      "unitSlots": [
        {
          "name": "main",
          "x": 64.54,
          "y": 66.94,
          "territory": "TOB",
          "arrowReceiver": {
            "x": 82.54,
            "y": 84.94
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 64.54,
          "y": 66.94,
          "territory": "TOB",
          "arrowReceiver": {
            "x": 82.54,
            "y": 84.94
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "BOB": {
    "territory": "BOB",
    "unitSlotName": "main",
    "province": "BOB",
    "provinceMapData": {
      "abbr": "BAY",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 42,
          "y": 53,
          "text": "Bay of Bengal"
        }
      ],
      "width": 84,
      "height": 106,
      "x": 235,
      "y": 294,
      "playable": true,
      "path": "M 45.00 3.00 L 40.00 14.00 L 8.00 43.00 L 0.00 76.00 L 6.00 78.00 L 9.00 74.00 L 18.00 84.00 L 54.00 100.00 L 83.00 106.00 L 84.00 100.00 L 76.00 93.00 L 70.00 69.00 L 73.00 44.00 L 82.00 30.00 L 80.00 17.00 L 69.00 9.00 L 65.00 1.00 L 59.00 0.00 L 54.00 5.00 Z",
      "province": "BOB",
      "rootTerritory": "BOB",
      "viewBox": "0 0 84 106",
      "unitSlots": [
        {
          "name": "main",
          "x": 45.99,
          "y": 54.06,
          "territory": "BOB",
          "arrowReceiver": {
            "x": 63.99,
            "y": 72.06
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 45.99,
          "y": 54.06,
          "territory": "BOB",
          "arrowReceiver": {
            "x": 63.99,
            "y": 72.06
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Bay of Bengal": {
    "territory": "BOB",
    "unitSlotName": "main",
    "province": "BOB",
    "provinceMapData": {
      "abbr": "BAY",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 42,
          "y": 53,
          "text": "Bay of Bengal"
        }
      ],
      "width": 84,
      "height": 106,
      "x": 235,
      "y": 294,
      "playable": true,
      "path": "M 45.00 3.00 L 40.00 14.00 L 8.00 43.00 L 0.00 76.00 L 6.00 78.00 L 9.00 74.00 L 18.00 84.00 L 54.00 100.00 L 83.00 106.00 L 84.00 100.00 L 76.00 93.00 L 70.00 69.00 L 73.00 44.00 L 82.00 30.00 L 80.00 17.00 L 69.00 9.00 L 65.00 1.00 L 59.00 0.00 L 54.00 5.00 Z",
      "province": "BOB",
      "rootTerritory": "BOB",
      "viewBox": "0 0 84 106",
      "unitSlots": [
        {
          "name": "main",
          "x": 45.99,
          "y": 54.06,
          "territory": "BOB",
          "arrowReceiver": {
            "x": 63.99,
            "y": 72.06
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 45.99,
          "y": 54.06,
          "territory": "BOB",
          "arrowReceiver": {
            "x": 63.99,
            "y": 72.06
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "ODE": {
    "territory": "ODE",
    "unitSlotName": "main",
    "province": "ODE",
    "provinceMapData": {
      "abbr": "UKR",
      "type": "Coast",
      "centerPos": {
        "x": 72.12,
        "y": 32.77
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 64.5,
          "y": 42,
          "text": "Ukraine"
        }
      ],
      "width": 129,
      "height": 84,
      "x": 39,
      "y": 54,
      "playable": true,
      "path": "M 1.00 13.00 L 3.00 22.00 L 0.00 28.00 L 16.00 35.00 L 19.00 41.00 L 30.00 35.00 L 31.00 27.00 L 36.00 25.00 L 43.00 32.00 L 44.00 45.00 L 49.00 43.00 L 49.00 37.00 L 70.00 45.00 L 69.00 49.00 L 56.00 50.00 L 55.00 53.00 L 80.00 84.00 L 97.00 63.00 L 111.00 67.00 L 113.00 53.00 L 128.00 40.00 L 124.00 32.00 L 128.00 16.00 L 101.00 15.00 L 81.00 0.00 L 71.00 4.00 L 60.00 3.00 L 57.00 8.00 L 39.00 1.00 L 26.00 14.00 L 15.00 4.00 L 10.00 4.00 Z",
      "province": "ODE",
      "rootTerritory": "ODE",
      "viewBox": "0 0 129 84",
      "unitSlots": [
        {
          "name": "main",
          "x": 72.12,
          "y": 32.77,
          "territory": "ODE",
          "arrowReceiver": {
            "x": 90.12,
            "y": 50.77
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 72.12,
          "y": 32.77,
          "territory": "ODE",
          "arrowReceiver": {
            "x": 90.12,
            "y": 50.77
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Ukraine": {
    "territory": "ODE",
    "unitSlotName": "main",
    "province": "ODE",
    "provinceMapData": {
      "abbr": "UKR",
      "type": "Coast",
      "centerPos": {
        "x": 72.12,
        "y": 32.77
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 64.5,
          "y": 42,
          "text": "Ukraine"
        }
      ],
      "width": 129,
      "height": 84,
      "x": 39,
      "y": 54,
      "playable": true,
      "path": "M 1.00 13.00 L 3.00 22.00 L 0.00 28.00 L 16.00 35.00 L 19.00 41.00 L 30.00 35.00 L 31.00 27.00 L 36.00 25.00 L 43.00 32.00 L 44.00 45.00 L 49.00 43.00 L 49.00 37.00 L 70.00 45.00 L 69.00 49.00 L 56.00 50.00 L 55.00 53.00 L 80.00 84.00 L 97.00 63.00 L 111.00 67.00 L 113.00 53.00 L 128.00 40.00 L 124.00 32.00 L 128.00 16.00 L 101.00 15.00 L 81.00 0.00 L 71.00 4.00 L 60.00 3.00 L 57.00 8.00 L 39.00 1.00 L 26.00 14.00 L 15.00 4.00 L 10.00 4.00 Z",
      "province": "ODE",
      "rootTerritory": "ODE",
      "viewBox": "0 0 129 84",
      "unitSlots": [
        {
          "name": "main",
          "x": 72.12,
          "y": 32.77,
          "territory": "ODE",
          "arrowReceiver": {
            "x": 90.12,
            "y": 50.77
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 72.12,
          "y": 32.77,
          "territory": "ODE",
          "arrowReceiver": {
            "x": 90.12,
            "y": 50.77
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "CSE": {
    "territory": "CSE",
    "unitSlotName": "main",
    "province": "CSE",
    "provinceMapData": {
      "abbr": "CEL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 68.5,
          "y": 35.5,
          "text": "Celebes Sea"
        }
      ],
      "width": 137,
      "height": 71,
      "x": 462,
      "y": 336,
      "playable": true,
      "path": "M 137.00 0.00 L 91.00 9.00 L 40.00 12.00 L 37.00 18.00 L 33.00 16.00 L 28.00 22.00 L 17.00 18.00 L 8.00 21.00 L 3.00 28.00 L 20.00 38.00 L 29.00 50.00 L 3.00 64.00 L 0.00 70.00 L 7.00 71.00 L 12.00 66.00 L 34.00 61.00 L 36.00 56.00 L 49.00 58.00 L 58.00 49.00 L 66.00 50.00 L 68.00 46.00 L 74.00 49.00 L 71.00 59.00 L 79.00 62.00 L 92.00 45.00 L 105.00 46.00 L 109.00 43.00 L 121.00 46.00 L 127.00 54.00 L 137.00 57.00 Z",
      "province": "CSE",
      "rootTerritory": "CSE",
      "viewBox": "0 0 137 71",
      "unitSlots": [
        {
          "name": "main",
          "x": 77.06,
          "y": 31.57,
          "territory": "CSE",
          "arrowReceiver": {
            "x": 95.06,
            "y": 49.57
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 77.06,
          "y": 31.57,
          "territory": "CSE",
          "arrowReceiver": {
            "x": 95.06,
            "y": 49.57
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Celebes Sea": {
    "territory": "CSE",
    "unitSlotName": "main",
    "province": "CSE",
    "provinceMapData": {
      "abbr": "CEL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 68.5,
          "y": 35.5,
          "text": "Celebes Sea"
        }
      ],
      "width": 137,
      "height": 71,
      "x": 462,
      "y": 336,
      "playable": true,
      "path": "M 137.00 0.00 L 91.00 9.00 L 40.00 12.00 L 37.00 18.00 L 33.00 16.00 L 28.00 22.00 L 17.00 18.00 L 8.00 21.00 L 3.00 28.00 L 20.00 38.00 L 29.00 50.00 L 3.00 64.00 L 0.00 70.00 L 7.00 71.00 L 12.00 66.00 L 34.00 61.00 L 36.00 56.00 L 49.00 58.00 L 58.00 49.00 L 66.00 50.00 L 68.00 46.00 L 74.00 49.00 L 71.00 59.00 L 79.00 62.00 L 92.00 45.00 L 105.00 46.00 L 109.00 43.00 L 121.00 46.00 L 127.00 54.00 L 137.00 57.00 Z",
      "province": "CSE",
      "rootTerritory": "CSE",
      "viewBox": "0 0 137 71",
      "unitSlots": [
        {
          "name": "main",
          "x": 77.06,
          "y": 31.57,
          "territory": "CSE",
          "arrowReceiver": {
            "x": 95.06,
            "y": 49.57
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 77.06,
          "y": 31.57,
          "territory": "CSE",
          "arrowReceiver": {
            "x": 95.06,
            "y": 49.57
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "TUR": {
    "territory": "TUR",
    "unitSlotName": "main",
    "province": "TUR",
    "provinceMapData": {
      "abbr": "TUR",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 38,
          "y": 52,
          "text": "Turkestan"
        }
      ],
      "width": 76,
      "height": 104,
      "x": 138,
      "y": 94,
      "playable": true,
      "path": "M 71.00 0.00 L 53.00 6.00 L 24.00 3.00 L 12.00 17.00 L 13.00 24.00 L 22.00 35.00 L 18.00 47.00 L 2.00 48.00 L 9.00 66.00 L 0.00 69.00 L 1.00 78.00 L 17.00 83.00 L 28.00 104.00 L 49.00 95.00 L 66.00 101.00 L 73.00 96.00 L 75.00 85.00 L 67.00 78.00 L 69.00 73.00 L 66.00 71.00 L 71.00 51.00 L 69.00 40.00 L 76.00 27.00 L 71.00 13.00 L 74.00 2.00 Z",
      "province": "TUR",
      "rootTerritory": "TUR",
      "viewBox": "0 0 76 104",
      "unitSlots": [
        {
          "name": "main",
          "x": 42.21,
          "y": 51.44,
          "territory": "TUR",
          "arrowReceiver": {
            "x": 60.21,
            "y": 69.44
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42.21,
          "y": 51.44,
          "territory": "TUR",
          "arrowReceiver": {
            "x": 60.21,
            "y": 69.44
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Turkestan": {
    "territory": "TUR",
    "unitSlotName": "main",
    "province": "TUR",
    "provinceMapData": {
      "abbr": "TUR",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 38,
          "y": 52,
          "text": "Turkestan"
        }
      ],
      "width": 76,
      "height": 104,
      "x": 138,
      "y": 94,
      "playable": true,
      "path": "M 71.00 0.00 L 53.00 6.00 L 24.00 3.00 L 12.00 17.00 L 13.00 24.00 L 22.00 35.00 L 18.00 47.00 L 2.00 48.00 L 9.00 66.00 L 0.00 69.00 L 1.00 78.00 L 17.00 83.00 L 28.00 104.00 L 49.00 95.00 L 66.00 101.00 L 73.00 96.00 L 75.00 85.00 L 67.00 78.00 L 69.00 73.00 L 66.00 71.00 L 71.00 51.00 L 69.00 40.00 L 76.00 27.00 L 71.00 13.00 L 74.00 2.00 Z",
      "province": "TUR",
      "rootTerritory": "TUR",
      "viewBox": "0 0 76 104",
      "unitSlots": [
        {
          "name": "main",
          "x": 42.21,
          "y": 51.44,
          "territory": "TUR",
          "arrowReceiver": {
            "x": 60.21,
            "y": 69.44
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42.21,
          "y": 51.44,
          "territory": "TUR",
          "arrowReceiver": {
            "x": 60.21,
            "y": 69.44
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "ASE": {
    "territory": "ASE",
    "unitSlotName": "main",
    "province": "ASE",
    "provinceMapData": {
      "abbr": "ARA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 37.5,
          "y": 48.5,
          "text": "Arabian Sea"
        }
      ],
      "width": 75,
      "height": 97,
      "x": 130,
      "y": 260,
      "playable": true,
      "path": "M 56.00 2.00 L 41.00 0.00 L 41.00 17.00 L 36.00 21.00 L 21.00 22.00 L 3.00 41.00 L 2.00 69.00 L 13.00 90.00 L 20.00 94.00 L 47.00 95.00 L 64.00 85.00 L 75.00 72.00 L 68.00 50.00 L 71.00 37.00 L 54.00 21.00 L 58.00 18.00 L 54.00 14.00 Z",
      "province": "ASE",
      "rootTerritory": "ASE",
      "viewBox": "0 0 75 97",
      "unitSlots": [
        {
          "name": "main",
          "x": 37.58,
          "y": 55.36,
          "territory": "ASE",
          "arrowReceiver": {
            "x": 55.58,
            "y": 73.36
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37.58,
          "y": 55.36,
          "territory": "ASE",
          "arrowReceiver": {
            "x": 55.58,
            "y": 73.36
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Arabian Sea": {
    "territory": "ASE",
    "unitSlotName": "main",
    "province": "ASE",
    "provinceMapData": {
      "abbr": "ARA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 37.5,
          "y": 48.5,
          "text": "Arabian Sea"
        }
      ],
      "width": 75,
      "height": 97,
      "x": 130,
      "y": 260,
      "playable": true,
      "path": "M 56.00 2.00 L 41.00 0.00 L 41.00 17.00 L 36.00 21.00 L 21.00 22.00 L 3.00 41.00 L 2.00 69.00 L 13.00 90.00 L 20.00 94.00 L 47.00 95.00 L 64.00 85.00 L 75.00 72.00 L 68.00 50.00 L 71.00 37.00 L 54.00 21.00 L 58.00 18.00 L 54.00 14.00 Z",
      "province": "ASE",
      "rootTerritory": "ASE",
      "viewBox": "0 0 75 97",
      "unitSlots": [
        {
          "name": "main",
          "x": 37.58,
          "y": 55.36,
          "territory": "ASE",
          "arrowReceiver": {
            "x": 55.58,
            "y": 73.36
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37.58,
          "y": 55.36,
          "territory": "ASE",
          "arrowReceiver": {
            "x": 55.58,
            "y": 73.36
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "KIR": {
    "territory": "KIR",
    "unitSlotName": "main",
    "province": "KIR",
    "provinceMapData": {
      "abbr": "KIR",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 35.5,
          "y": 51,
          "text": "Kirghiz"
        }
      ],
      "width": 71,
      "height": 102,
      "x": 205,
      "y": 93,
      "playable": true,
      "path": "M 35.00 0.00 L 10.00 2.00 L 4.00 11.00 L 10.00 27.00 L 2.00 42.00 L 5.00 59.00 L 0.00 72.00 L 8.00 85.00 L 6.00 97.00 L 12.00 101.00 L 21.00 101.00 L 15.00 92.00 L 16.00 86.00 L 30.00 89.00 L 53.00 76.00 L 54.00 61.00 L 66.00 51.00 L 66.00 44.00 L 71.00 41.00 Z",
      "province": "KIR",
      "rootTerritory": "KIR",
      "viewBox": "0 0 71 102",
      "unitSlots": [
        {
          "name": "main",
          "x": 30.39,
          "y": 46.12,
          "territory": "KIR",
          "arrowReceiver": {
            "x": 48.39,
            "y": 64.12
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30.39,
          "y": 46.12,
          "territory": "KIR",
          "arrowReceiver": {
            "x": 48.39,
            "y": 64.12
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Kirghiz": {
    "territory": "KIR",
    "unitSlotName": "main",
    "province": "KIR",
    "provinceMapData": {
      "abbr": "KIR",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 35.5,
          "y": 51,
          "text": "Kirghiz"
        }
      ],
      "width": 71,
      "height": 102,
      "x": 205,
      "y": 93,
      "playable": true,
      "path": "M 35.00 0.00 L 10.00 2.00 L 4.00 11.00 L 10.00 27.00 L 2.00 42.00 L 5.00 59.00 L 0.00 72.00 L 8.00 85.00 L 6.00 97.00 L 12.00 101.00 L 21.00 101.00 L 15.00 92.00 L 16.00 86.00 L 30.00 89.00 L 53.00 76.00 L 54.00 61.00 L 66.00 51.00 L 66.00 44.00 L 71.00 41.00 Z",
      "province": "KIR",
      "rootTerritory": "KIR",
      "viewBox": "0 0 71 102",
      "unitSlots": [
        {
          "name": "main",
          "x": 30.39,
          "y": 46.12,
          "territory": "KIR",
          "arrowReceiver": {
            "x": 48.39,
            "y": 64.12
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30.39,
          "y": 46.12,
          "territory": "KIR",
          "arrowReceiver": {
            "x": 48.39,
            "y": 64.12
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "CAN": {
    "territory": "CAN",
    "unitSlotName": "main",
    "province": "CAN",
    "provinceMapData": {
      "abbr": "CAN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 64.5,
          "y": 35.5,
          "text": "Canton"
        }
      ],
      "width": 129,
      "height": 71,
      "x": 319,
      "y": 224,
      "playable": true,
      "path": "M 128.00 1.00 L 123.00 0.00 L 116.00 6.00 L 106.00 4.00 L 103.00 8.00 L 94.00 4.00 L 86.00 12.00 L 64.00 7.00 L 59.00 19.00 L 54.00 21.00 L 53.00 27.00 L 47.00 28.00 L 40.00 41.00 L 16.00 22.00 L 16.00 12.00 L 6.00 17.00 L 0.00 30.00 L 3.00 33.00 L 14.00 31.00 L 21.00 38.00 L 15.00 61.00 L 23.00 60.00 L 44.00 71.00 L 53.00 59.00 L 70.00 63.00 L 73.00 56.00 L 79.00 56.00 L 81.00 62.00 L 91.00 57.00 L 92.00 40.00 L 102.00 32.00 L 120.00 39.00 L 119.00 32.00 L 123.00 30.00 L 127.00 16.00 L 117.00 16.00 L 116.00 13.00 L 125.00 12.00 L 129.00 8.00 Z",
      "province": "CAN",
      "rootTerritory": "CAN",
      "viewBox": "0 0 129 71",
      "unitSlots": [
        {
          "name": "main",
          "x": 67.53,
          "y": 34.74,
          "territory": "CAN",
          "arrowReceiver": {
            "x": 85.53,
            "y": 52.74
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 67.53,
          "y": 34.74,
          "territory": "CAN",
          "arrowReceiver": {
            "x": 85.53,
            "y": 52.74
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Canton": {
    "territory": "CAN",
    "unitSlotName": "main",
    "province": "CAN",
    "provinceMapData": {
      "abbr": "CAN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 64.5,
          "y": 35.5,
          "text": "Canton"
        }
      ],
      "width": 129,
      "height": 71,
      "x": 319,
      "y": 224,
      "playable": true,
      "path": "M 128.00 1.00 L 123.00 0.00 L 116.00 6.00 L 106.00 4.00 L 103.00 8.00 L 94.00 4.00 L 86.00 12.00 L 64.00 7.00 L 59.00 19.00 L 54.00 21.00 L 53.00 27.00 L 47.00 28.00 L 40.00 41.00 L 16.00 22.00 L 16.00 12.00 L 6.00 17.00 L 0.00 30.00 L 3.00 33.00 L 14.00 31.00 L 21.00 38.00 L 15.00 61.00 L 23.00 60.00 L 44.00 71.00 L 53.00 59.00 L 70.00 63.00 L 73.00 56.00 L 79.00 56.00 L 81.00 62.00 L 91.00 57.00 L 92.00 40.00 L 102.00 32.00 L 120.00 39.00 L 119.00 32.00 L 123.00 30.00 L 127.00 16.00 L 117.00 16.00 L 116.00 13.00 L 125.00 12.00 L 129.00 8.00 Z",
      "province": "CAN",
      "rootTerritory": "CAN",
      "viewBox": "0 0 129 71",
      "unitSlots": [
        {
          "name": "main",
          "x": 67.53,
          "y": 34.74,
          "territory": "CAN",
          "arrowReceiver": {
            "x": 85.53,
            "y": 52.74
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 67.53,
          "y": 34.74,
          "territory": "CAN",
          "arrowReceiver": {
            "x": 85.53,
            "y": 52.74
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "PER": {
    "territory": "PER",
    "unitSlotName": "main",
    "province": "PER",
    "provinceMapData": {
      "abbr": "PER",
      "type": "Coast",
      "centerPos": {
        "x": 35.68,
        "y": 55.52
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 34.5,
          "y": 55,
          "text": "Persia"
        }
      ],
      "width": 69,
      "height": 110,
      "x": 95,
      "y": 147,
      "playable": true,
      "path": "M 8.00 0.00 L 5.00 9.00 L 9.00 23.00 L 0.00 32.00 L 0.00 40.00 L 5.00 45.00 L 2.00 57.00 L 12.00 60.00 L 25.00 89.00 L 35.00 86.00 L 57.00 110.00 L 66.00 96.00 L 57.00 79.00 L 64.00 71.00 L 69.00 44.00 L 53.00 27.00 L 35.00 29.00 L 26.00 24.00 L 22.00 8.00 L 16.00 8.00 Z",
      "province": "PER",
      "rootTerritory": "PER",
      "viewBox": "0 0 69 110",
      "unitSlots": [
        {
          "name": "main",
          "x": 35.68,
          "y": 55.52,
          "territory": "PER",
          "arrowReceiver": {
            "x": 53.68,
            "y": 73.52
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35.68,
          "y": 55.52,
          "territory": "PER",
          "arrowReceiver": {
            "x": 53.68,
            "y": 73.52
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Persia": {
    "territory": "PER",
    "unitSlotName": "main",
    "province": "PER",
    "provinceMapData": {
      "abbr": "PER",
      "type": "Coast",
      "centerPos": {
        "x": 35.68,
        "y": 55.52
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 34.5,
          "y": 55,
          "text": "Persia"
        }
      ],
      "width": 69,
      "height": 110,
      "x": 95,
      "y": 147,
      "playable": true,
      "path": "M 8.00 0.00 L 5.00 9.00 L 9.00 23.00 L 0.00 32.00 L 0.00 40.00 L 5.00 45.00 L 2.00 57.00 L 12.00 60.00 L 25.00 89.00 L 35.00 86.00 L 57.00 110.00 L 66.00 96.00 L 57.00 79.00 L 64.00 71.00 L 69.00 44.00 L 53.00 27.00 L 35.00 29.00 L 26.00 24.00 L 22.00 8.00 L 16.00 8.00 Z",
      "province": "PER",
      "rootTerritory": "PER",
      "viewBox": "0 0 69 110",
      "unitSlots": [
        {
          "name": "main",
          "x": 35.68,
          "y": 55.52,
          "territory": "PER",
          "arrowReceiver": {
            "x": 53.68,
            "y": 73.52
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35.68,
          "y": 55.52,
          "territory": "PER",
          "arrowReceiver": {
            "x": 53.68,
            "y": 73.52
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "GOB": {
    "territory": "GOB",
    "unitSlotName": "main",
    "province": "GOB",
    "provinceMapData": {
      "abbr": "GOB",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 58.5,
          "y": 29,
          "text": "Gobi Desert"
        }
      ],
      "width": 117,
      "height": 58,
      "x": 254,
      "y": 157,
      "playable": true,
      "path": "M 0.00 16.00 L 12.00 26.00 L 29.00 28.00 L 41.00 40.00 L 39.00 44.00 L 25.00 44.00 L 29.00 54.00 L 56.00 50.00 L 62.00 58.00 L 68.00 58.00 L 80.00 49.00 L 102.00 47.00 L 101.00 41.00 L 111.00 33.00 L 117.00 12.00 L 99.00 9.00 L 84.00 15.00 L 64.00 0.00 L 54.00 6.00 L 37.00 0.00 L 35.00 6.00 L 29.00 3.00 L 16.00 11.00 L 6.00 10.00 Z",
      "province": "GOB",
      "rootTerritory": "GOB",
      "viewBox": "0 0 117 58",
      "unitSlots": [
        {
          "name": "main",
          "x": 62.04,
          "y": 27.08,
          "territory": "GOB",
          "arrowReceiver": {
            "x": 80.04,
            "y": 45.08
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 62.04,
          "y": 27.08,
          "territory": "GOB",
          "arrowReceiver": {
            "x": 80.04,
            "y": 45.08
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Gobi Desert": {
    "territory": "GOB",
    "unitSlotName": "main",
    "province": "GOB",
    "provinceMapData": {
      "abbr": "GOB",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 58.5,
          "y": 29,
          "text": "Gobi Desert"
        }
      ],
      "width": 117,
      "height": 58,
      "x": 254,
      "y": 157,
      "playable": true,
      "path": "M 0.00 16.00 L 12.00 26.00 L 29.00 28.00 L 41.00 40.00 L 39.00 44.00 L 25.00 44.00 L 29.00 54.00 L 56.00 50.00 L 62.00 58.00 L 68.00 58.00 L 80.00 49.00 L 102.00 47.00 L 101.00 41.00 L 111.00 33.00 L 117.00 12.00 L 99.00 9.00 L 84.00 15.00 L 64.00 0.00 L 54.00 6.00 L 37.00 0.00 L 35.00 6.00 L 29.00 3.00 L 16.00 11.00 L 6.00 10.00 Z",
      "province": "GOB",
      "rootTerritory": "GOB",
      "viewBox": "0 0 117 58",
      "unitSlots": [
        {
          "name": "main",
          "x": 62.04,
          "y": 27.08,
          "territory": "GOB",
          "arrowReceiver": {
            "x": 80.04,
            "y": 45.08
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 62.04,
          "y": 27.08,
          "territory": "GOB",
          "arrowReceiver": {
            "x": 80.04,
            "y": 45.08
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_25": {
    "territory": "REGION_25",
    "unitSlotName": "main",
    "province": "REGION_25",
    "provinceMapData": {
      "abbr": "REG",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 61.5,
          "y": 36.5,
          "text": "REGION_25"
        }
      ],
      "width": 123,
      "height": 73,
      "x": 476,
      "y": 426,
      "playable": true,
      "path": "M 116.00 1.00 L 112.00 1.00 L 109.00 10.00 L 112.00 16.00 L 102.00 37.00 L 89.00 35.00 L 71.00 41.00 L 67.00 33.00 L 54.00 33.00 L 49.00 38.00 L 50.00 48.00 L 43.00 44.00 L 34.00 45.00 L 23.00 61.00 L 0.00 73.00 L 123.00 73.00 L 123.00 16.00 Z",
      "province": "REGION_25",
      "rootTerritory": "REGION_25",
      "viewBox": "0 0 123 73",
      "unitSlots": [
        {
          "name": "main",
          "x": 78.68,
          "y": 52.06,
          "territory": "REGION_25",
          "arrowReceiver": {
            "x": 96.68,
            "y": 70.06
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 78.68,
          "y": 52.06,
          "territory": "REGION_25",
          "arrowReceiver": {
            "x": 96.68,
            "y": 70.06
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "SOO": {
    "territory": "SOO",
    "unitSlotName": "main",
    "province": "SOO",
    "provinceMapData": {
      "abbr": "SEA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 42.5,
          "y": 52.5,
          "text": "Sea of Okhotsk"
        }
      ],
      "width": 85,
      "height": 105,
      "x": 435,
      "y": 0,
      "playable": true,
      "path": "M 42.00 0.00 L 38.00 5.00 L 41.00 20.00 L 31.00 17.00 L 27.00 32.00 L 17.00 39.00 L 7.00 40.00 L 0.00 65.00 L 22.00 65.00 L 27.00 60.00 L 36.00 79.00 L 39.00 78.00 L 36.00 68.00 L 52.00 78.00 L 50.00 84.00 L 61.00 95.00 L 57.00 102.00 L 69.00 105.00 L 74.00 102.00 L 85.00 80.00 L 83.00 62.00 L 76.00 59.00 L 79.00 53.00 L 58.00 37.00 L 47.00 10.00 L 50.00 0.00 Z",
      "province": "SOO",
      "rootTerritory": "SOO",
      "viewBox": "0 0 85 105",
      "unitSlots": [
        {
          "name": "main",
          "x": 47.07,
          "y": 56.07,
          "territory": "SOO",
          "arrowReceiver": {
            "x": 65.07,
            "y": 74.07
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 47.07,
          "y": 56.07,
          "territory": "SOO",
          "arrowReceiver": {
            "x": 65.07,
            "y": 74.07
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Sea of Okhotsk": {
    "territory": "SOO",
    "unitSlotName": "main",
    "province": "SOO",
    "provinceMapData": {
      "abbr": "SEA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 42.5,
          "y": 52.5,
          "text": "Sea of Okhotsk"
        }
      ],
      "width": 85,
      "height": 105,
      "x": 435,
      "y": 0,
      "playable": true,
      "path": "M 42.00 0.00 L 38.00 5.00 L 41.00 20.00 L 31.00 17.00 L 27.00 32.00 L 17.00 39.00 L 7.00 40.00 L 0.00 65.00 L 22.00 65.00 L 27.00 60.00 L 36.00 79.00 L 39.00 78.00 L 36.00 68.00 L 52.00 78.00 L 50.00 84.00 L 61.00 95.00 L 57.00 102.00 L 69.00 105.00 L 74.00 102.00 L 85.00 80.00 L 83.00 62.00 L 76.00 59.00 L 79.00 53.00 L 58.00 37.00 L 47.00 10.00 L 50.00 0.00 Z",
      "province": "SOO",
      "rootTerritory": "SOO",
      "viewBox": "0 0 85 105",
      "unitSlots": [
        {
          "name": "main",
          "x": 47.07,
          "y": 56.07,
          "territory": "SOO",
          "arrowReceiver": {
            "x": 65.07,
            "y": 74.07
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 47.07,
          "y": 56.07,
          "territory": "SOO",
          "arrowReceiver": {
            "x": 65.07,
            "y": 74.07
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "OKH": {
    "territory": "OKH",
    "unitSlotName": "main",
    "province": "OKH",
    "provinceMapData": {
      "abbr": "YAK",
      "type": "Coast",
      "centerPos": {
        "x": 44,
        "y": 22.38
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 34,
          "text": "Yakutsk"
        }
      ],
      "width": 94,
      "height": 68,
      "x": 382,
      "y": 0,
      "playable": true,
      "path": "M 0.00 20.00 L 5.00 33.00 L 24.00 36.00 L 36.00 48.00 L 29.00 62.00 L 37.00 68.00 L 43.00 62.00 L 56.00 58.00 L 55.00 49.00 L 62.00 32.00 L 71.00 37.00 L 80.00 31.00 L 85.00 15.00 L 92.00 17.00 L 91.00 4.00 L 94.00 0.00 L 4.00 0.00 Z",
      "province": "OKH",
      "rootTerritory": "OKH",
      "viewBox": "0 0 94 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 44,
          "y": 22.38,
          "territory": "OKH",
          "arrowReceiver": {
            "x": 62,
            "y": 40.38
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 44,
          "y": 22.38,
          "territory": "OKH",
          "arrowReceiver": {
            "x": 62,
            "y": 40.38
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Yakutsk": {
    "territory": "OKH",
    "unitSlotName": "main",
    "province": "OKH",
    "provinceMapData": {
      "abbr": "YAK",
      "type": "Coast",
      "centerPos": {
        "x": 44,
        "y": 22.38
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 34,
          "text": "Yakutsk"
        }
      ],
      "width": 94,
      "height": 68,
      "x": 382,
      "y": 0,
      "playable": true,
      "path": "M 0.00 20.00 L 5.00 33.00 L 24.00 36.00 L 36.00 48.00 L 29.00 62.00 L 37.00 68.00 L 43.00 62.00 L 56.00 58.00 L 55.00 49.00 L 62.00 32.00 L 71.00 37.00 L 80.00 31.00 L 85.00 15.00 L 92.00 17.00 L 91.00 4.00 L 94.00 0.00 L 4.00 0.00 Z",
      "province": "OKH",
      "rootTerritory": "OKH",
      "viewBox": "0 0 94 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 44,
          "y": 22.38,
          "territory": "OKH",
          "arrowReceiver": {
            "x": 62,
            "y": 40.38
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 44,
          "y": 22.38,
          "territory": "OKH",
          "arrowReceiver": {
            "x": 62,
            "y": 40.38
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "SHA": {
    "territory": "SHA",
    "unitSlotName": "main",
    "province": "SHA",
    "provinceMapData": {
      "abbr": "SHA",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 57,
          "y": 44,
          "text": "Shanghai"
        }
      ],
      "width": 114,
      "height": 88,
      "x": 333,
      "y": 177,
      "playable": true,
      "path": "M 101.00 1.00 L 88.00 3.00 L 85.00 16.00 L 77.00 26.00 L 49.00 34.00 L 34.00 32.00 L 13.00 47.00 L 1.00 45.00 L 0.00 51.00 L 5.00 60.00 L 2.00 69.00 L 26.00 88.00 L 26.00 81.00 L 33.00 79.00 L 33.00 73.00 L 40.00 72.00 L 49.00 52.00 L 71.00 59.00 L 80.00 50.00 L 87.00 54.00 L 92.00 50.00 L 102.00 53.00 L 113.00 46.00 L 110.00 33.00 L 95.00 22.00 Z",
      "province": "SHA",
      "rootTerritory": "SHA",
      "viewBox": "0 0 114 88",
      "unitSlots": [
        {
          "name": "main",
          "x": 54.42,
          "y": 46.56,
          "territory": "SHA",
          "arrowReceiver": {
            "x": 72.42,
            "y": 64.56
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 54.42,
          "y": 46.56,
          "territory": "SHA",
          "arrowReceiver": {
            "x": 72.42,
            "y": 64.56
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Shanghai": {
    "territory": "SHA",
    "unitSlotName": "main",
    "province": "SHA",
    "provinceMapData": {
      "abbr": "SHA",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 57,
          "y": 44,
          "text": "Shanghai"
        }
      ],
      "width": 114,
      "height": 88,
      "x": 333,
      "y": 177,
      "playable": true,
      "path": "M 101.00 1.00 L 88.00 3.00 L 85.00 16.00 L 77.00 26.00 L 49.00 34.00 L 34.00 32.00 L 13.00 47.00 L 1.00 45.00 L 0.00 51.00 L 5.00 60.00 L 2.00 69.00 L 26.00 88.00 L 26.00 81.00 L 33.00 79.00 L 33.00 73.00 L 40.00 72.00 L 49.00 52.00 L 71.00 59.00 L 80.00 50.00 L 87.00 54.00 L 92.00 50.00 L 102.00 53.00 L 113.00 46.00 L 110.00 33.00 L 95.00 22.00 Z",
      "province": "SHA",
      "rootTerritory": "SHA",
      "viewBox": "0 0 114 88",
      "unitSlots": [
        {
          "name": "main",
          "x": 54.42,
          "y": 46.56,
          "territory": "SHA",
          "arrowReceiver": {
            "x": 72.42,
            "y": 64.56
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 54.42,
          "y": 46.56,
          "territory": "SHA",
          "arrowReceiver": {
            "x": 72.42,
            "y": 64.56
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "TIB": {
    "territory": "TIB",
    "unitSlotName": "main",
    "province": "TIB",
    "provinceMapData": {
      "abbr": "TIB",
      "type": "Land",
      "centerPos": {
        "x": 50.61,
        "y": 23.13
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 23.5,
          "text": "Tibet"
        }
      ],
      "width": 98,
      "height": 47,
      "x": 237,
      "y": 207,
      "playable": true,
      "path": "M 98.00 28.00 L 93.00 14.00 L 79.00 8.00 L 72.00 0.00 L 60.00 6.00 L 56.00 2.00 L 51.00 5.00 L 41.00 3.00 L 9.00 10.00 L 0.00 21.00 L 9.00 33.00 L 27.00 37.00 L 42.00 47.00 L 58.00 42.00 L 80.00 44.00 L 88.00 33.00 Z",
      "province": "TIB",
      "rootTerritory": "TIB",
      "viewBox": "0 0 98 47",
      "unitSlots": [
        {
          "name": "main",
          "x": 50.61,
          "y": 23.13,
          "territory": "TIB",
          "arrowReceiver": {
            "x": 68.61,
            "y": 41.13
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 50.61,
          "y": 23.13,
          "territory": "TIB",
          "arrowReceiver": {
            "x": 68.61,
            "y": 41.13
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Tibet": {
    "territory": "TIB",
    "unitSlotName": "main",
    "province": "TIB",
    "provinceMapData": {
      "abbr": "TIB",
      "type": "Land",
      "centerPos": {
        "x": 50.61,
        "y": 23.13
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 23.5,
          "text": "Tibet"
        }
      ],
      "width": 98,
      "height": 47,
      "x": 237,
      "y": 207,
      "playable": true,
      "path": "M 98.00 28.00 L 93.00 14.00 L 79.00 8.00 L 72.00 0.00 L 60.00 6.00 L 56.00 2.00 L 51.00 5.00 L 41.00 3.00 L 9.00 10.00 L 0.00 21.00 L 9.00 33.00 L 27.00 37.00 L 42.00 47.00 L 58.00 42.00 L 80.00 44.00 L 88.00 33.00 Z",
      "province": "TIB",
      "rootTerritory": "TIB",
      "viewBox": "0 0 98 47",
      "unitSlots": [
        {
          "name": "main",
          "x": 50.61,
          "y": 23.13,
          "territory": "TIB",
          "arrowReceiver": {
            "x": 68.61,
            "y": 41.13
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 50.61,
          "y": 23.13,
          "territory": "TIB",
          "arrowReceiver": {
            "x": 68.61,
            "y": 41.13
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "AMU": {
    "territory": "AMU",
    "unitSlotName": "main",
    "province": "AMU",
    "provinceMapData": {
      "abbr": "AMU",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 41,
          "y": 39.5,
          "text": "Amur"
        }
      ],
      "width": 82,
      "height": 79,
      "x": 396,
      "y": 61,
      "playable": true,
      "path": "M 0.00 28.00 L 5.00 32.00 L 16.00 27.00 L 32.00 45.00 L 39.00 43.00 L 51.00 51.00 L 61.00 44.00 L 63.00 58.00 L 56.00 73.00 L 60.00 79.00 L 79.00 71.00 L 82.00 57.00 L 77.00 44.00 L 82.00 28.00 L 66.00 6.00 L 52.00 3.00 L 35.00 9.00 L 38.00 1.00 L 32.00 0.00 L 15.00 19.00 Z",
      "province": "AMU",
      "rootTerritory": "AMU",
      "viewBox": "0 0 82 79",
      "unitSlots": [
        {
          "name": "main",
          "x": 51.15,
          "y": 32.49,
          "territory": "AMU",
          "arrowReceiver": {
            "x": 69.15,
            "y": 50.49
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51.15,
          "y": 32.49,
          "territory": "AMU",
          "arrowReceiver": {
            "x": 69.15,
            "y": 50.49
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Amur": {
    "territory": "AMU",
    "unitSlotName": "main",
    "province": "AMU",
    "provinceMapData": {
      "abbr": "AMU",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 41,
          "y": 39.5,
          "text": "Amur"
        }
      ],
      "width": 82,
      "height": 79,
      "x": 396,
      "y": 61,
      "playable": true,
      "path": "M 0.00 28.00 L 5.00 32.00 L 16.00 27.00 L 32.00 45.00 L 39.00 43.00 L 51.00 51.00 L 61.00 44.00 L 63.00 58.00 L 56.00 73.00 L 60.00 79.00 L 79.00 71.00 L 82.00 57.00 L 77.00 44.00 L 82.00 28.00 L 66.00 6.00 L 52.00 3.00 L 35.00 9.00 L 38.00 1.00 L 32.00 0.00 L 15.00 19.00 Z",
      "province": "AMU",
      "rootTerritory": "AMU",
      "viewBox": "0 0 82 79",
      "unitSlots": [
        {
          "name": "main",
          "x": 51.15,
          "y": 32.49,
          "territory": "AMU",
          "arrowReceiver": {
            "x": 69.15,
            "y": 50.49
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51.15,
          "y": 32.49,
          "territory": "AMU",
          "arrowReceiver": {
            "x": 69.15,
            "y": 50.49
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "BOR": {
    "territory": "BOR",
    "unitSlotName": "main",
    "province": "BOR",
    "provinceMapData": {
      "abbr": "BOR",
      "type": "Coast",
      "centerPos": {
        "x": 61.7,
        "y": 40.24
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 59,
          "y": 32,
          "text": "Borneo"
        }
      ],
      "width": 118,
      "height": 64,
      "x": 342,
      "y": 387,
      "playable": true,
      "path": "M 0.00 18.00 L 22.00 43.00 L 40.00 42.00 L 43.00 45.00 L 36.00 48.00 L 36.00 55.00 L 42.00 58.00 L 62.00 57.00 L 91.00 64.00 L 110.00 60.00 L 118.00 48.00 L 114.00 35.00 L 93.00 39.00 L 85.00 36.00 L 75.00 39.00 L 72.00 35.00 L 64.00 37.00 L 62.00 32.00 L 58.00 33.00 L 42.00 20.00 L 29.00 0.00 L 24.00 6.00 L 24.00 33.00 L 15.00 29.00 L 4.00 16.00 Z",
      "province": "BOR",
      "rootTerritory": "BOR",
      "viewBox": "0 0 118 64",
      "unitSlots": [
        {
          "name": "main",
          "x": 61.7,
          "y": 40.24,
          "territory": "BOR",
          "arrowReceiver": {
            "x": 79.7,
            "y": 58.24
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 61.7,
          "y": 40.24,
          "territory": "BOR",
          "arrowReceiver": {
            "x": 79.7,
            "y": 58.24
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Borneo": {
    "territory": "BOR",
    "unitSlotName": "main",
    "province": "BOR",
    "provinceMapData": {
      "abbr": "BOR",
      "type": "Coast",
      "centerPos": {
        "x": 61.7,
        "y": 40.24
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 59,
          "y": 32,
          "text": "Borneo"
        }
      ],
      "width": 118,
      "height": 64,
      "x": 342,
      "y": 387,
      "playable": true,
      "path": "M 0.00 18.00 L 22.00 43.00 L 40.00 42.00 L 43.00 45.00 L 36.00 48.00 L 36.00 55.00 L 42.00 58.00 L 62.00 57.00 L 91.00 64.00 L 110.00 60.00 L 118.00 48.00 L 114.00 35.00 L 93.00 39.00 L 85.00 36.00 L 75.00 39.00 L 72.00 35.00 L 64.00 37.00 L 62.00 32.00 L 58.00 33.00 L 42.00 20.00 L 29.00 0.00 L 24.00 6.00 L 24.00 33.00 L 15.00 29.00 L 4.00 16.00 Z",
      "province": "BOR",
      "rootTerritory": "BOR",
      "viewBox": "0 0 118 64",
      "unitSlots": [
        {
          "name": "main",
          "x": 61.7,
          "y": 40.24,
          "territory": "BOR",
          "arrowReceiver": {
            "x": 79.7,
            "y": 58.24
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 61.7,
          "y": 40.24,
          "territory": "BOR",
          "arrowReceiver": {
            "x": 79.7,
            "y": 58.24
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "PEK": {
    "territory": "PEK",
    "unitSlotName": "main",
    "province": "PEK",
    "provinceMapData": {
      "abbr": "PEK",
      "type": "Coast",
      "centerPos": {
        "x": 57.83,
        "y": 33.32
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 51.5,
          "y": 33,
          "text": "Peking"
        }
      ],
      "width": 103,
      "height": 66,
      "x": 323,
      "y": 158,
      "playable": true,
      "path": "M 103.00 5.00 L 98.00 3.00 L 77.00 9.00 L 73.00 0.00 L 59.00 3.00 L 48.00 14.00 L 42.00 32.00 L 34.00 40.00 L 34.00 47.00 L 12.00 48.00 L 0.00 59.00 L 8.00 65.00 L 16.00 63.00 L 23.00 66.00 L 43.00 51.00 L 58.00 53.00 L 65.00 48.00 L 72.00 50.00 L 88.00 43.00 L 97.00 25.00 L 91.00 24.00 L 87.00 18.00 L 100.00 11.00 Z",
      "province": "PEK",
      "rootTerritory": "PEK",
      "viewBox": "0 0 103 66",
      "unitSlots": [
        {
          "name": "main",
          "x": 57.83,
          "y": 33.32,
          "territory": "PEK",
          "arrowReceiver": {
            "x": 75.83,
            "y": 51.32
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 57.83,
          "y": 33.32,
          "territory": "PEK",
          "arrowReceiver": {
            "x": 75.83,
            "y": 51.32
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Peking": {
    "territory": "PEK",
    "unitSlotName": "main",
    "province": "PEK",
    "provinceMapData": {
      "abbr": "PEK",
      "type": "Coast",
      "centerPos": {
        "x": 57.83,
        "y": 33.32
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 51.5,
          "y": 33,
          "text": "Peking"
        }
      ],
      "width": 103,
      "height": 66,
      "x": 323,
      "y": 158,
      "playable": true,
      "path": "M 103.00 5.00 L 98.00 3.00 L 77.00 9.00 L 73.00 0.00 L 59.00 3.00 L 48.00 14.00 L 42.00 32.00 L 34.00 40.00 L 34.00 47.00 L 12.00 48.00 L 0.00 59.00 L 8.00 65.00 L 16.00 63.00 L 23.00 66.00 L 43.00 51.00 L 58.00 53.00 L 65.00 48.00 L 72.00 50.00 L 88.00 43.00 L 97.00 25.00 L 91.00 24.00 L 87.00 18.00 L 100.00 11.00 Z",
      "province": "PEK",
      "rootTerritory": "PEK",
      "viewBox": "0 0 103 66",
      "unitSlots": [
        {
          "name": "main",
          "x": 57.83,
          "y": 33.32,
          "territory": "PEK",
          "arrowReceiver": {
            "x": 75.83,
            "y": 51.32
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 57.83,
          "y": 33.32,
          "territory": "PEK",
          "arrowReceiver": {
            "x": 75.83,
            "y": 51.32
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "BAL": {
    "territory": "BAL",
    "unitSlotName": "main",
    "province": "BAL",
    "provinceMapData": {
      "abbr": "BAL",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 54.5,
          "text": "Bal"
        }
      ],
      "width": 58,
      "height": 109,
      "x": 0,
      "y": 58,
      "playable": true,
      "path": "M 10.00 0.00 L 6.00 11.00 L 12.00 27.00 L 9.00 28.00 L 3.00 20.00 L 0.00 28.00 L 0.00 83.00 L 19.00 101.00 L 39.00 109.00 L 58.00 87.00 L 52.00 86.00 L 44.00 74.00 L 24.00 70.00 L 30.00 64.00 L 28.00 54.00 L 39.00 49.00 L 39.00 42.00 L 27.00 37.00 L 22.00 43.00 L 22.00 52.00 L 9.00 51.00 L 15.00 40.00 L 14.00 32.00 L 21.00 24.00 L 16.00 10.00 L 18.00 1.00 Z",
      "province": "BAL",
      "rootTerritory": "BAL",
      "viewBox": "0 0 58 109",
      "unitSlots": [
        {
          "name": "main",
          "x": 20.99,
          "y": 65.33,
          "territory": "BAL",
          "arrowReceiver": {
            "x": 38.99,
            "y": 83.33
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 20.99,
          "y": 65.33,
          "territory": "BAL",
          "arrowReceiver": {
            "x": 38.99,
            "y": 83.33
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Bal": {
    "territory": "BAL",
    "unitSlotName": "main",
    "province": "BAL",
    "provinceMapData": {
      "abbr": "BAL",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 54.5,
          "text": "Bal"
        }
      ],
      "width": 58,
      "height": 109,
      "x": 0,
      "y": 58,
      "playable": true,
      "path": "M 10.00 0.00 L 6.00 11.00 L 12.00 27.00 L 9.00 28.00 L 3.00 20.00 L 0.00 28.00 L 0.00 83.00 L 19.00 101.00 L 39.00 109.00 L 58.00 87.00 L 52.00 86.00 L 44.00 74.00 L 24.00 70.00 L 30.00 64.00 L 28.00 54.00 L 39.00 49.00 L 39.00 42.00 L 27.00 37.00 L 22.00 43.00 L 22.00 52.00 L 9.00 51.00 L 15.00 40.00 L 14.00 32.00 L 21.00 24.00 L 16.00 10.00 L 18.00 1.00 Z",
      "province": "BAL",
      "rootTerritory": "BAL",
      "viewBox": "0 0 58 109",
      "unitSlots": [
        {
          "name": "main",
          "x": 20.99,
          "y": 65.33,
          "territory": "BAL",
          "arrowReceiver": {
            "x": 38.99,
            "y": 83.33
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 20.99,
          "y": 65.33,
          "territory": "BAL",
          "arrowReceiver": {
            "x": 38.99,
            "y": 83.33
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "CAL": {
    "territory": "CAL",
    "unitSlotName": "main",
    "province": "CAL",
    "provinceMapData": {
      "abbr": "CAL",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 36.5,
          "y": 26,
          "text": "Calcutta"
        }
      ],
      "width": 73,
      "height": 52,
      "x": 218,
      "y": 273,
      "playable": true,
      "path": "M 0.00 20.00 L 7.00 40.00 L 27.00 45.00 L 36.00 52.00 L 53.00 39.00 L 65.00 21.00 L 70.00 23.00 L 73.00 13.00 L 67.00 3.00 L 39.00 8.00 L 12.00 0.00 L 3.00 5.00 Z",
      "province": "CAL",
      "rootTerritory": "CAL",
      "viewBox": "0 0 73 52",
      "unitSlots": [
        {
          "name": "main",
          "x": 33.22,
          "y": 23.03,
          "territory": "CAL",
          "arrowReceiver": {
            "x": 51.22,
            "y": 41.03
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 33.22,
          "y": 23.03,
          "territory": "CAL",
          "arrowReceiver": {
            "x": 51.22,
            "y": 41.03
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Calcutta": {
    "territory": "CAL",
    "unitSlotName": "main",
    "province": "CAL",
    "provinceMapData": {
      "abbr": "CAL",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 36.5,
          "y": 26,
          "text": "Calcutta"
        }
      ],
      "width": 73,
      "height": 52,
      "x": 218,
      "y": 273,
      "playable": true,
      "path": "M 0.00 20.00 L 7.00 40.00 L 27.00 45.00 L 36.00 52.00 L 53.00 39.00 L 65.00 21.00 L 70.00 23.00 L 73.00 13.00 L 67.00 3.00 L 39.00 8.00 L 12.00 0.00 L 3.00 5.00 Z",
      "province": "CAL",
      "rootTerritory": "CAL",
      "viewBox": "0 0 73 52",
      "unitSlots": [
        {
          "name": "main",
          "x": 33.22,
          "y": 23.03,
          "territory": "CAL",
          "arrowReceiver": {
            "x": 51.22,
            "y": 41.03
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 33.22,
          "y": 23.03,
          "territory": "CAL",
          "arrowReceiver": {
            "x": 51.22,
            "y": 41.03
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "SOJ": {
    "territory": "SOJ",
    "unitSlotName": "main",
    "province": "SOJ",
    "provinceMapData": {
      "abbr": "SEA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 27,
          "y": 49,
          "text": "Sea of Japan"
        }
      ],
      "width": 54,
      "height": 98,
      "x": 451,
      "y": 94,
      "playable": true,
      "path": "M 30.00 0.00 L 23.00 10.00 L 27.00 23.00 L 25.00 38.00 L 9.00 44.00 L 0.00 60.00 L 1.00 66.00 L 13.00 78.00 L 19.00 95.00 L 24.00 98.00 L 38.00 91.00 L 36.00 87.00 L 31.00 89.00 L 25.00 84.00 L 33.00 85.00 L 46.00 71.00 L 44.00 62.00 L 54.00 48.00 L 50.00 41.00 L 39.00 39.00 L 47.00 37.00 L 48.00 32.00 L 36.00 16.00 L 41.00 8.00 Z",
      "province": "SOJ",
      "rootTerritory": "SOJ",
      "viewBox": "0 0 54 98",
      "unitSlots": [
        {
          "name": "main",
          "x": 27.94,
          "y": 53.03,
          "territory": "SOJ",
          "arrowReceiver": {
            "x": 45.94,
            "y": 71.03
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27.94,
          "y": 53.03,
          "territory": "SOJ",
          "arrowReceiver": {
            "x": 45.94,
            "y": 71.03
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Sea of Japan": {
    "territory": "SOJ",
    "unitSlotName": "main",
    "province": "SOJ",
    "provinceMapData": {
      "abbr": "SEA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 27,
          "y": 49,
          "text": "Sea of Japan"
        }
      ],
      "width": 54,
      "height": 98,
      "x": 451,
      "y": 94,
      "playable": true,
      "path": "M 30.00 0.00 L 23.00 10.00 L 27.00 23.00 L 25.00 38.00 L 9.00 44.00 L 0.00 60.00 L 1.00 66.00 L 13.00 78.00 L 19.00 95.00 L 24.00 98.00 L 38.00 91.00 L 36.00 87.00 L 31.00 89.00 L 25.00 84.00 L 33.00 85.00 L 46.00 71.00 L 44.00 62.00 L 54.00 48.00 L 50.00 41.00 L 39.00 39.00 L 47.00 37.00 L 48.00 32.00 L 36.00 16.00 L 41.00 8.00 Z",
      "province": "SOJ",
      "rootTerritory": "SOJ",
      "viewBox": "0 0 54 98",
      "unitSlots": [
        {
          "name": "main",
          "x": 27.94,
          "y": 53.03,
          "territory": "SOJ",
          "arrowReceiver": {
            "x": 45.94,
            "y": 71.03
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27.94,
          "y": 53.03,
          "territory": "SOJ",
          "arrowReceiver": {
            "x": 45.94,
            "y": 71.03
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "AFG": {
    "territory": "AFG",
    "unitSlotName": "main",
    "province": "AFG",
    "provinceMapData": {
      "abbr": "AFG",
      "type": "Land",
      "centerPos": {
        "x": 34.77,
        "y": 23.31
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 35.5,
          "y": 25,
          "text": "Afghanistan"
        }
      ],
      "width": 71,
      "height": 50,
      "x": 156,
      "y": 190,
      "playable": true,
      "path": "M 67.00 6.00 L 61.00 7.00 L 58.00 2.00 L 48.00 6.00 L 31.00 0.00 L 7.00 12.00 L 0.00 34.00 L 10.00 40.00 L 25.00 42.00 L 37.00 50.00 L 48.00 43.00 L 65.00 20.00 L 71.00 19.00 Z",
      "province": "AFG",
      "rootTerritory": "AFG",
      "viewBox": "0 0 71 50",
      "unitSlots": [
        {
          "name": "main",
          "x": 34.77,
          "y": 23.31,
          "territory": "AFG",
          "arrowReceiver": {
            "x": 52.77,
            "y": 41.31
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34.77,
          "y": 23.31,
          "territory": "AFG",
          "arrowReceiver": {
            "x": 52.77,
            "y": 41.31
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Afghanistan": {
    "territory": "AFG",
    "unitSlotName": "main",
    "province": "AFG",
    "provinceMapData": {
      "abbr": "AFG",
      "type": "Land",
      "centerPos": {
        "x": 34.77,
        "y": 23.31
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 35.5,
          "y": 25,
          "text": "Afghanistan"
        }
      ],
      "width": 71,
      "height": 50,
      "x": 156,
      "y": 190,
      "playable": true,
      "path": "M 67.00 6.00 L 61.00 7.00 L 58.00 2.00 L 48.00 6.00 L 31.00 0.00 L 7.00 12.00 L 0.00 34.00 L 10.00 40.00 L 25.00 42.00 L 37.00 50.00 L 48.00 43.00 L 65.00 20.00 L 71.00 19.00 Z",
      "province": "AFG",
      "rootTerritory": "AFG",
      "viewBox": "0 0 71 50",
      "unitSlots": [
        {
          "name": "main",
          "x": 34.77,
          "y": 23.31,
          "territory": "AFG",
          "arrowReceiver": {
            "x": 52.77,
            "y": 41.31
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34.77,
          "y": 23.31,
          "territory": "AFG",
          "arrowReceiver": {
            "x": 52.77,
            "y": 41.31
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "MAN": {
    "territory": "MAN",
    "unitSlotName": "main",
    "province": "MAN",
    "provinceMapData": {
      "abbr": "MAN",
      "type": "Land",
      "centerPos": {
        "x": 31.51,
        "y": 29.5
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 30,
          "y": 33,
          "text": "Manchuria"
        }
      ],
      "width": 60,
      "height": 66,
      "x": 398,
      "y": 106,
      "playable": true,
      "path": "M 59.00 1.00 L 51.00 7.00 L 38.00 0.00 L 13.00 6.00 L 17.00 24.00 L 15.00 34.00 L 0.00 57.00 L 7.00 60.00 L 27.00 54.00 L 38.00 66.00 L 39.00 55.00 L 58.00 19.00 Z",
      "province": "MAN",
      "rootTerritory": "MAN",
      "viewBox": "0 0 60 66",
      "unitSlots": [
        {
          "name": "main",
          "x": 31.51,
          "y": 29.5,
          "territory": "MAN",
          "arrowReceiver": {
            "x": 49.51,
            "y": 47.5
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 31.51,
          "y": 29.5,
          "territory": "MAN",
          "arrowReceiver": {
            "x": 49.51,
            "y": 47.5
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Manchuria": {
    "territory": "MAN",
    "unitSlotName": "main",
    "province": "MAN",
    "provinceMapData": {
      "abbr": "MAN",
      "type": "Land",
      "centerPos": {
        "x": 31.51,
        "y": 29.5
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 30,
          "y": 33,
          "text": "Manchuria"
        }
      ],
      "width": 60,
      "height": 66,
      "x": 398,
      "y": 106,
      "playable": true,
      "path": "M 59.00 1.00 L 51.00 7.00 L 38.00 0.00 L 13.00 6.00 L 17.00 24.00 L 15.00 34.00 L 0.00 57.00 L 7.00 60.00 L 27.00 54.00 L 38.00 66.00 L 39.00 55.00 L 58.00 19.00 Z",
      "province": "MAN",
      "rootTerritory": "MAN",
      "viewBox": "0 0 60 66",
      "unitSlots": [
        {
          "name": "main",
          "x": 31.51,
          "y": 29.5,
          "territory": "MAN",
          "arrowReceiver": {
            "x": 49.51,
            "y": 47.5
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 31.51,
          "y": 29.5,
          "territory": "MAN",
          "arrowReceiver": {
            "x": 49.51,
            "y": 47.5
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "BOM": {
    "territory": "BOM",
    "unitSlotName": "main",
    "province": "BOM",
    "provinceMapData": {
      "abbr": "BOM",
      "type": "Coast",
      "centerPos": {
        "x": 21.53,
        "y": 41.02
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 19.5,
          "y": 47,
          "text": "Bombay"
        }
      ],
      "width": 39,
      "height": 94,
      "x": 185,
      "y": 245,
      "playable": true,
      "path": "M 10.00 2.00 L 2.00 13.00 L 4.00 25.00 L 0.00 29.00 L 6.00 32.00 L 1.00 37.00 L 5.00 44.00 L 23.00 54.00 L 21.00 59.00 L 14.00 59.00 L 13.00 65.00 L 25.00 93.00 L 29.00 94.00 L 39.00 72.00 L 33.00 49.00 L 35.00 23.00 L 31.00 1.00 Z",
      "province": "BOM",
      "rootTerritory": "BOM",
      "viewBox": "0 0 39 94",
      "unitSlots": [
        {
          "name": "main",
          "x": 21.53,
          "y": 41.02,
          "territory": "BOM",
          "arrowReceiver": {
            "x": 39.53,
            "y": 59.02
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 21.53,
          "y": 41.02,
          "territory": "BOM",
          "arrowReceiver": {
            "x": 39.53,
            "y": 59.02
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Bombay": {
    "territory": "BOM",
    "unitSlotName": "main",
    "province": "BOM",
    "provinceMapData": {
      "abbr": "BOM",
      "type": "Coast",
      "centerPos": {
        "x": 21.53,
        "y": 41.02
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 19.5,
          "y": 47,
          "text": "Bombay"
        }
      ],
      "width": 39,
      "height": 94,
      "x": 185,
      "y": 245,
      "playable": true,
      "path": "M 10.00 2.00 L 2.00 13.00 L 4.00 25.00 L 0.00 29.00 L 6.00 32.00 L 1.00 37.00 L 5.00 44.00 L 23.00 54.00 L 21.00 59.00 L 14.00 59.00 L 13.00 65.00 L 25.00 93.00 L 29.00 94.00 L 39.00 72.00 L 33.00 49.00 L 35.00 23.00 L 31.00 1.00 Z",
      "province": "BOM",
      "rootTerritory": "BOM",
      "viewBox": "0 0 39 94",
      "unitSlots": [
        {
          "name": "main",
          "x": 21.53,
          "y": 41.02,
          "territory": "BOM",
          "arrowReceiver": {
            "x": 39.53,
            "y": 59.02
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 21.53,
          "y": 41.02,
          "territory": "BOM",
          "arrowReceiver": {
            "x": 39.53,
            "y": 59.02
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "SIN": {
    "territory": "SIN",
    "unitSlotName": "main",
    "province": "SIN",
    "provinceMapData": {
      "abbr": "SIN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 36.5,
          "y": 23.5,
          "text": "Sinkiang"
        }
      ],
      "width": 73,
      "height": 47,
      "x": 221,
      "y": 176,
      "playable": true,
      "path": "M 0.00 5.00 L 7.00 16.00 L 4.00 23.00 L 7.00 39.00 L 15.00 47.00 L 38.00 37.00 L 54.00 36.00 L 60.00 32.00 L 58.00 23.00 L 73.00 23.00 L 63.00 10.00 L 48.00 8.00 L 33.00 0.00 L 14.00 7.00 Z",
      "province": "SIN",
      "rootTerritory": "SIN",
      "viewBox": "0 0 73 47",
      "unitSlots": [
        {
          "name": "main",
          "x": 32.49,
          "y": 21.57,
          "territory": "SIN",
          "arrowReceiver": {
            "x": 50.49,
            "y": 39.57
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 32.49,
          "y": 21.57,
          "territory": "SIN",
          "arrowReceiver": {
            "x": 50.49,
            "y": 39.57
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Sinkiang": {
    "territory": "SIN",
    "unitSlotName": "main",
    "province": "SIN",
    "provinceMapData": {
      "abbr": "SIN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 36.5,
          "y": 23.5,
          "text": "Sinkiang"
        }
      ],
      "width": 73,
      "height": 47,
      "x": 221,
      "y": 176,
      "playable": true,
      "path": "M 0.00 5.00 L 7.00 16.00 L 4.00 23.00 L 7.00 39.00 L 15.00 47.00 L 38.00 37.00 L 54.00 36.00 L 60.00 32.00 L 58.00 23.00 L 73.00 23.00 L 63.00 10.00 L 48.00 8.00 L 33.00 0.00 L 14.00 7.00 Z",
      "province": "SIN",
      "rootTerritory": "SIN",
      "viewBox": "0 0 73 47",
      "unitSlots": [
        {
          "name": "main",
          "x": 32.49,
          "y": 21.57,
          "territory": "SIN",
          "arrowReceiver": {
            "x": 50.49,
            "y": 39.57
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 32.49,
          "y": 21.57,
          "territory": "SIN",
          "arrowReceiver": {
            "x": 50.49,
            "y": 39.57
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "GOM": {
    "territory": "GOM",
    "unitSlotName": "main",
    "province": "GOM",
    "provinceMapData": {
      "abbr": "GUL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20.5,
          "y": 38.5,
          "text": "Gulf of Martaban"
        }
      ],
      "width": 41,
      "height": 77,
      "x": 306,
      "y": 327,
      "playable": true,
      "path": "M 8.00 4.00 L 1.00 16.00 L 1.00 48.00 L 11.00 66.00 L 36.00 77.00 L 41.00 73.00 L 41.00 67.00 L 29.00 51.00 L 33.00 33.00 L 27.00 10.00 L 29.00 1.00 Z",
      "province": "GOM",
      "rootTerritory": "GOM",
      "viewBox": "0 0 41 77",
      "unitSlots": [
        {
          "name": "main",
          "x": 18.42,
          "y": 38.03,
          "territory": "GOM",
          "arrowReceiver": {
            "x": 36.42,
            "y": 56.03
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 18.42,
          "y": 38.03,
          "territory": "GOM",
          "arrowReceiver": {
            "x": 36.42,
            "y": 56.03
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Gulf of Martaban": {
    "territory": "GOM",
    "unitSlotName": "main",
    "province": "GOM",
    "provinceMapData": {
      "abbr": "GUL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20.5,
          "y": 38.5,
          "text": "Gulf of Martaban"
        }
      ],
      "width": 41,
      "height": 77,
      "x": 306,
      "y": 327,
      "playable": true,
      "path": "M 8.00 4.00 L 1.00 16.00 L 1.00 48.00 L 11.00 66.00 L 36.00 77.00 L 41.00 73.00 L 41.00 67.00 L 29.00 51.00 L 33.00 33.00 L 27.00 10.00 L 29.00 1.00 Z",
      "province": "GOM",
      "rootTerritory": "GOM",
      "viewBox": "0 0 41 77",
      "unitSlots": [
        {
          "name": "main",
          "x": 18.42,
          "y": 38.03,
          "territory": "GOM",
          "arrowReceiver": {
            "x": 36.42,
            "y": 56.03
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 18.42,
          "y": 38.03,
          "territory": "GOM",
          "arrowReceiver": {
            "x": 36.42,
            "y": 56.03
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "BUR": {
    "territory": "BUR",
    "unitSlotName": "main",
    "province": "BUR",
    "provinceMapData": {
      "abbr": "BUR",
      "type": "Coast",
      "centerPos": {
        "x": 19.01,
        "y": 44.67
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21.5,
          "y": 59.5,
          "text": "Burma"
        }
      ],
      "width": 43,
      "height": 119,
      "x": 310,
      "y": 256,
      "playable": true,
      "path": "M 20.00 0.00 L 4.00 19.00 L 6.00 27.00 L 2.00 31.00 L 0.00 50.00 L 6.00 56.00 L 6.00 75.00 L 17.00 70.00 L 25.00 72.00 L 29.00 99.00 L 25.00 118.00 L 28.00 119.00 L 34.00 96.00 L 29.00 82.00 L 30.00 71.00 L 22.00 61.00 L 29.00 51.00 L 29.00 42.00 L 35.00 49.00 L 43.00 45.00 L 40.00 34.00 L 32.00 29.00 L 22.00 29.00 L 29.00 6.00 Z",
      "province": "BUR",
      "rootTerritory": "BUR",
      "viewBox": "0 0 43 119",
      "unitSlots": [
        {
          "name": "main",
          "x": 19.01,
          "y": 44.67,
          "territory": "BUR",
          "arrowReceiver": {
            "x": 37.01,
            "y": 62.67
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 19.01,
          "y": 44.67,
          "territory": "BUR",
          "arrowReceiver": {
            "x": 37.01,
            "y": 62.67
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Burma": {
    "territory": "BUR",
    "unitSlotName": "main",
    "province": "BUR",
    "provinceMapData": {
      "abbr": "BUR",
      "type": "Coast",
      "centerPos": {
        "x": 19.01,
        "y": 44.67
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21.5,
          "y": 59.5,
          "text": "Burma"
        }
      ],
      "width": 43,
      "height": 119,
      "x": 310,
      "y": 256,
      "playable": true,
      "path": "M 20.00 0.00 L 4.00 19.00 L 6.00 27.00 L 2.00 31.00 L 0.00 50.00 L 6.00 56.00 L 6.00 75.00 L 17.00 70.00 L 25.00 72.00 L 29.00 99.00 L 25.00 118.00 L 28.00 119.00 L 34.00 96.00 L 29.00 82.00 L 30.00 71.00 L 22.00 61.00 L 29.00 51.00 L 29.00 42.00 L 35.00 49.00 L 43.00 45.00 L 40.00 34.00 L 32.00 29.00 L 22.00 29.00 L 29.00 6.00 Z",
      "province": "BUR",
      "rootTerritory": "BUR",
      "viewBox": "0 0 43 119",
      "unitSlots": [
        {
          "name": "main",
          "x": 19.01,
          "y": 44.67,
          "territory": "BUR",
          "arrowReceiver": {
            "x": 37.01,
            "y": 62.67
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 19.01,
          "y": 44.67,
          "territory": "BUR",
          "arrowReceiver": {
            "x": 37.01,
            "y": 62.67
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "ECS": {
    "territory": "ECS",
    "unitSlotName": "main",
    "province": "ECS",
    "provinceMapData": {
      "abbr": "EAS",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 23,
          "y": 33.5,
          "text": "East China Sea"
        }
      ],
      "width": 46,
      "height": 67,
      "x": 445,
      "y": 191,
      "playable": true,
      "path": "M 28.00 0.00 L 16.00 0.00 L 15.00 8.00 L 4.00 22.00 L 8.00 29.00 L 3.00 31.00 L 0.00 55.00 L 10.00 60.00 L 13.00 67.00 L 24.00 58.00 L 31.00 42.00 L 46.00 24.00 L 44.00 15.00 L 39.00 14.00 Z",
      "province": "ECS",
      "rootTerritory": "ECS",
      "viewBox": "0 0 46 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 21.31,
          "y": 31.21,
          "territory": "ECS",
          "arrowReceiver": {
            "x": 39.31,
            "y": 49.21
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 21.31,
          "y": 31.21,
          "territory": "ECS",
          "arrowReceiver": {
            "x": 39.31,
            "y": 49.21
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "East China Sea": {
    "territory": "ECS",
    "unitSlotName": "main",
    "province": "ECS",
    "provinceMapData": {
      "abbr": "EAS",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 23,
          "y": 33.5,
          "text": "East China Sea"
        }
      ],
      "width": 46,
      "height": 67,
      "x": 445,
      "y": 191,
      "playable": true,
      "path": "M 28.00 0.00 L 16.00 0.00 L 15.00 8.00 L 4.00 22.00 L 8.00 29.00 L 3.00 31.00 L 0.00 55.00 L 10.00 60.00 L 13.00 67.00 L 24.00 58.00 L 31.00 42.00 L 46.00 24.00 L 44.00 15.00 L 39.00 14.00 Z",
      "province": "ECS",
      "rootTerritory": "ECS",
      "viewBox": "0 0 46 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 21.31,
          "y": 31.21,
          "territory": "ECS",
          "arrowReceiver": {
            "x": 39.31,
            "y": 49.21
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 21.31,
          "y": 31.21,
          "territory": "ECS",
          "arrowReceiver": {
            "x": 39.31,
            "y": 49.21
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "SUN": {
    "territory": "SUN",
    "unitSlotName": "main",
    "province": "SUN",
    "provinceMapData": {
      "abbr": "SUN",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 23,
          "y": 29.5,
          "text": "Sunda Sea"
        }
      ],
      "width": 46,
      "height": 59,
      "x": 367,
      "y": 354,
      "playable": true,
      "path": "M 36.00 0.00 L 24.00 4.00 L 20.00 16.00 L 7.00 18.00 L 7.00 9.00 L 0.00 7.00 L 3.00 31.00 L 17.00 52.00 L 26.00 59.00 L 44.00 41.00 L 46.00 34.00 L 44.00 12.00 Z",
      "province": "SUN",
      "rootTerritory": "SUN",
      "viewBox": "0 0 46 59",
      "unitSlots": [
        {
          "name": "main",
          "x": 25.75,
          "y": 28.02,
          "territory": "SUN",
          "arrowReceiver": {
            "x": 43.75,
            "y": 46.02
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 25.75,
          "y": 28.02,
          "territory": "SUN",
          "arrowReceiver": {
            "x": 43.75,
            "y": 46.02
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Sunda Sea": {
    "territory": "SUN",
    "unitSlotName": "main",
    "province": "SUN",
    "provinceMapData": {
      "abbr": "SUN",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 23,
          "y": 29.5,
          "text": "Sunda Sea"
        }
      ],
      "width": 46,
      "height": 59,
      "x": 367,
      "y": 354,
      "playable": true,
      "path": "M 36.00 0.00 L 24.00 4.00 L 20.00 16.00 L 7.00 18.00 L 7.00 9.00 L 0.00 7.00 L 3.00 31.00 L 17.00 52.00 L 26.00 59.00 L 44.00 41.00 L 46.00 34.00 L 44.00 12.00 Z",
      "province": "SUN",
      "rootTerritory": "SUN",
      "viewBox": "0 0 46 59",
      "unitSlots": [
        {
          "name": "main",
          "x": 25.75,
          "y": 28.02,
          "territory": "SUN",
          "arrowReceiver": {
            "x": 43.75,
            "y": 46.02
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 25.75,
          "y": 28.02,
          "territory": "SUN",
          "arrowReceiver": {
            "x": 43.75,
            "y": 46.02
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "PGU": {
    "territory": "PGU",
    "unitSlotName": "main",
    "province": "PGU",
    "provinceMapData": {
      "abbr": "PER",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 40,
          "y": 39,
          "text": "Persian Gulf"
        }
      ],
      "width": 80,
      "height": 78,
      "x": 91,
      "y": 204,
      "playable": true,
      "path": "M 0.00 2.00 L 2.00 16.00 L 8.00 27.00 L 16.00 29.00 L 19.00 40.00 L 29.00 43.00 L 37.00 37.00 L 40.00 39.00 L 36.00 53.00 L 55.00 76.00 L 70.00 78.00 L 80.00 72.00 L 76.00 57.00 L 59.00 53.00 L 39.00 30.00 L 27.00 31.00 L 15.00 3.00 Z",
      "province": "PGU",
      "rootTerritory": "PGU",
      "viewBox": "0 0 80 78",
      "unitSlots": [
        {
          "name": "main",
          "x": 40.06,
          "y": 43.75,
          "territory": "PGU",
          "arrowReceiver": {
            "x": 58.06,
            "y": 61.75
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 40.06,
          "y": 43.75,
          "territory": "PGU",
          "arrowReceiver": {
            "x": 58.06,
            "y": 61.75
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Persian Gulf": {
    "territory": "PGU",
    "unitSlotName": "main",
    "province": "PGU",
    "provinceMapData": {
      "abbr": "PER",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 40,
          "y": 39,
          "text": "Persian Gulf"
        }
      ],
      "width": 80,
      "height": 78,
      "x": 91,
      "y": 204,
      "playable": true,
      "path": "M 0.00 2.00 L 2.00 16.00 L 8.00 27.00 L 16.00 29.00 L 19.00 40.00 L 29.00 43.00 L 37.00 37.00 L 40.00 39.00 L 36.00 53.00 L 55.00 76.00 L 70.00 78.00 L 80.00 72.00 L 76.00 57.00 L 59.00 53.00 L 39.00 30.00 L 27.00 31.00 L 15.00 3.00 Z",
      "province": "PGU",
      "rootTerritory": "PGU",
      "viewBox": "0 0 80 78",
      "unitSlots": [
        {
          "name": "main",
          "x": 40.06,
          "y": 43.75,
          "territory": "PGU",
          "arrowReceiver": {
            "x": 58.06,
            "y": 61.75
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 40.06,
          "y": 43.75,
          "territory": "PGU",
          "arrowReceiver": {
            "x": 58.06,
            "y": 61.75
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "DEL": {
    "territory": "DEL",
    "unitSlotName": "main",
    "province": "DEL",
    "provinceMapData": {
      "abbr": "DEL",
      "type": "Land",
      "centerPos": {
        "x": 28.27,
        "y": 22.35
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 33.5,
          "y": 19.5,
          "text": "Delhi"
        }
      ],
      "width": 67,
      "height": 39,
      "x": 216,
      "y": 241,
      "playable": true,
      "path": "M 1.00 3.00 L 0.00 17.00 L 5.00 35.00 L 17.00 32.00 L 43.00 39.00 L 67.00 34.00 L 65.00 25.00 L 26.00 11.00 L 21.00 1.00 Z",
      "province": "DEL",
      "rootTerritory": "DEL",
      "viewBox": "0 0 67 39",
      "unitSlots": [
        {
          "name": "main",
          "x": 28.27,
          "y": 22.35,
          "territory": "DEL",
          "arrowReceiver": {
            "x": 46.27,
            "y": 40.35
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 28.27,
          "y": 22.35,
          "territory": "DEL",
          "arrowReceiver": {
            "x": 46.27,
            "y": 40.35
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Delhi": {
    "territory": "DEL",
    "unitSlotName": "main",
    "province": "DEL",
    "provinceMapData": {
      "abbr": "DEL",
      "type": "Land",
      "centerPos": {
        "x": 28.27,
        "y": 22.35
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 33.5,
          "y": 19.5,
          "text": "Delhi"
        }
      ],
      "width": 67,
      "height": 39,
      "x": 216,
      "y": 241,
      "playable": true,
      "path": "M 1.00 3.00 L 0.00 17.00 L 5.00 35.00 L 17.00 32.00 L 43.00 39.00 L 67.00 34.00 L 65.00 25.00 L 26.00 11.00 L 21.00 1.00 Z",
      "province": "DEL",
      "rootTerritory": "DEL",
      "viewBox": "0 0 67 39",
      "unitSlots": [
        {
          "name": "main",
          "x": 28.27,
          "y": 22.35,
          "territory": "DEL",
          "arrowReceiver": {
            "x": 46.27,
            "y": 40.35
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 28.27,
          "y": 22.35,
          "territory": "DEL",
          "arrowReceiver": {
            "x": 46.27,
            "y": 40.35
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "ANG": {
    "territory": "ANG",
    "unitSlotName": "main",
    "province": "ANG",
    "provinceMapData": {
      "abbr": "ANA",
      "type": "Coast",
      "centerPos": {
        "x": 36.12,
        "y": 18.63
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 36,
          "y": 20,
          "text": "Anatolia"
        }
      ],
      "width": 72,
      "height": 40,
      "x": 29,
      "y": 113,
      "playable": true,
      "path": "M 1.00 2.00 L 0.00 13.00 L 6.00 18.00 L 15.00 18.00 L 22.00 30.00 L 26.00 24.00 L 33.00 25.00 L 29.00 29.00 L 31.00 35.00 L 43.00 32.00 L 52.00 33.00 L 61.00 40.00 L 71.00 39.00 L 72.00 34.00 L 60.00 27.00 L 61.00 17.00 L 46.00 3.00 L 42.00 9.00 L 36.00 9.00 L 35.00 1.00 Z",
      "province": "ANG",
      "rootTerritory": "ANG",
      "viewBox": "0 0 72 40",
      "unitSlots": [
        {
          "name": "main",
          "x": 36.12,
          "y": 18.63,
          "territory": "ANG",
          "arrowReceiver": {
            "x": 54.12,
            "y": 36.63
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 36.12,
          "y": 18.63,
          "territory": "ANG",
          "arrowReceiver": {
            "x": 54.12,
            "y": 36.63
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Anatolia": {
    "territory": "ANG",
    "unitSlotName": "main",
    "province": "ANG",
    "provinceMapData": {
      "abbr": "ANA",
      "type": "Coast",
      "centerPos": {
        "x": 36.12,
        "y": 18.63
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 36,
          "y": 20,
          "text": "Anatolia"
        }
      ],
      "width": 72,
      "height": 40,
      "x": 29,
      "y": 113,
      "playable": true,
      "path": "M 1.00 2.00 L 0.00 13.00 L 6.00 18.00 L 15.00 18.00 L 22.00 30.00 L 26.00 24.00 L 33.00 25.00 L 29.00 29.00 L 31.00 35.00 L 43.00 32.00 L 52.00 33.00 L 61.00 40.00 L 71.00 39.00 L 72.00 34.00 L 60.00 27.00 L 61.00 17.00 L 46.00 3.00 L 42.00 9.00 L 36.00 9.00 L 35.00 1.00 Z",
      "province": "ANG",
      "rootTerritory": "ANG",
      "viewBox": "0 0 72 40",
      "unitSlots": [
        {
          "name": "main",
          "x": 36.12,
          "y": 18.63,
          "territory": "ANG",
          "arrowReceiver": {
            "x": 54.12,
            "y": 36.63
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 36.12,
          "y": 18.63,
          "territory": "ANG",
          "arrowReceiver": {
            "x": 54.12,
            "y": 36.63
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "BLA": {
    "territory": "BLA",
    "unitSlotName": "main",
    "province": "BLA",
    "provinceMapData": {
      "abbr": "BLA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32.5,
          "y": 22.5,
          "text": "Black Sea"
        }
      ],
      "width": 65,
      "height": 45,
      "x": 43,
      "y": 85,
      "playable": true,
      "path": "M 0.00 20.00 L 10.00 29.00 L 32.00 31.00 L 49.00 45.00 L 58.00 44.00 L 63.00 39.00 L 51.00 18.00 L 61.00 20.00 L 65.00 15.00 L 57.00 10.00 L 52.00 10.00 L 49.00 15.00 L 36.00 15.00 L 37.00 0.00 L 29.00 1.00 L 17.00 12.00 L 10.00 10.00 Z",
      "province": "BLA",
      "rootTerritory": "BLA",
      "viewBox": "0 0 65 45",
      "unitSlots": [
        {
          "name": "main",
          "x": 35.52,
          "y": 22.76,
          "territory": "BLA",
          "arrowReceiver": {
            "x": 53.52,
            "y": 40.76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35.52,
          "y": 22.76,
          "territory": "BLA",
          "arrowReceiver": {
            "x": 53.52,
            "y": 40.76
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Black Sea": {
    "territory": "BLA",
    "unitSlotName": "main",
    "province": "BLA",
    "provinceMapData": {
      "abbr": "BLA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32.5,
          "y": 22.5,
          "text": "Black Sea"
        }
      ],
      "width": 65,
      "height": 45,
      "x": 43,
      "y": 85,
      "playable": true,
      "path": "M 0.00 20.00 L 10.00 29.00 L 32.00 31.00 L 49.00 45.00 L 58.00 44.00 L 63.00 39.00 L 51.00 18.00 L 61.00 20.00 L 65.00 15.00 L 57.00 10.00 L 52.00 10.00 L 49.00 15.00 L 36.00 15.00 L 37.00 0.00 L 29.00 1.00 L 17.00 12.00 L 10.00 10.00 Z",
      "province": "BLA",
      "rootTerritory": "BLA",
      "viewBox": "0 0 65 45",
      "unitSlots": [
        {
          "name": "main",
          "x": 35.52,
          "y": 22.76,
          "territory": "BLA",
          "arrowReceiver": {
            "x": 53.52,
            "y": 40.76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35.52,
          "y": 22.76,
          "territory": "BLA",
          "arrowReceiver": {
            "x": 53.52,
            "y": 40.76
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_48": {
    "territory": "REGION_48",
    "unitSlotName": "main",
    "province": "REGION_48",
    "provinceMapData": {
      "abbr": "CAS",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21,
          "y": 29.5,
          "text": "Caspian Sea"
        }
      ],
      "width": 42,
      "height": 59,
      "x": 117,
      "y": 117,
      "playable": true,
      "path": "M 22.00 0.00 L 7.00 12.00 L 10.00 35.00 L 0.00 42.00 L 1.00 51.00 L 14.00 59.00 L 22.00 52.00 L 18.00 45.00 L 30.00 43.00 L 29.00 36.00 L 22.00 34.00 L 22.00 25.00 L 38.00 24.00 L 42.00 14.00 L 36.00 4.00 L 30.00 5.00 Z",
      "province": "REGION_48",
      "rootTerritory": "REGION_48",
      "viewBox": "0 0 42 59",
      "unitSlots": [
        {
          "name": "main",
          "x": 19.39,
          "y": 27.08,
          "territory": "REGION_48",
          "arrowReceiver": {
            "x": 37.39,
            "y": 45.08
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 19.39,
          "y": 27.08,
          "territory": "REGION_48",
          "arrowReceiver": {
            "x": 37.39,
            "y": 45.08
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Caspian Sea": {
    "territory": "REGION_48",
    "unitSlotName": "main",
    "province": "REGION_48",
    "provinceMapData": {
      "abbr": "CAS",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21,
          "y": 29.5,
          "text": "Caspian Sea"
        }
      ],
      "width": 42,
      "height": 59,
      "x": 117,
      "y": 117,
      "playable": true,
      "path": "M 22.00 0.00 L 7.00 12.00 L 10.00 35.00 L 0.00 42.00 L 1.00 51.00 L 14.00 59.00 L 22.00 52.00 L 18.00 45.00 L 30.00 43.00 L 29.00 36.00 L 22.00 34.00 L 22.00 25.00 L 38.00 24.00 L 42.00 14.00 L 36.00 4.00 L 30.00 5.00 Z",
      "province": "REGION_48",
      "rootTerritory": "REGION_48",
      "viewBox": "0 0 42 59",
      "unitSlots": [
        {
          "name": "main",
          "x": 19.39,
          "y": 27.08,
          "territory": "REGION_48",
          "arrowReceiver": {
            "x": 37.39,
            "y": 45.08
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 19.39,
          "y": 27.08,
          "territory": "REGION_48",
          "arrowReceiver": {
            "x": 37.39,
            "y": 45.08
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "EGY": {
    "territory": "EGY",
    "unitSlotName": "main",
    "province": "EGY",
    "provinceMapData": {
      "abbr": "EGY",
      "type": "Coast",
      "centerPos": {
        "x": 12.85,
        "y": 36.18
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 14.5,
          "y": 34,
          "text": "Egypt"
        }
      ],
      "width": 29,
      "height": 68,
      "x": 0,
      "y": 142,
      "playable": true,
      "path": "M 0.00 0.00 L 0.00 51.00 L 26.00 68.00 L 29.00 56.00 L 25.00 22.00 L 18.00 24.00 L 18.00 15.00 Z",
      "province": "EGY",
      "rootTerritory": "EGY",
      "viewBox": "0 0 29 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 12.85,
          "y": 36.18,
          "territory": "EGY",
          "arrowReceiver": {
            "x": 30.85,
            "y": 54.18
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 12.85,
          "y": 36.18,
          "territory": "EGY",
          "arrowReceiver": {
            "x": 30.85,
            "y": 54.18
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Egypt": {
    "territory": "EGY",
    "unitSlotName": "main",
    "province": "EGY",
    "provinceMapData": {
      "abbr": "EGY",
      "type": "Coast",
      "centerPos": {
        "x": 12.85,
        "y": 36.18
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 14.5,
          "y": 34,
          "text": "Egypt"
        }
      ],
      "width": 29,
      "height": 68,
      "x": 0,
      "y": 142,
      "playable": true,
      "path": "M 0.00 0.00 L 0.00 51.00 L 26.00 68.00 L 29.00 56.00 L 25.00 22.00 L 18.00 24.00 L 18.00 15.00 Z",
      "province": "EGY",
      "rootTerritory": "EGY",
      "viewBox": "0 0 29 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 12.85,
          "y": 36.18,
          "territory": "EGY",
          "arrowReceiver": {
            "x": 30.85,
            "y": 54.18
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 12.85,
          "y": 36.18,
          "territory": "EGY",
          "arrowReceiver": {
            "x": 30.85,
            "y": 54.18
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "MAD_2": {
    "territory": "MAD_2",
    "unitSlotName": "main",
    "province": "MAD_2",
    "provinceMapData": {
      "abbr": "MAD",
      "type": "Coast",
      "centerPos": {
        "x": 16.06,
        "y": 25.34
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 18,
          "y": 30,
          "text": "Mad 2"
        }
      ],
      "width": 36,
      "height": 60,
      "x": 214,
      "y": 315,
      "playable": true,
      "path": "M 19.00 0.00 L 10.00 1.00 L 0.00 25.00 L 5.00 52.00 L 12.00 60.00 L 15.00 57.00 L 11.00 51.00 L 22.00 49.00 L 29.00 21.00 L 36.00 15.00 L 31.00 4.00 L 26.00 5.00 Z",
      "province": "MAD_2",
      "rootTerritory": "MAD_2",
      "viewBox": "0 0 36 60",
      "unitSlots": [
        {
          "name": "main",
          "x": 16.06,
          "y": 25.34,
          "territory": "MAD_2",
          "arrowReceiver": {
            "x": 34.06,
            "y": 43.34
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 16.06,
          "y": 25.34,
          "territory": "MAD_2",
          "arrowReceiver": {
            "x": 34.06,
            "y": 43.34
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Mad 2": {
    "territory": "MAD_2",
    "unitSlotName": "main",
    "province": "MAD_2",
    "provinceMapData": {
      "abbr": "MAD",
      "type": "Coast",
      "centerPos": {
        "x": 16.06,
        "y": 25.34
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 18,
          "y": 30,
          "text": "Mad 2"
        }
      ],
      "width": 36,
      "height": 60,
      "x": 214,
      "y": 315,
      "playable": true,
      "path": "M 19.00 0.00 L 10.00 1.00 L 0.00 25.00 L 5.00 52.00 L 12.00 60.00 L 15.00 57.00 L 11.00 51.00 L 22.00 49.00 L 29.00 21.00 L 36.00 15.00 L 31.00 4.00 L 26.00 5.00 Z",
      "province": "MAD_2",
      "rootTerritory": "MAD_2",
      "viewBox": "0 0 36 60",
      "unitSlots": [
        {
          "name": "main",
          "x": 16.06,
          "y": 25.34,
          "territory": "MAD_2",
          "arrowReceiver": {
            "x": 34.06,
            "y": 43.34
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 16.06,
          "y": 25.34,
          "territory": "MAD_2",
          "arrowReceiver": {
            "x": 34.06,
            "y": 43.34
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_51": {
    "territory": "REGION_51",
    "unitSlotName": "main",
    "province": "REGION_51",
    "provinceMapData": {
      "abbr": "REG",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 43.5,
          "y": 11,
          "text": "REGION_51"
        }
      ],
      "width": 87,
      "height": 22,
      "x": 168,
      "y": 0,
      "playable": true,
      "path": "M 0.00 12.00 L 6.00 19.00 L 20.00 16.00 L 24.00 22.00 L 32.00 12.00 L 36.00 15.00 L 35.00 22.00 L 52.00 13.00 L 55.00 16.00 L 66.00 13.00 L 68.00 9.00 L 80.00 17.00 L 87.00 0.00 L 20.00 0.00 L 23.00 7.00 L 17.00 12.00 L 6.00 4.00 Z",
      "province": "REGION_51",
      "rootTerritory": "REGION_51",
      "viewBox": "0 0 87 22",
      "unitSlots": [
        {
          "name": "main",
          "x": 44.97,
          "y": 8.35,
          "territory": "REGION_51",
          "arrowReceiver": {
            "x": 62.97,
            "y": 26.35
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 44.97,
          "y": 8.35,
          "territory": "REGION_51",
          "arrowReceiver": {
            "x": 62.97,
            "y": 26.35
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "BEN": {
    "territory": "BEN",
    "unitSlotName": "main",
    "province": "BEN",
    "provinceMapData": {
      "abbr": "BEN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20.5,
          "y": 27,
          "text": "Bengal"
        }
      ],
      "width": 41,
      "height": 54,
      "x": 283,
      "y": 250,
      "playable": true,
      "path": "M 13.00 0.00 L 7.00 3.00 L 7.00 12.00 L 0.00 22.00 L 8.00 35.00 L 8.00 43.00 L 17.00 45.00 L 25.00 54.00 L 30.00 24.00 L 41.00 9.00 L 34.00 3.00 Z",
      "province": "BEN",
      "rootTerritory": "BEN",
      "viewBox": "0 0 41 54",
      "unitSlots": [
        {
          "name": "main",
          "x": 19.45,
          "y": 22.47,
          "territory": "BEN",
          "arrowReceiver": {
            "x": 37.45,
            "y": 40.47
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 19.45,
          "y": 22.47,
          "territory": "BEN",
          "arrowReceiver": {
            "x": 37.45,
            "y": 40.47
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Bengal": {
    "territory": "BEN",
    "unitSlotName": "main",
    "province": "BEN",
    "provinceMapData": {
      "abbr": "BEN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20.5,
          "y": 27,
          "text": "Bengal"
        }
      ],
      "width": 41,
      "height": 54,
      "x": 283,
      "y": 250,
      "playable": true,
      "path": "M 13.00 0.00 L 7.00 3.00 L 7.00 12.00 L 0.00 22.00 L 8.00 35.00 L 8.00 43.00 L 17.00 45.00 L 25.00 54.00 L 30.00 24.00 L 41.00 9.00 L 34.00 3.00 Z",
      "province": "BEN",
      "rootTerritory": "BEN",
      "viewBox": "0 0 41 54",
      "unitSlots": [
        {
          "name": "main",
          "x": 19.45,
          "y": 22.47,
          "territory": "BEN",
          "arrowReceiver": {
            "x": 37.45,
            "y": 40.47
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 19.45,
          "y": 22.47,
          "territory": "BEN",
          "arrowReceiver": {
            "x": 37.45,
            "y": 40.47
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "RED": {
    "territory": "RED",
    "unitSlotName": "main",
    "province": "RED",
    "provinceMapData": {
      "abbr": "RED",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 10.5,
          "y": 57.5,
          "text": "Red Sea"
        }
      ],
      "width": 21,
      "height": 115,
      "x": 27,
      "y": 178,
      "playable": true,
      "path": "M 2.00 0.00 L 2.00 48.00 L 10.00 50.00 L 10.00 66.00 L 3.00 68.00 L 4.00 87.00 L 8.00 102.00 L 18.00 115.00 L 21.00 88.00 L 14.00 73.00 L 15.00 38.00 L 10.00 26.00 L 14.00 3.00 L 6.00 4.00 Z",
      "province": "RED",
      "rootTerritory": "RED",
      "viewBox": "0 0 21 115",
      "unitSlots": [
        {
          "name": "main",
          "x": 10.1,
          "y": 59.08,
          "territory": "RED",
          "arrowReceiver": {
            "x": 28.1,
            "y": 77.08
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 10.1,
          "y": 59.08,
          "territory": "RED",
          "arrowReceiver": {
            "x": 28.1,
            "y": 77.08
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Red Sea": {
    "territory": "RED",
    "unitSlotName": "main",
    "province": "RED",
    "provinceMapData": {
      "abbr": "RED",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 10.5,
          "y": 57.5,
          "text": "Red Sea"
        }
      ],
      "width": 21,
      "height": 115,
      "x": 27,
      "y": 178,
      "playable": true,
      "path": "M 2.00 0.00 L 2.00 48.00 L 10.00 50.00 L 10.00 66.00 L 3.00 68.00 L 4.00 87.00 L 8.00 102.00 L 18.00 115.00 L 21.00 88.00 L 14.00 73.00 L 15.00 38.00 L 10.00 26.00 L 14.00 3.00 L 6.00 4.00 Z",
      "province": "RED",
      "rootTerritory": "RED",
      "viewBox": "0 0 21 115",
      "unitSlots": [
        {
          "name": "main",
          "x": 10.1,
          "y": 59.08,
          "territory": "RED",
          "arrowReceiver": {
            "x": 28.1,
            "y": 77.08
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 10.1,
          "y": 59.08,
          "territory": "RED",
          "arrowReceiver": {
            "x": 28.1,
            "y": 77.08
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "MES": {
    "territory": "MES",
    "unitSlotName": "main",
    "province": "MES",
    "provinceMapData": {
      "abbr": "MES",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 18,
          "y": 29.5,
          "text": "Mesopotamia"
        }
      ],
      "width": 36,
      "height": 59,
      "x": 66,
      "y": 145,
      "playable": true,
      "path": "M 3.00 0.00 L 0.00 9.00 L 5.00 30.00 L 11.00 32.00 L 18.00 52.00 L 29.00 59.00 L 32.00 47.00 L 28.00 34.00 L 36.00 25.00 L 33.00 10.00 Z",
      "province": "MES",
      "rootTerritory": "MES",
      "viewBox": "0 0 36 59",
      "unitSlots": [
        {
          "name": "main",
          "x": 18.73,
          "y": 25.55,
          "territory": "MES",
          "arrowReceiver": {
            "x": 36.73,
            "y": 43.55
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 18.73,
          "y": 25.55,
          "territory": "MES",
          "arrowReceiver": {
            "x": 36.73,
            "y": 43.55
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Mesopotamia": {
    "territory": "MES",
    "unitSlotName": "main",
    "province": "MES",
    "provinceMapData": {
      "abbr": "MES",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 18,
          "y": 29.5,
          "text": "Mesopotamia"
        }
      ],
      "width": 36,
      "height": 59,
      "x": 66,
      "y": 145,
      "playable": true,
      "path": "M 3.00 0.00 L 0.00 9.00 L 5.00 30.00 L 11.00 32.00 L 18.00 52.00 L 29.00 59.00 L 32.00 47.00 L 28.00 34.00 L 36.00 25.00 L 33.00 10.00 Z",
      "province": "MES",
      "rootTerritory": "MES",
      "viewBox": "0 0 36 59",
      "unitSlots": [
        {
          "name": "main",
          "x": 18.73,
          "y": 25.55,
          "territory": "MES",
          "arrowReceiver": {
            "x": 36.73,
            "y": 43.55
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 18.73,
          "y": 25.55,
          "territory": "MES",
          "arrowReceiver": {
            "x": 36.73,
            "y": 43.55
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "MAK": {
    "territory": "MAK",
    "unitSlotName": "main",
    "province": "MAK",
    "provinceMapData": {
      "abbr": "MAK",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21.5,
          "y": 29.5,
          "text": "Mak"
        }
      ],
      "width": 43,
      "height": 59,
      "x": 444,
      "y": 364,
      "playable": true,
      "path": "M 23.00 1.00 L 17.00 0.00 L 5.00 10.00 L 2.00 26.00 L 8.00 33.00 L 1.00 46.00 L 1.00 59.00 L 11.00 52.00 L 15.00 34.00 L 43.00 19.00 L 37.00 10.00 Z",
      "province": "MAK",
      "rootTerritory": "MAK",
      "viewBox": "0 0 43 59",
      "unitSlots": [
        {
          "name": "main",
          "x": 17.89,
          "y": 23.28,
          "territory": "MAK",
          "arrowReceiver": {
            "x": 35.89,
            "y": 41.28
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 17.89,
          "y": 23.28,
          "territory": "MAK",
          "arrowReceiver": {
            "x": 35.89,
            "y": 41.28
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Mak": {
    "territory": "MAK",
    "unitSlotName": "main",
    "province": "MAK",
    "provinceMapData": {
      "abbr": "MAK",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21.5,
          "y": 29.5,
          "text": "Mak"
        }
      ],
      "width": 43,
      "height": 59,
      "x": 444,
      "y": 364,
      "playable": true,
      "path": "M 23.00 1.00 L 17.00 0.00 L 5.00 10.00 L 2.00 26.00 L 8.00 33.00 L 1.00 46.00 L 1.00 59.00 L 11.00 52.00 L 15.00 34.00 L 43.00 19.00 L 37.00 10.00 Z",
      "province": "MAK",
      "rootTerritory": "MAK",
      "viewBox": "0 0 43 59",
      "unitSlots": [
        {
          "name": "main",
          "x": 17.89,
          "y": 23.28,
          "territory": "MAK",
          "arrowReceiver": {
            "x": 35.89,
            "y": 41.28
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 17.89,
          "y": 23.28,
          "territory": "MAK",
          "arrowReceiver": {
            "x": 35.89,
            "y": 41.28
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "SIAM": {
    "territory": "SIAM",
    "unitSlotName": "main",
    "province": "SIAM",
    "provinceMapData": {
      "abbr": "SIA",
      "type": "Coast",
      "centerPos": {
        "x": 20.37,
        "y": 24.42
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21.5,
          "y": 26,
          "text": "Siam"
        }
      ],
      "width": 43,
      "height": 52,
      "x": 334,
      "y": 306,
      "playable": true,
      "path": "M 17.00 0.00 L 5.00 4.00 L 0.00 11.00 L 7.00 21.00 L 6.00 31.00 L 12.00 52.00 L 16.00 49.00 L 16.00 39.00 L 22.00 39.00 L 26.00 45.00 L 43.00 32.00 L 34.00 13.00 L 19.00 12.00 L 20.00 2.00 Z",
      "province": "SIAM",
      "rootTerritory": "SIAM",
      "viewBox": "0 0 43 52",
      "unitSlots": [
        {
          "name": "main",
          "x": 20.37,
          "y": 24.42,
          "territory": "SIAM",
          "arrowReceiver": {
            "x": 38.37,
            "y": 42.42
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 20.37,
          "y": 24.42,
          "territory": "SIAM",
          "arrowReceiver": {
            "x": 38.37,
            "y": 42.42
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Siam": {
    "territory": "SIAM",
    "unitSlotName": "main",
    "province": "SIAM",
    "provinceMapData": {
      "abbr": "SIA",
      "type": "Coast",
      "centerPos": {
        "x": 20.37,
        "y": 24.42
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21.5,
          "y": 26,
          "text": "Siam"
        }
      ],
      "width": 43,
      "height": 52,
      "x": 334,
      "y": 306,
      "playable": true,
      "path": "M 17.00 0.00 L 5.00 4.00 L 0.00 11.00 L 7.00 21.00 L 6.00 31.00 L 12.00 52.00 L 16.00 49.00 L 16.00 39.00 L 22.00 39.00 L 26.00 45.00 L 43.00 32.00 L 34.00 13.00 L 19.00 12.00 L 20.00 2.00 Z",
      "province": "SIAM",
      "rootTerritory": "SIAM",
      "viewBox": "0 0 43 52",
      "unitSlots": [
        {
          "name": "main",
          "x": 20.37,
          "y": 24.42,
          "territory": "SIAM",
          "arrowReceiver": {
            "x": 38.37,
            "y": 42.42
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 20.37,
          "y": 24.42,
          "territory": "SIAM",
          "arrowReceiver": {
            "x": 38.37,
            "y": 42.42
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "BOR_2": {
    "territory": "BOR_2",
    "unitSlotName": "main",
    "province": "BOR_2",
    "provinceMapData": {
      "abbr": "CEL",
      "type": "Coast",
      "centerPos": {
        "x": 30.88,
        "y": 19.16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 27.5,
          "y": 17.5,
          "text": "Celebes"
        }
      ],
      "width": 55,
      "height": 35,
      "x": 396,
      "y": 391,
      "playable": true,
      "path": "M 55.00 4.00 L 47.00 0.00 L 42.00 5.00 L 33.00 5.00 L 23.00 15.00 L 2.00 17.00 L 0.00 24.00 L 10.00 33.00 L 18.00 31.00 L 24.00 34.00 L 32.00 25.00 L 34.00 34.00 L 42.00 34.00 L 47.00 30.00 L 47.00 19.00 Z",
      "province": "BOR_2",
      "rootTerritory": "BOR_2",
      "viewBox": "0 0 55 35",
      "unitSlots": [
        {
          "name": "main",
          "x": 30.88,
          "y": 19.16,
          "territory": "BOR_2",
          "arrowReceiver": {
            "x": 48.88,
            "y": 37.16
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30.88,
          "y": 19.16,
          "territory": "BOR_2",
          "arrowReceiver": {
            "x": 48.88,
            "y": 37.16
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Celebes": {
    "territory": "BOR_2",
    "unitSlotName": "main",
    "province": "BOR_2",
    "provinceMapData": {
      "abbr": "CEL",
      "type": "Coast",
      "centerPos": {
        "x": 30.88,
        "y": 19.16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 27.5,
          "y": 17.5,
          "text": "Celebes"
        }
      ],
      "width": 55,
      "height": 35,
      "x": 396,
      "y": 391,
      "playable": true,
      "path": "M 55.00 4.00 L 47.00 0.00 L 42.00 5.00 L 33.00 5.00 L 23.00 15.00 L 2.00 17.00 L 0.00 24.00 L 10.00 33.00 L 18.00 31.00 L 24.00 34.00 L 32.00 25.00 L 34.00 34.00 L 42.00 34.00 L 47.00 30.00 L 47.00 19.00 Z",
      "province": "BOR_2",
      "rootTerritory": "BOR_2",
      "viewBox": "0 0 55 35",
      "unitSlots": [
        {
          "name": "main",
          "x": 30.88,
          "y": 19.16,
          "territory": "BOR_2",
          "arrowReceiver": {
            "x": 48.88,
            "y": 37.16
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30.88,
          "y": 19.16,
          "territory": "BOR_2",
          "arrowReceiver": {
            "x": 48.88,
            "y": 37.16
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "YEL": {
    "territory": "YEL",
    "unitSlotName": "main",
    "province": "YEL",
    "provinceMapData": {
      "abbr": "YEL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 15.5,
          "y": 22.5,
          "text": "Yellow Sea"
        }
      ],
      "width": 31,
      "height": 45,
      "x": 428,
      "y": 166,
      "playable": true,
      "path": "M 12.00 0.00 L 5.00 8.00 L 7.00 14.00 L 0.00 32.00 L 21.00 45.00 L 31.00 28.00 L 23.00 6.00 Z",
      "province": "YEL",
      "rootTerritory": "YEL",
      "viewBox": "0 0 31 45",
      "unitSlots": [
        {
          "name": "main",
          "x": 15.65,
          "y": 24.15,
          "territory": "YEL",
          "arrowReceiver": {
            "x": 33.65,
            "y": 42.15
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 15.65,
          "y": 24.15,
          "territory": "YEL",
          "arrowReceiver": {
            "x": 33.65,
            "y": 42.15
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Yellow Sea": {
    "territory": "YEL",
    "unitSlotName": "main",
    "province": "YEL",
    "provinceMapData": {
      "abbr": "YEL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 15.5,
          "y": 22.5,
          "text": "Yellow Sea"
        }
      ],
      "width": 31,
      "height": 45,
      "x": 428,
      "y": 166,
      "playable": true,
      "path": "M 12.00 0.00 L 5.00 8.00 L 7.00 14.00 L 0.00 32.00 L 21.00 45.00 L 31.00 28.00 L 23.00 6.00 Z",
      "province": "YEL",
      "rootTerritory": "YEL",
      "viewBox": "0 0 31 45",
      "unitSlots": [
        {
          "name": "main",
          "x": 15.65,
          "y": 24.15,
          "territory": "YEL",
          "arrowReceiver": {
            "x": 33.65,
            "y": 42.15
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 15.65,
          "y": 24.15,
          "territory": "YEL",
          "arrowReceiver": {
            "x": 33.65,
            "y": 42.15
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "BEL": {
    "territory": "BEL",
    "unitSlotName": "main",
    "province": "BEL",
    "provinceMapData": {
      "abbr": "BEL",
      "type": "Coast",
      "centerPos": {
        "x": 21.72,
        "y": 19.98
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 25.5,
          "y": 18,
          "text": "Beluchistan"
        }
      ],
      "width": 51,
      "height": 36,
      "x": 153,
      "y": 226,
      "playable": true,
      "path": "M 0.00 1.00 L 10.00 15.00 L 3.00 31.00 L 14.00 35.00 L 32.00 36.00 L 38.00 23.00 L 51.00 15.00 L 50.00 12.00 L 40.00 15.00 L 29.00 12.00 L 25.00 18.00 L 21.00 15.00 L 22.00 6.00 Z",
      "province": "BEL",
      "rootTerritory": "BEL",
      "viewBox": "0 0 51 36",
      "unitSlots": [
        {
          "name": "main",
          "x": 21.72,
          "y": 19.98,
          "territory": "BEL",
          "arrowReceiver": {
            "x": 39.72,
            "y": 37.98
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 21.72,
          "y": 19.98,
          "territory": "BEL",
          "arrowReceiver": {
            "x": 39.72,
            "y": 37.98
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Beluchistan": {
    "territory": "BEL",
    "unitSlotName": "main",
    "province": "BEL",
    "provinceMapData": {
      "abbr": "BEL",
      "type": "Coast",
      "centerPos": {
        "x": 21.72,
        "y": 19.98
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 25.5,
          "y": 18,
          "text": "Beluchistan"
        }
      ],
      "width": 51,
      "height": 36,
      "x": 153,
      "y": 226,
      "playable": true,
      "path": "M 0.00 1.00 L 10.00 15.00 L 3.00 31.00 L 14.00 35.00 L 32.00 36.00 L 38.00 23.00 L 51.00 15.00 L 50.00 12.00 L 40.00 15.00 L 29.00 12.00 L 25.00 18.00 L 21.00 15.00 L 22.00 6.00 Z",
      "province": "BEL",
      "rootTerritory": "BEL",
      "viewBox": "0 0 51 36",
      "unitSlots": [
        {
          "name": "main",
          "x": 21.72,
          "y": 19.98,
          "territory": "BEL",
          "arrowReceiver": {
            "x": 39.72,
            "y": 37.98
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 21.72,
          "y": 19.98,
          "territory": "BEL",
          "arrowReceiver": {
            "x": 39.72,
            "y": 37.98
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "NEW": {
    "territory": "NEW",
    "unitSlotName": "main",
    "province": "NEW",
    "provinceMapData": {
      "abbr": "NEW",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 26.5,
          "y": 18,
          "text": "New Guinea"
        }
      ],
      "width": 53,
      "height": 36,
      "x": 517,
      "y": 382,
      "playable": true,
      "path": "M 0.00 6.00 L 2.00 12.00 L 9.00 11.00 L 8.00 20.00 L 26.00 22.00 L 31.00 18.00 L 37.00 22.00 L 41.00 33.00 L 53.00 35.00 L 53.00 15.00 L 35.00 13.00 L 36.00 10.00 L 52.00 11.00 L 52.00 0.00 L 37.00 0.00 L 25.00 16.00 L 16.00 13.00 L 17.00 2.00 Z",
      "province": "NEW",
      "rootTerritory": "NEW",
      "viewBox": "0 0 53 36",
      "unitSlots": [
        {
          "name": "main",
          "x": 34.05,
          "y": 15.19,
          "territory": "NEW",
          "arrowReceiver": {
            "x": 52.05,
            "y": 33.19
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34.05,
          "y": 15.19,
          "territory": "NEW",
          "arrowReceiver": {
            "x": 52.05,
            "y": 33.19
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "New Guinea": {
    "territory": "NEW",
    "unitSlotName": "main",
    "province": "NEW",
    "provinceMapData": {
      "abbr": "NEW",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 26.5,
          "y": 18,
          "text": "New Guinea"
        }
      ],
      "width": 53,
      "height": 36,
      "x": 517,
      "y": 382,
      "playable": true,
      "path": "M 0.00 6.00 L 2.00 12.00 L 9.00 11.00 L 8.00 20.00 L 26.00 22.00 L 31.00 18.00 L 37.00 22.00 L 41.00 33.00 L 53.00 35.00 L 53.00 15.00 L 35.00 13.00 L 36.00 10.00 L 52.00 11.00 L 52.00 0.00 L 37.00 0.00 L 25.00 16.00 L 16.00 13.00 L 17.00 2.00 Z",
      "province": "NEW",
      "rootTerritory": "NEW",
      "viewBox": "0 0 53 36",
      "unitSlots": [
        {
          "name": "main",
          "x": 34.05,
          "y": 15.19,
          "territory": "NEW",
          "arrowReceiver": {
            "x": 52.05,
            "y": 33.19
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34.05,
          "y": 15.19,
          "territory": "NEW",
          "arrowReceiver": {
            "x": 52.05,
            "y": 33.19
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "PUN": {
    "territory": "PUN",
    "unitSlotName": "main",
    "province": "PUN",
    "provinceMapData": {
      "abbr": "PUN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20,
          "y": 17.5,
          "text": "Punjab"
        }
      ],
      "width": 40,
      "height": 35,
      "x": 204,
      "y": 211,
      "playable": true,
      "path": "M 21.00 0.00 L 2.00 20.00 L 2.00 35.00 L 40.00 30.00 Z",
      "province": "PUN",
      "rootTerritory": "PUN",
      "viewBox": "0 0 40 35",
      "unitSlots": [
        {
          "name": "main",
          "x": 18.21,
          "y": 20.31,
          "territory": "PUN",
          "arrowReceiver": {
            "x": 36.21,
            "y": 38.31
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 18.21,
          "y": 20.31,
          "territory": "PUN",
          "arrowReceiver": {
            "x": 36.21,
            "y": 38.31
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Punjab": {
    "territory": "PUN",
    "unitSlotName": "main",
    "province": "PUN",
    "provinceMapData": {
      "abbr": "PUN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20,
          "y": 17.5,
          "text": "Punjab"
        }
      ],
      "width": 40,
      "height": 35,
      "x": 204,
      "y": 211,
      "playable": true,
      "path": "M 21.00 0.00 L 2.00 20.00 L 2.00 35.00 L 40.00 30.00 Z",
      "province": "PUN",
      "rootTerritory": "PUN",
      "viewBox": "0 0 40 35",
      "unitSlots": [
        {
          "name": "main",
          "x": 18.21,
          "y": 20.31,
          "territory": "PUN",
          "arrowReceiver": {
            "x": 36.21,
            "y": 38.31
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 18.21,
          "y": 20.31,
          "territory": "PUN",
          "arrowReceiver": {
            "x": 36.21,
            "y": 38.31
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_62": {
    "territory": "REGION_62",
    "unitSlotName": "main",
    "province": "REGION_62",
    "provinceMapData": {
      "abbr": "REG",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 14,
          "y": 19.5,
          "text": "REGION_62"
        }
      ],
      "width": 28,
      "height": 39,
      "x": 571,
      "y": 380,
      "playable": true,
      "path": "M 1.00 0.00 L 0.00 37.00 L 4.00 39.00 L 15.00 24.00 L 22.00 30.00 L 28.00 29.00 L 28.00 13.00 L 18.00 11.00 L 12.00 3.00 Z",
      "province": "REGION_62",
      "rootTerritory": "REGION_62",
      "viewBox": "0 0 28 39",
      "unitSlots": [
        {
          "name": "main",
          "x": 11.96,
          "y": 18.59,
          "territory": "REGION_62",
          "arrowReceiver": {
            "x": 29.96,
            "y": 36.59
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 11.96,
          "y": 18.59,
          "territory": "REGION_62",
          "arrowReceiver": {
            "x": 29.96,
            "y": 36.59
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_63": {
    "territory": "REGION_63",
    "unitSlotName": "main",
    "province": "REGION_63",
    "provinceMapData": {
      "abbr": "REG",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 17.5,
          "y": 12.5,
          "text": "REGION_63"
        }
      ],
      "width": 35,
      "height": 25,
      "x": 45,
      "y": 294,
      "playable": true,
      "path": "M 2.00 1.00 L 0.00 8.00 L 8.00 24.00 L 33.00 22.00 L 35.00 10.00 L 31.00 3.00 Z",
      "province": "REGION_63",
      "rootTerritory": "REGION_63",
      "viewBox": "0 0 35 25",
      "unitSlots": [
        {
          "name": "main",
          "x": 17.82,
          "y": 12.51,
          "territory": "REGION_63",
          "arrowReceiver": {
            "x": 35.82,
            "y": 30.51
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 17.82,
          "y": 12.51,
          "territory": "REGION_63",
          "arrowReceiver": {
            "x": 35.82,
            "y": 30.51
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_64": {
    "territory": "REGION_64",
    "unitSlotName": "main",
    "province": "REGION_64",
    "provinceMapData": {
      "abbr": "REG",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 15.5,
          "y": 25,
          "text": "REGION_64"
        }
      ],
      "width": 31,
      "height": 50,
      "x": 483,
      "y": 0,
      "playable": true,
      "path": "M 3.00 0.00 L 0.00 10.00 L 8.00 33.00 L 20.00 47.00 L 29.00 50.00 L 31.00 29.00 L 10.00 18.00 L 6.00 7.00 L 11.00 0.00 Z",
      "province": "REGION_64",
      "rootTerritory": "REGION_64",
      "viewBox": "0 0 31 50",
      "unitSlots": [
        {
          "name": "main",
          "x": 15.91,
          "y": 27.98,
          "territory": "REGION_64",
          "arrowReceiver": {
            "x": 33.91,
            "y": 45.98
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 15.91,
          "y": 27.98,
          "territory": "REGION_64",
          "arrowReceiver": {
            "x": 33.91,
            "y": 45.98
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "GOS": {
    "territory": "GOS",
    "unitSlotName": "main",
    "province": "GOS",
    "provinceMapData": {
      "abbr": "GUL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 13,
          "y": 19.5,
          "text": "Gulf of Siam"
        }
      ],
      "width": 26,
      "height": 39,
      "x": 344,
      "y": 351,
      "playable": true,
      "path": "M 7.00 1.00 L 0.00 29.00 L 13.00 31.00 L 23.00 39.00 L 26.00 31.00 L 23.00 10.00 L 16.00 2.00 Z",
      "province": "GOS",
      "rootTerritory": "GOS",
      "viewBox": "0 0 26 39",
      "unitSlots": [
        {
          "name": "main",
          "x": 14.28,
          "y": 18.55,
          "territory": "GOS",
          "arrowReceiver": {
            "x": 32.28,
            "y": 36.55
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 14.28,
          "y": 18.55,
          "territory": "GOS",
          "arrowReceiver": {
            "x": 32.28,
            "y": 36.55
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Gulf of Siam": {
    "territory": "GOS",
    "unitSlotName": "main",
    "province": "GOS",
    "provinceMapData": {
      "abbr": "GUL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 13,
          "y": 19.5,
          "text": "Gulf of Siam"
        }
      ],
      "width": 26,
      "height": 39,
      "x": 344,
      "y": 351,
      "playable": true,
      "path": "M 7.00 1.00 L 0.00 29.00 L 13.00 31.00 L 23.00 39.00 L 26.00 31.00 L 23.00 10.00 L 16.00 2.00 Z",
      "province": "GOS",
      "rootTerritory": "GOS",
      "viewBox": "0 0 26 39",
      "unitSlots": [
        {
          "name": "main",
          "x": 14.28,
          "y": 18.55,
          "territory": "GOS",
          "arrowReceiver": {
            "x": 32.28,
            "y": 36.55
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 14.28,
          "y": 18.55,
          "territory": "GOS",
          "arrowReceiver": {
            "x": 32.28,
            "y": 36.55
          }
        }
      },
      "texture": {
        "texture": "#96B2B2",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_66": {
    "territory": "REGION_66",
    "unitSlotName": "main",
    "province": "REGION_66",
    "provinceMapData": {
      "abbr": "REG",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 23.5,
          "y": 12.5,
          "text": "REGION_66"
        }
      ],
      "width": 47,
      "height": 25,
      "x": 242,
      "y": 241,
      "playable": true,
      "path": "M 0.00 4.00 L 1.00 10.00 L 41.00 25.00 L 47.00 21.00 L 46.00 13.00 L 36.00 14.00 L 29.00 8.00 L 5.00 0.00 Z",
      "province": "REGION_66",
      "rootTerritory": "REGION_66",
      "viewBox": "0 0 47 25",
      "unitSlots": [
        {
          "name": "main",
          "x": 23.28,
          "y": 12.69,
          "territory": "REGION_66",
          "arrowReceiver": {
            "x": 41.28,
            "y": 30.69
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 23.28,
          "y": 12.69,
          "territory": "REGION_66",
          "arrowReceiver": {
            "x": 41.28,
            "y": 30.69
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "SYR": {
    "territory": "SYR",
    "unitSlotName": "main",
    "province": "SYR",
    "provinceMapData": {
      "abbr": "SYR",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 16,
          "y": 12,
          "text": "Syria"
        }
      ],
      "width": 32,
      "height": 24,
      "x": 39,
      "y": 155,
      "playable": true,
      "path": "M 0.00 12.00 L 3.00 21.00 L 13.00 24.00 L 32.00 20.00 L 28.00 2.00 L 13.00 0.00 Z",
      "province": "SYR",
      "rootTerritory": "SYR",
      "viewBox": "0 0 32 24",
      "unitSlots": [
        {
          "name": "main",
          "x": 16.79,
          "y": 12.62,
          "territory": "SYR",
          "arrowReceiver": {
            "x": 34.79,
            "y": 30.62
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 16.79,
          "y": 12.62,
          "territory": "SYR",
          "arrowReceiver": {
            "x": 34.79,
            "y": 30.62
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Syria": {
    "territory": "SYR",
    "unitSlotName": "main",
    "province": "SYR",
    "provinceMapData": {
      "abbr": "SYR",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 16,
          "y": 12,
          "text": "Syria"
        }
      ],
      "width": 32,
      "height": 24,
      "x": 39,
      "y": 155,
      "playable": true,
      "path": "M 0.00 12.00 L 3.00 21.00 L 13.00 24.00 L 32.00 20.00 L 28.00 2.00 L 13.00 0.00 Z",
      "province": "SYR",
      "rootTerritory": "SYR",
      "viewBox": "0 0 32 24",
      "unitSlots": [
        {
          "name": "main",
          "x": 16.79,
          "y": 12.62,
          "territory": "SYR",
          "arrowReceiver": {
            "x": 34.79,
            "y": 30.62
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 16.79,
          "y": 12.62,
          "territory": "SYR",
          "arrowReceiver": {
            "x": 34.79,
            "y": 30.62
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_69": {
    "territory": "REGION_69",
    "unitSlotName": "main",
    "province": "REGION_69",
    "provinceMapData": {
      "abbr": "REG",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 19.5,
          "y": 17,
          "text": "REGION_69"
        }
      ],
      "width": 39,
      "height": 34,
      "x": 319,
      "y": 394,
      "playable": true,
      "path": "M 0.00 1.00 L 11.00 12.00 L 20.00 34.00 L 24.00 31.00 L 39.00 32.00 L 11.00 3.00 Z",
      "province": "REGION_69",
      "rootTerritory": "REGION_69",
      "viewBox": "0 0 39 34",
      "unitSlots": [
        {
          "name": "main",
          "x": 19.43,
          "y": 18.83,
          "territory": "REGION_69",
          "arrowReceiver": {
            "x": 37.43,
            "y": 36.83
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 19.43,
          "y": 18.83,
          "territory": "REGION_69",
          "arrowReceiver": {
            "x": 37.43,
            "y": 36.83
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "SUM": {
    "territory": "SUM",
    "unitSlotName": "main",
    "province": "SUM",
    "provinceMapData": {
      "abbr": "SUM",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 17,
          "y": 11,
          "text": "Sumatra"
        }
      ],
      "width": 34,
      "height": 22,
      "x": 344,
      "y": 428,
      "playable": true,
      "path": "M 0.00 3.00 L 26.00 22.00 L 34.00 19.00 L 33.00 9.00 L 23.00 2.00 Z",
      "province": "SUM",
      "rootTerritory": "SUM",
      "viewBox": "0 0 34 22",
      "unitSlots": [
        {
          "name": "main",
          "x": 19.96,
          "y": 10.34,
          "territory": "SUM",
          "arrowReceiver": {
            "x": 37.96,
            "y": 28.34
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 19.96,
          "y": 10.34,
          "territory": "SUM",
          "arrowReceiver": {
            "x": 37.96,
            "y": 28.34
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "Sumatra": {
    "territory": "SUM",
    "unitSlotName": "main",
    "province": "SUM",
    "provinceMapData": {
      "abbr": "SUM",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 17,
          "y": 11,
          "text": "Sumatra"
        }
      ],
      "width": 34,
      "height": 22,
      "x": 344,
      "y": 428,
      "playable": true,
      "path": "M 0.00 3.00 L 26.00 22.00 L 34.00 19.00 L 33.00 9.00 L 23.00 2.00 Z",
      "province": "SUM",
      "rootTerritory": "SUM",
      "viewBox": "0 0 34 22",
      "unitSlots": [
        {
          "name": "main",
          "x": 19.96,
          "y": 10.34,
          "territory": "SUM",
          "arrowReceiver": {
            "x": 37.96,
            "y": 28.34
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 19.96,
          "y": 10.34,
          "territory": "SUM",
          "arrowReceiver": {
            "x": 37.96,
            "y": 28.34
          }
        }
      },
      "texture": {
        "texture": "#F9F2E6",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  }
} as unknown as MapVariant["territoryMap"];

const webdipNameToTerritory: MapVariant["webdipNameToTerritory"] = {
  "Central Pacific Ocean": "CPO",
  "Madras": "MAD",
  "Java": "JAV",
  "North Pacific Ocean": "NPO",
  "Kiushu": "KIU",
  "Siberia": "SIB",
  "Arabia": "ARA",
  "Ara 2": "ARA_2",
  "Irkutsk": "IRK",
  "South China Sea": "SCS",
  "Mongolia": "MON",
  "Moscow": "MOS",
  "Banda Sea": "BAN",
  "Tobolsk": "TOB",
  "Bay of Bengal": "BOB",
  "Ukraine": "ODE",
  "Celebes Sea": "CSE",
  "Turkestan": "TUR",
  "Arabian Sea": "ASE",
  "Kirghiz": "KIR",
  "Canton": "CAN",
  "Persia": "PER",
  "Gobi Desert": "GOB",
  "REGION_25": "REGION_25",
  "Sea of Okhotsk": "SOO",
  "Yakutsk": "OKH",
  "Shanghai": "SHA",
  "Tibet": "TIB",
  "Amur": "AMU",
  "Borneo": "BOR",
  "Peking": "PEK",
  "Bal": "BAL",
  "Calcutta": "CAL",
  "Sea of Japan": "SOJ",
  "Afghanistan": "AFG",
  "Manchuria": "MAN",
  "Bombay": "BOM",
  "Sinkiang": "SIN",
  "Gulf of Martaban": "GOM",
  "Burma": "BUR",
  "East China Sea": "ECS",
  "Sunda Sea": "SUN",
  "Persian Gulf": "PGU",
  "Delhi": "DEL",
  "Anatolia": "ANG",
  "Black Sea": "BLA",
  "Caspian Sea": "REGION_48",
  "Egypt": "EGY",
  "Mad 2": "MAD_2",
  "REGION_51": "REGION_51",
  "Bengal": "BEN",
  "Red Sea": "RED",
  "Mesopotamia": "MES",
  "Mak": "MAK",
  "Siam": "SIAM",
  "Celebes": "BOR_2",
  "Yellow Sea": "YEL",
  "Beluchistan": "BEL",
  "New Guinea": "NEW",
  "Punjab": "PUN",
  "REGION_62": "REGION_62",
  "REGION_63": "REGION_63",
  "REGION_64": "REGION_64",
  "Gulf of Siam": "GOS",
  "REGION_66": "REGION_66",
  "Syria": "SYR",
  "REGION_69": "REGION_69",
  "Sumatra": "SUM"
};

const territoryToWebdipName: MapVariant["territoryToWebdipName"] = {
  "CPO": "Central Pacific Ocean",
  "MAD": "Madras",
  "JAV": "Java",
  "NPO": "North Pacific Ocean",
  "KIU": "Kiushu",
  "SIB": "Siberia",
  "ARA": "Arabia",
  "ARA_2": "Ara 2",
  "IRK": "Irkutsk",
  "SCS": "South China Sea",
  "MON": "Mongolia",
  "MOS": "Moscow",
  "BAN": "Banda Sea",
  "TOB": "Tobolsk",
  "BOB": "Bay of Bengal",
  "ODE": "Ukraine",
  "CSE": "Celebes Sea",
  "TUR": "Turkestan",
  "ASE": "Arabian Sea",
  "KIR": "Kirghiz",
  "CAN": "Canton",
  "PER": "Persia",
  "GOB": "Gobi Desert",
  "REGION_25": "REGION_25",
  "SOO": "Sea of Okhotsk",
  "OKH": "Yakutsk",
  "SHA": "Shanghai",
  "TIB": "Tibet",
  "AMU": "Amur",
  "BOR": "Borneo",
  "PEK": "Peking",
  "BAL": "Bal",
  "CAL": "Calcutta",
  "SOJ": "Sea of Japan",
  "AFG": "Afghanistan",
  "MAN": "Manchuria",
  "BOM": "Bombay",
  "SIN": "Sinkiang",
  "GOM": "Gulf of Martaban",
  "BUR": "Burma",
  "ECS": "East China Sea",
  "SUN": "Sunda Sea",
  "PGU": "Persian Gulf",
  "DEL": "Delhi",
  "ANG": "Anatolia",
  "BLA": "Black Sea",
  "REGION_48": "Caspian Sea",
  "EGY": "Egypt",
  "MAD_2": "Mad 2",
  "REGION_51": "REGION_51",
  "BEN": "Bengal",
  "RED": "Red Sea",
  "MES": "Mesopotamia",
  "MAK": "Mak",
  "SIAM": "Siam",
  "BOR_2": "Celebes",
  "YEL": "Yellow Sea",
  "BEL": "Beluchistan",
  "NEW": "New Guinea",
  "PUN": "Punjab",
  "REGION_62": "REGION_62",
  "REGION_63": "REGION_63",
  "REGION_64": "REGION_64",
  "GOS": "Gulf of Siam",
  "REGION_66": "REGION_66",
  "SYR": "Syria",
  "REGION_69": "REGION_69",
  "SUM": "Sumatra"
};

const coastData: MapVariant["coastData"] = {};

const countryMap: MapVariant["countryMap"] = {
  "Britain": Country.BRITAIN,
  "China": "China" as Country,
  "France": Country.FRANCE,
  "Holland": Country.HOLLAND,
  "Japan": "Japan" as Country,
  "Russia": Country.RUSSIA,
  "Turkey": Country.TURKEY,
};

const countryIDMap: MapVariant["countryIDMap"] = {
  1: Country.BRITAIN,
  2: "China" as Country,
  3: Country.FRANCE,
  4: Country.HOLLAND,
  5: "Japan" as Country,
  6: Country.RUSSIA,
  7: Country.TURKEY,
};

const worldmapMapVariant: MapVariant = {
  key: "worldmap",
  name: "WorldMap",
  mapID: 24,
  variantIDs: [24],
  width: 600,
  height: 500,
  provincesMapData,
  territoryMap,
  webdipNameToTerritory,
  territoryToWebdipName,
  coastData,
  countryMap,
  countryIDMap,
  textures: {
    capturableLand: {
      href: capturableLandTexture,
      width: 1546,
      height: 1384,
      patternWidth: 1546,
      patternHeight: 1384,
    },
    sea: {
      href: seaTexture,
      width: 1966,
      height: 1615,
      patternWidth: 1546,
      patternHeight: 1384,
    },
  },
  provincesToRenderLast: [],
  boardMap: WDBoardMap,
};

export default worldmapMapVariant;
